import { defineMessage } from 'react-intl';

export default {
    'errors.default': defineMessage({
        id: 'errors.default',
        defaultMessage: 'Ha ocurrido un error'
    }),
    'tipoFormularioSecuencia.errors.checklist_sin_vehiculo': defineMessage({
        id: 'tipoFormularioSecuencia.errors.checklist_sin_vehiculo',
        defaultMessage: 'Los checklists de la secuencia deben ser de tipos que se completan sobre un vehículo y estar activos.'
    }),
    'formularioSecuenciaIntento.errors.estado_movil_no_coincide': defineMessage({
        id: 'formularioSecuenciaIntento.errors.estado_movil_no_coincide',
        defaultMessage: 'El vehículo no está en el estado requerido para iniciar esta secuencia.'
    }),
    'formularioSecuenciaIntento.errors.intento_ya_en_curso': defineMessage({
        id: 'formularioSecuenciaIntento.errors.intento_ya_en_curso',
        defaultMessage: 'El vehículo ya tiene un intento de validación en curso para esta secuencia.'
    }),
    'formularioSecuenciaIntento.errors.movil_en_otra_secuencia': defineMessage({
        id: 'formularioSecuenciaIntento.errors.movil_en_otra_secuencia',
        defaultMessage: 'El vehículo ya está en otra secuencia en curso: un vehículo solo puede estar en una secuencia a la vez.'
    }),
    'formularioSecuenciaIntento.errors.intentos_agotados': defineMessage({
        id: 'formularioSecuenciaIntento.errors.intentos_agotados',
        defaultMessage: 'El vehículo agotó la cantidad máxima de intentos configurada para esta secuencia.'
    }),
    'tipoFormularioSecuencia.errors.estado_no_activo': defineMessage({
        id: 'tipoFormularioSecuencia.errors.estado_no_activo',
        defaultMessage: 'Los estados del encadenamiento deben ser estados activos de vehículo.'
    }),
    'tipoFormularioSecuencia.errors.lote_sin_vehiculos': defineMessage({
        id: 'tipoFormularioSecuencia.errors.lote_sin_vehiculos',
        defaultMessage: 'Elegí al menos un vehículo, o "Todos los disponibles".'
    }),
    'tipoFormularioSecuencia.errors.lote_demasiados_vehiculos': defineMessage({
        id: 'tipoFormularioSecuencia.errors.lote_demasiados_vehiculos',
        defaultMessage: 'Se pueden iniciar hasta 2000 vehículos por vez.'
    }),
    'tickets.errors.servicio_principal_solo_correctivos': defineMessage({
        id: 'tickets.errors.servicio_principal_solo_correctivos',
        defaultMessage: 'Solo se puede modificar el servicio principal de tickets correctivos.'
    }),
    'tickets.errors.servicio_principal_con_presupuesto': defineMessage({
        id: 'tickets.errors.servicio_principal_con_presupuesto',
        defaultMessage: 'No se puede modificar el servicio principal cuando el ticket tiene presupuesto cargado.'
    }),
    'tickets.errors.tarea_no_pertenece_al_servicio': defineMessage({
        id: 'tickets.errors.tarea_no_pertenece_al_servicio',
        defaultMessage: 'La tarea seleccionada no pertenece al servicio indicado.'
    }),
    'tickets.errors.item_no_pertenece_al_servicio': defineMessage({
        id: 'tickets.errors.item_no_pertenece_al_servicio',
        defaultMessage: 'El ítem seleccionado no pertenece al servicio indicado.'
    }),
    'tickets.errors.proveedor_no_brinda_el_servicio': defineMessage({
        id: 'tickets.errors.proveedor_no_brinda_el_servicio',
        defaultMessage: 'El proveedor seleccionado no brinda el servicio indicado.'
    }),
    'errors.contacte_al_administrador': defineMessage({
        id: 'errors.contacte_al_administrador',
        defaultMessage: 'Contacte al administrador.'
    }),
    'login.errors.usuario_no_existe': defineMessage({
        id: 'login.errors.usuario_no_existe',
        defaultMessage: 'El usuario no existe.'
    }),
    'login.errors.contraseña_incorrecta': defineMessage({
        id: 'login.errors.contraseña_incorrecta',
        defaultMessage: 'La contraseña es incorrecta.'
    }),
    'login.errors.activar_cuenta': defineMessage({
        id: 'login.errors.activar_cuenta',
        defaultMessage: 'Debe activar su cuenta.'
    }),
    'forgotPassword.errors.email_ingresado_no_corresponde_usuario_activo': defineMessage({
        id: 'forgotPassword.errors.email_ingresado_no_corresponde_usuario_activo',
        defaultMessage: 'El email ingresado no corresponde a un usuario activo.'
    }),
    'forgotPassword.errors.debe_activar_cuenta': defineMessage({
        id: 'forgotPassword.errors.debe_activar_cuenta',
        defaultMessage: 'Debe activar su cuenta.'
    }),
    'changePassword.errors.contrasenia_debe_ser_diferente_anteriores': defineMessage({
        id: 'changePassword.errors.contrasenia_debe_ser_diferente_anteriores',
        defaultMessage: 'La contraseña debe ser diferente a las anteriores.'
    }),
    'changePassword.errors.contrasenia_nueva_diferente_actual': defineMessage({
        id: 'changePassword.errors.contrasenia_nueva_diferente_actual',
        defaultMessage: 'La contraseña nueva debe ser diferente a la actual.'
    }),
    'changePassword.errors.contrasenia_actual_incorrecta': defineMessage({
        id: 'changePassword.errors.contrasenia_actual_incorrecta',
        defaultMessage: 'La contraseña actual es incorrecta.'
    }),
    'changePassword.errors.sesion_no_corresponde_usuario_activo': defineMessage({
        id: 'changePassword.errors.sesion_no_corresponde_usuario_activo',
        defaultMessage: 'La sesión no corresponde a un usuario activo.'
    }),
    'changePassword.errors.contrasenias_ingresadas_no_coinciden': defineMessage({
        id: 'changePassword.errors.contrasenias_ingresadas_no_coinciden',
        defaultMessage: 'Las contraseñas ingresadas no coinciden.'
    }),
    'azureCallback.errors.faltan_parametros_validar': defineMessage({
        id: 'azureCallback.errors.faltan_parametros_validar',
        defaultMessage: 'Faltan parámetros para validar su cuenta'
    }),
    'azureCallback.errors.token_no_encontrado_servidor': defineMessage({
        id: 'azureCallback.errors.token_no_encontrado_servidor',
        defaultMessage: 'Error: token no encontrado en respuesta del servidor'
    }),
    'azureCallback.errors.pedir_token_usuario': defineMessage({
        id: 'azureCallback.errors.pedir_token_usuario',
        defaultMessage: 'Error: error al pedir el token del usuario'
    }),
    'azureCallback.errors.lado_del_servidor': defineMessage({
        id: 'azureCallback.errors.lado_del_servidor',
        defaultMessage: 'Error: error del lado del servidor'
    }),
    'internalLogin.errors.acceso_denegado': defineMessage({
        id: 'internalLogin.errors.acceso_denegado',
        defaultMessage: 'Acceso denegado.'
    }),
    'recoverPassword.errors.clave_activacion_invalida': defineMessage({
        id: 'recoverPassword.errors.clave_activacion_invalida',
        defaultMessage: 'Clave de activación inválida.'
    }),
    'recoverPassword.errors.clave_expiro': defineMessage({
        id: 'recoverPassword.errors.clave_expiro',
        defaultMessage: 'La clave de activación expiró.'
    }),
    'recoverPassword.errors.contrasenia_diferente_anteriores': defineMessage({
        id: 'recoverPassword.errors.contrasenia_diferente_anteriores',
        defaultMessage: 'La contraseña debe ser diferente a las anteriores.'
    }),
    'recoverPassword.errors.contrasenias_coinciden': defineMessage({
        id: 'recoverPassword.errors.contrasenias_coinciden',
        defaultMessage: 'Las contraseñas ingresadas no coinciden.'
    }),
    'combustiblesAbm.errors.no_pudo_obtener_archivo_modelo': defineMessage({
        id: 'combustiblesAbm.errors.no_pudo_obtener_archivo_modelo',
        defaultMessage: 'No se pudo obtener el archivo modelo'
    }),
    'correctivosAbm.errors.deber_ingresar_al_menos_una_tarea': defineMessage({
        id: 'correctivosAbm.errors.deber_ingresar_al_menos_una_tarea',
        defaultMessage: 'Debe ingresar al menos una tarea.'
    }),
    'facturasAbm.errors.no_puede_dejar_datos_factura_sin_completar': defineMessage({
        id: 'facturasAbm.errors.no_puede_dejar_datos_factura_sin_completar',
        defaultMessage: 'No puede dejar datos de la factura sin completar.'
    }),
    'facturasService.errors.cerrar_no_habilitado': defineMessage({
        id: 'facturasService.errors.cerrar_no_habilitado',
        defaultMessage: 'El cierre de facturas no está habilitado para esta instancia.'
    }),
    'facturasService.errors.adjunto_requerido_para_cerrar': defineMessage({
        id: 'facturasService.errors.adjunto_requerido_para_cerrar',
        defaultMessage: 'Debe adjuntar un documento de la categoría "{categoriaNombre}" antes de cerrar la factura.'
    }),
    'infraccionesService.errors.no_se_pudo_obtener_archivo_modelo': defineMessage({
        id: 'infraccionesService.errors.no_se_pudo_obtener_archivo_modelo',
        defaultMessage: 'No se pudo obtener el archivo modelo'
    }),
    'oTAbm.errors.no_puede_dejar_datos_sin_completar': defineMessage({
        id: 'oTAbm.errors.no_puede_dejar_datos_sin_completar',
        defaultMessage: 'No puede dejar datos sin completar.'
    }),
    'oTAbm.errors.debe_seleccionar_al_menos_un_ticket': defineMessage({
        id: 'oTAbm.errors.debe_seleccionar_al_menos_un_ticket',
        defaultMessage: 'Debe seleccionar al menos un ticket.'
    }),
    'personaController.errors.la_persona_tiene_tickets_pendientes_gestionar_cancelar_los_mismos_para_poder_realizar_el_cambio_de_estado': defineMessage({
        id: 'personaController.errors.la_persona_tiene_tickets_pendientes_gestionar_cancelar_los_mismos_para_poder_realizar_el_cambio_de_estado',
        defaultMessage: 'La persona tiene tickets pendientes, por favor gestionar/cancelar los mismos para poder realizar el cambio de estado de la persona'
    }),
    'personaController.errors.la_persona_tiene_controles_activos_desactivar_los_mismos_para_poder_realizar_cambio_de_estado': defineMessage({
        id: 'personaController.errors.la_persona_tiene_controles_activos_desactivar_los_mismos_para_poder_realizar_cambio_de_estado',
        defaultMessage: 'La persona tiene controles activos, favor desactivar los mismos para poder realizar el cambio de estado de la persona'
    }),
    'personaController.errors.persona_asociada_a_vehiculo': defineMessage({
        id: 'personaController.errors.persona_asociada_a_vehiculo',
        defaultMessage: 'La persona se encuentra asociada a un vehículo. Favor remover la asociación para poder cambiar su estado.'
    }),
    'personaController.errors.no_tiene_permiso_editar_persona': defineMessage({
        id: 'personaController.errors.no_tiene_permiso_editar_persona',
        defaultMessage: 'No tiene permiso para editar esta persona.'
    }),
    'personaController.errors.forzar_sso_sin_proveedor_habilitado': defineMessage({
        id: 'personaController.errors.forzar_sso_sin_proveedor_habilitado',
        defaultMessage: 'No se puede forzar SSO: ningún proveedor SSO (Okta/Azure/Google) está habilitado para este tenant.'
    }),
    'ticketTareasCierre.errors.deber_ingresar_al_menos_una_tarea': defineMessage({
        id: 'ticketTareasCierre.errors.deber_ingresar_al_menos_una_tarea',
        defaultMessage: 'Debe ingresar al menos una tarea.'
    }),
    'personaRepository.errors.direccion_email_existe': defineMessage({
        id: 'personaRepository.errors.direccion_email_existe',
        defaultMessage: 'La dirección de email ingresada ya existe.'
    }),
    'personaRepository.errors.nombre_usuario_existe': defineMessage({
        id: 'personaRepository.errors.nombre_usuario_existe',
        defaultMessage: 'El nombre de Usuario ingresado ya existe.'
    }),
    'personaRepository.errors.llave_ingresada_no_valida': defineMessage({
        id: 'personaRepository.errors.llave_ingresada_no_valida',
        defaultMessage: 'La llave ingresada no es válida.'
    }),
    'almacenController.errors.no_existe_almacen_con_ese_id': defineMessage({
        id: 'almacenController.errors.no_existe_almacen_con_ese_id',
        defaultMessage: 'No existe el almacen con ese id'
    }),
    'almacenRepository.errors.almacen_ya_existe': defineMessage({
        id: 'almacenRepository.errors.almacen_ya_existe',
        defaultMessage: 'El almacen ya existe.'
    }),
    'authController.errors.acceso_denegado': defineMessage({
        id: 'authController.errors.acceso_denegado',
        defaultMessage: 'Acceso denegado.'
    }),
    'authController.errors.usuario_requiere_sso': defineMessage({
        id: 'authController.errors.usuario_requiere_sso',
        defaultMessage: 'Su cuenta requiere inicio de sesión mediante SSO. Utilice el botón correspondiente.'
    }),
    'authController.errors.azure_token_grant_invalido': defineMessage({
        id: 'authController.errors.azure_token_grant_invalido',
        defaultMessage: 'Azure token_grant inválido'
    }),
    'authService.errors.no_se_encontro_una_sesion_activa': defineMessage({
        id: 'authController.errors.no_se_encontro_una_sesion_activa',
        defaultMessage: 'No se encontró una sesión activa.'
    }),
    'authService.errors.contrasenia_debe_tener_una_longitud_entre': defineMessage({
        id: 'authService.errors.contrasenia_debe_tener_una_longitud_entre',
        defaultMessage: 'La contraseña debe tener una longitud entre 8 y 16 caracteres.'
    }),
    'authService.errors.contrasenia_contener_al_menos_una_letra': defineMessage({
        id: 'authService.errors.contrasenia_contener_al_menos_una_letra',
        defaultMessage: 'La contraseña debe contener al menos una letra.'
    }),
    'authService.errors.contrasenia_contener_al_menos_un_numero': defineMessage({
        id: 'authService.errors.contrasenia_contener_al_menos_un_numero',
        defaultMessage: 'La contraseña debe contener al menos un número.'
    }),
    'authService.errors.contrasenia_no_debe_contener_espacios_en_blanco': defineMessage({
        id: 'authService.errors.contrasenia_no_debe_contener_espacios_en_blanco',
        defaultMessage: 'La contraseña no debe contener espacios en blanco.'
    }),
    'authService.errors.contrasenia_no_debe_contener': defineMessage({
        id: 'authService.errors.contrasenia_no_debe_contener',
        defaultMessage: 'La contraseña debe contener sólo letras, números y alguno de los siguientes símbolos . ! ¿ ? @ $ & # % * + - _ ='
    }),
    'authService.errors.contrasenia_no_incluir_nombre_de_usuario': defineMessage({
        id: 'authService.errors.contrasenia_no_incluir_nombre_de_usuario',
        defaultMessage: 'La contraseña no puede incluir el nombre de usuario.'
    }),
    'basesRepository.errors.error_al_ingresar_los_datos': defineMessage({
        id: 'basesRepository.errors.error_al_ingresar_los_datos',
        defaultMessage: 'Error al ingresar los datos'
    }),
    'basesRepository.errors.error_al_ingresar_los_datos': defineMessage({
        id: 'basesRepository.errors.error_al_ingresar_los_datos',
        defaultMessage: 'Error al ingresar los datos'
    }),
    'basesRepository.errors.ya_existe_base_con_ese_nombre': defineMessage({
        id: 'basesRepository.errors.ya_existe_base_con_ese_nombre',
        defaultMessage: 'Ya existe una Base con ese nombre.'
    }),
    'centrosBeneficiosRepository.errors.existe_centro_beneficio_con_ese_nombre_debe_ser_unico': defineMessage({
        id: 'centrosBeneficiosRepository.errors.existe_centro_beneficio_con_ese_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Centro de Beneficio con ese nombre y debe ser unico.'
    }),
    'centrosBeneficiosRepository.errors.no_se_puede_borrar_centro_beneficios_esta_asociada_otro_elemento': defineMessage({
        id: 'centrosBeneficiosRepository.errors.no_se_puede_borrar_centro_beneficios_esta_asociada_otro_elemento',
        defaultMessage: 'No se puede borrar el Centro de Beneficios ya que esta asociada a otro elemento.'
    }),
    'centrosCostosRepository.errors.existe_centro_costo_con_ese_nombre_debe_ser_unico': defineMessage({
        id: 'centrosCostosRepository.errors.existe_centro_costo_con_ese_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Centro de Costo con ese nombre y debe ser unico.'
    }),
    'centrosCostosRepository.errors.no_se_puede_borrar_centro_costos_esta_asociada_otro_elemento': defineMessage({
        id: 'centrosCostosRepository.errors.no_se_puede_borrar_centro_costos_esta_asociada_otro_elemento',
        defaultMessage: 'No se puede borrar el Centro de Costos ya que esta asociada a otro elemento.'
    }),
    'combustibleBanderasRepository.errors.error_al_ingresar_nueva_bandera_combustible': defineMessage({
        id: 'combustibleBanderasRepository.errors.error_al_ingresar_nueva_bandera_combustible',
        defaultMessage: 'Error al ingresar una nueva bandera de combustible'
    }),
    'combustiblesController.errors.contacte_al_administrador': defineMessage({
        id: 'combustiblesController.errors.contacte_al_administrador',
        defaultMessage: 'Contacte al administrador.'
    }),
    'combustiblesController.errors.error_al_subir_el_archivo': defineMessage({
        id: 'combustiblesController.errors.error_al_subir_el_archivo',
        defaultMessage: 'Ocurrió un error al subir el archivo'
    }),
    'combustiblesService.errors.no_pudo_realizar_importacion_fallo_creacion_log': defineMessage({
        id: 'combustiblesService.errors.no_pudo_realizar_importacion_fallo_creacion_log',
        defaultMessage: 'NO se pudo realizar la importación. Falló la creación del log'
    }),
    'combustiblesRepository.errors.el_movil_ingresado_invalido': defineMessage({
        id: 'combustiblesRepository.errors.el_movil_ingresado_invalido',
        defaultMessage: 'El móvil ingresado para la carga es inválido'
    }),
    'combustiblesRepository.errors.carga_combustible_estaduplicada': defineMessage({
        id: 'combustiblesRepository.errors.carga_combustible_estaduplicada',
        defaultMessage: 'La carga de combustible está duplicada'
    }),
    'combustiblesRepository.errors.fecha_hora_de_carga_combustible_invalida': defineMessage({
        id: 'combustiblesRepository.errors.fecha_hora_de_carga_combustible_invalida',
        defaultMessage: 'La Fecha y Hora de carga de combustible es inválida'
    }),
    'combustiblesRepository.errors.odometro_invalido': defineMessage({
        id: 'combustiblesRepository.errors.odometro_invalido',
        defaultMessage: 'El odómetro cargado es inválido para la fecha definida'
    }),
    'combustiblesRepository.errors.error_base_datos': defineMessage({
        id: 'combustiblesRepository.errors.error_base_datos',
        defaultMessage: 'Error en la base de datos'
    }),
    'combustiblesRepository.errors.no_se_pudieron_leer_columnas_del_archivo': defineMessage({
        id: 'combustiblesRepository.errors.no_se_pudieron_leer_columnas_del_archivo',
        defaultMessage: 'No se pudieron leer las columnas del archivo. Contacte al administrador'
    }),
    'combustiblesRepository.errors.la_carga_no_existe': defineMessage({
        id: 'combustiblesRepository.errors.la_carga_no_existe',
        defaultMessage: 'La carga que se quiere actualizar no existe'
    }),
    'combustiblesRepository.errors.carga_combustible_duplicada': defineMessage({
        id: 'combustiblesRepository.errors.carga_combustible_duplicada',
        defaultMessage: 'La carga de combustible está duplicada'
    }),
    'combustiblesRepository.errors.error_buscar_datos': defineMessage({
        id: 'combustiblesRepository.errors.error_buscar_datos',
        defaultMessage: 'Error al buscar los datos'
    }),
    'combustiblesRepository.errors.archivo_no_cumple_formato_de_EDENRED_faltan_columnas': defineMessage({
        id: 'combustiblesRepository.errors.archivo_no_cumple_formato_de_EDENRED_faltan_columnas',
        defaultMessage: 'El archivo no cumple el formato de EDENRED, faltan columnas'
    }),
    'combustiblesRepository.errors.encabezado_no_esta_en_fila_correcta': defineMessage({
        id: 'combustiblesRepository.errors.encabezado_no_esta_en_fila_correcta',
        defaultMessage: 'El encabezado no esta en la fila correcta.'
    }),
    'combustiblesRepository.errors.archivo_no_cumple_formato_YPF_faltan_columnas': defineMessage({
        id: 'combustiblesRepository.errors.archivo_no_cumple_formato_YPF_faltan_columnas',
        defaultMessage: 'El archivo no cumple el formato de YPF, faltan columnas.'
    }),
    'combustiblesRepository.errors.archivo_no_cumple_formato_COPEC_faltan_columnas': defineMessage({
        id: 'combustiblesRepository.errors.archivo_no_cumple_formato_COPEC_faltan_columnas',
        defaultMessage: 'El archivo no cumple el formato de COPEC, faltan columnas.'
    }),
    'combustiblesRepository.basicCardInfo.description.gasto_total_de_combustible': defineMessage({
        id: 'combustiblesRepository.basicCardInfo.description.gasto_total_de_combustible',
        defaultMessage: 'Gasto Total de Combustible'
    }),
    'combustiblesRepository.basicCardInfo.description.total_de_litros_consumidos': defineMessage({
        id: 'combustiblesRepository.basicCardInfo.description.total_de_litros_consumidos',
        defaultMessage: 'Total de Litros Consumidos'
    }),
    'combustiblesRepository.basicCardInfo.description.promedio_de_km_litro': defineMessage({
        id: 'combustiblesRepository.basicCardInfo.description.promedio_de_km_litro',
        defaultMessage: 'Promedio de Km/litro'
    }),
    'combustiblesRepository.basicCardInfo.description.promedio_de_costo_litro': defineMessage({
        id: 'combustiblesRepository.basicCardInfo.description.promedio_de_costo_litro',
        defaultMessage: 'Promedio de Costo/litro'
    }),
    'combustibleTiposRepository.errors.ingresar_nueva_bandera_combustible': defineMessage({
        id: 'combustibleTiposRepository.errors.ingresar_nueva_bandera_combustible',
        defaultMessage: 'Error al ingresar una nueva bandera de combustible'
    }),
    'combustiblesGrid.column.controles.rendimiento_esperado_sin_comprobacion': defineMessage({
        id: 'combustiblesGrid.column.controles.rendimiento_esperado_sin_comprobacion',
        defaultMessage: 'No hay datos del rendimiento esperado '
    }),
    'combustiblesGrid.column.controles.rendimiento_esperado_sin_comprobacion_medidor': defineMessage({
        id: 'combustiblesGrid.column.controles.rendimiento_esperado_sin_comprobacion_medidor',
        defaultMessage: 'No se pudo calcular el rendimiento esperado'
    }),
    'combustiblesGrid.column.controles.rendimiento_esperado_carga_sin_recorrido': defineMessage({
        id: 'combustiblesGrid.column.controles.rendimiento_esperado_carga_sin_recorrido',
        defaultMessage: 'Rendimiento menor al esperado: realizó carga sin recorrer kilómetros'
    }),
    'combustiblesGrid.column.controles.rendimiento_esperado_menor': defineMessage({
        id: 'combustiblesGrid.column.controles.rendimiento_esperado_menor',
        defaultMessage: 'Rendimiento menor al esperado (tolerancia mínima): '
    }),
    'combustiblesGrid.column.controles.rendimiento_esperado_superior': defineMessage({
        id: 'combustiblesGrid.column.controles.rendimiento_esperado_superior',
        defaultMessage: 'Rendimiento superior al esperado (tolerancia máxima): '
    }),
    'combustiblesGrid.column.controles.rendimiento_esperado_valido': defineMessage({
        id: 'combustiblesGrid.column.controles.rendimiento_esperado_valido',
        defaultMessage: 'Rendimiento esperado (tolerancia): '
    }),
    'combustiblesGrid.column.controles.rendimiento_esperado_init': defineMessage({
        id: 'combustiblesGrid.column.controles.rendimiento_esperado_init',
        defaultMessage: ' '
    }),
    'estacionesServicioRepository.errors.error_al_ingresar_los_datos': defineMessage({
        id: 'estacionesServicioRepository.errors.error_al_ingresar_los_datos',
        defaultMessage: 'Error al ingresar los datos'
    }),
    'facturasRepository.errors.la_factura_existe': defineMessage({
        id: 'facturasRepository.errors.la_factura_existe',
        defaultMessage: 'La factura ya existe.'
    }),
    'gerenciadoresRepository.errors.existe_un_gerenciador_con_ese_nombre_debe_ser_unico': defineMessage({
        id: 'gerenciadoresRepository.errors.existe_un_gerenciador_con_ese_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Gerenciador con ese nombre y debe ser unico.'
    }),
    'gerenciadoresService.errors.pais_invalido': defineMessage({
        id: 'gerenciadoresService.errors.pais_invalido',
        defaultMessage: 'El país no es válido.'
    }),
    'gerenciadoresService.errors.tipo_invalido': defineMessage({
        id: 'gerenciadoresService.errors.tipo_invalido',
        defaultMessage: 'El tipo de proveedor no es válido.'
    }),
    'gerenciadoresService.errors.subregion_invalida': defineMessage({
        id: 'gerenciadoresService.errors.subregion_invalida',
        defaultMessage: 'Alguna de las subregiones indicadas no es válida o no existe.'
    }),
    'gerenciadoresService.errors.titular_invalido': defineMessage({
        id: 'gerenciadoresService.errors.titular_invalido',
        defaultMessage: 'Alguno de los titulares indicados no es válido o no existe.'
    }),
    'gerenciadoresService.errors.servicio_item_invalido': defineMessage({
        id: 'gerenciadoresService.errors.servicio_item_invalido',
        defaultMessage: 'Alguno de los ítems indicados no pertenece a su servicio, o el servicio no está asignado al proveedor.'
    }),
    'infraccionesRepository.errors.error_al_ingresar_los_datos': defineMessage({
        id: 'infraccionesRepository.errors.error_al_ingresar_los_datos',
        defaultMessage: 'Error al ingresar los datos'
    }),
    'infraccionesRepository.errors.no_se_puede_borrar_la_infraccion': defineMessage({
        id: 'infraccionesRepository.errors.no_se_puede_borrar_la_infraccion',
        defaultMessage: 'No se puede borrar la Infracción.'
    }),
    'infraccionesRepository.errors.dominio_ingresado_ya_existe': defineMessage({
        id: 'infraccionesRepository.errors.dominio_ingresado_ya_existe',
        defaultMessage: 'El dominio ingresado ya existe.'
    }),
    'insumoMarcaRepository.errors.marca_de_insumo_repuesto_ya_existe': defineMessage({
        id: 'insumoMarcaRepository.errors.marca_de_insumo_repuesto_ya_existe',
        defaultMessage: 'La marca de insumo/repuesto ya existe.'
    }),
    'insumoMarcaController.errors.no_existe_marca_con_ese_id': defineMessage({
        id: 'insumoMarcaController.errors.no_existe_marca_con_ese_id',
        defaultMessage: 'No existe la marca con ese id'
    }),
    'itemCategoriaController.errors.no_existe_categoria': defineMessage({
        id: 'itemCategoriaController.errors.no_existe_categoria',
        defaultMessage: 'No existe la categoria'
    }),
    'itemCategoriaRepository.errors.no_existe_categoria': defineMessage({
        id: 'itemCategoriaRepository.errors.no_existe_categoria',
        defaultMessage: 'La categoría ya existe.'
    }),
    'itemController.errors.no_existe_el_item_con_ese_id': defineMessage({
        id: 'itemController.errors.no_existe_el_item_con_ese_id',
        defaultMessage: 'No existe el item con ese id'
    }),
    'itemSubCategoriaController.errors.no_existe_la_subcategoria': defineMessage({
        id: 'itemSubCategoriaController.errors.no_existe_la_subcategoria',
        defaultMessage: 'No existe la subcategoria'
    }),
    'localidadController.errors.debe_ingresar_una_provincia_valida': defineMessage({
        id: 'localidadController.errors.debe_ingresar_una_provincia_valida',
        defaultMessage: 'Error, debe ingresar una provincia valida'
    }),
    'marcaService.errors.no_se_pudo_obtener_la_imagen_en_la_carpeta': defineMessage({
        id: 'marcaService.errors.no_se_pudo_obtener_la_imagen_en_la_carpeta',
        defaultMessage: 'No se pudo obtener la imagen en la carpeta.'
    }),
    'marcaRepository.errors.existe_marca_con_ese_nombre_debe_ser_unica': defineMessage({
        id: 'marcaRepository.errors.existe_marca_con_ese_nombre_debe_ser_unica',
        defaultMessage: 'Ya existe una Marca con ese nombre y debe ser única.'
    }),
    'marcaRepository.errors.no_puede_borrar_marca_ya_asociada_a_otro_elemento': defineMessage({
        id: 'marcaRepository.errors.no_puede_borrar_marca_ya_asociada_a_otro_elemento',
        defaultMessage: 'No se puede borrar la Marca ya que esta asociada a otro elemento.'
    }),
    'modelosRepository.errors.existe_modelo_con_ese_nombre_con_ese_tipo_y_modelo_debe_ser_unico': defineMessage({
        id: 'modelosRepository.errors.existe_modelo_con_ese_nombre_con_ese_tipo_y_modelo_debe_ser_unico',
        defaultMessage: 'Ya existe un Modelo con ese nombre con ese Tipo y Modelo, debe ser único.'
    }),
    'modelosRepository.errors.no_se_puede_borrar_modelo_asociado_a_otro_elemento': defineMessage({
        id: 'modelosRepository.errors.no_se_puede_borrar_modelo_asociado_a_otro_elemento',
        defaultMessage: 'No se puede borrar el Modelo ya que esta asociado a otro elemento.'
    }),
    'modeloTiposRepository.errors.existe_un_tipo_modelo_con_ese_nombre_debe_ser_unico': defineMessage({
        id: 'modeloTiposRepository.errors.existe_un_tipo_modelo_con_ese_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Tipo de Modelo con ese Nombre y debe ser único.'
    }),
    'modeloTiposRepository.errors.no_se_puede_borrar_tipo_modelo_asociada_a_otro_elemento': defineMessage({
        id: 'modeloTiposRepository.errors.no_se_puede_borrar_tipo_modelo_asociada_a_otro_elemento',
        defaultMessage: 'No se puede borrar el Tipo de Modelo ya que esta asociada a otro elemento.'
    }),
    'movilController.errors.token_no_es_correcto': defineMessage({
        id: 'movilController.errors.token_no_es_correcto',
        defaultMessage: 'Error, el token ingresado no es correcto'
    }),
    'movilController.errors.campos_latitud_longitud_no_pudieron_validarse': defineMessage({
        id: 'movilController.errors.campos_latitud_longitud_no_pudieron_validarse',
        defaultMessage: 'Error, los campos latitud y longitud no pudieron validarse'
    }),
    'movilController.errors.debe_ingresar_la_fecha': defineMessage({
        id: 'movilController.errors.debe_ingresar_la_fecha',
        defaultMessage: 'Error, debe ingresar la fecha'
    }),
    'movilFuenteRepository.errors.error_al_ingresar_los_datos': defineMessage({
        id: 'movilFuenteRepository.errors.error_al_ingresar_los_datos',
        defaultMessage: 'Error al ingresar los datos'
    }),
    'movilRepository.errors.error_al_ingresar_los_datos': defineMessage({
        id: 'movilRepository.errors.error_al_ingresar_los_datos',
        defaultMessage: 'Error al ingresar los datos'
    }),
    'movilRepository.errors.error_al_actualizar_tareas_del_movil': defineMessage({
        id: 'movilRepository.errors.error_al_actualizar_tareas_del_movil',
        defaultMessage: 'Error al actualizar tareas del móvil'
    }),
    'movilRepository.errors.error_cambiar_de_estado': defineMessage({
        id: 'movilRepository.errors.error_cambiar_de_estado',
        defaultMessage: 'Error Cambiar de estado'
    }),
    'movilRepository.errors.parametro_incorrecto_modificar_km': defineMessage({
        id: 'movilRepository.errors.parametro_incorrecto_modificar_km',
        defaultMessage: 'Parámetro incorrecto para modificar el km del móvil.'
    }),
    'movilRepository.errors.parametro_incorrecto_modificar_km': defineMessage({
        id: 'movilRepository.errors.parametro_incorrecto_modificar_km',
        defaultMessage: 'Parámetro incorrecto para modificar el km del móvil.'
    }),
    'movilRepository.errors.no_existe_el_movil_con_ese_id': defineMessage({
        id: 'movilRepository.errors.no_existe_el_movil_con_ese_id',
        defaultMessage: 'No existe el móvil con ese id.'
    }),
    'movilRepository.errors.dominio_ingresado_ya_existe': defineMessage({
        id: 'movilRepository.errors.dominio_ingresado_ya_existe',
        defaultMessage: 'El dominio ingresado ya existe.'
    }),
    'movilRepository.errors.este_movil_tiene_Rops_activos_no_puede_cambiar_estado': defineMessage({
        id: 'movilRepository.errors.este_movil_tiene_Rops_activos_no_puede_cambiar_estado',
        defaultMessage: 'Este movil tiene ROPS activos, no puede cambiar el estado.'
    }),
    'movilRepository.errors.este_movil_tiene_Tickets_Preventivos_activos_no_puede_cambiar_Plan': defineMessage({
        id: 'movilRepository.errors.este_movil_tiene_Tickets_Preventivos_activos_no_puede_cambiar_Plan',
        defaultMessage: 'Este movil tiene Tickets Preventivos activos, no puede cambiar el Plan.'
    }),
    'movilRepository.errors.este_movil_tiene_Tickets_Preventivos_activos_no_puede_cambiar_estado': defineMessage({
        id: 'movilRepository.errors.este_movil_tiene_Tickets_Preventivos_activos_no_puede_cambiar_estado',
        defaultMessage: 'Este movil tiene Tickets Preventivos activos, no puede cambiar el estado.'
    }),
    'movilRepository.errors.este_movil_tiene_Tickets_Vencimientos_activos_no_puede_cambiar_estado': defineMessage({
        id: 'movilRepository.errors.este_movil_tiene_Tickets_Vencimientos_activos_no_puede_cambiar_estado',
        defaultMessage: 'Este movil tiene Tickets de Vencimientos activos, no puede cambiar el estado.'
    }),
    'movilRepository.errors.este_movil_tiene_Tickets_Vencimientos_activos_no_puede_cambiar_Plan': defineMessage({
        id: 'movilRepository.errors.este_movil_tiene_Tickets_Vencimientos_activos_no_puede_cambiar_Plan',
        defaultMessage: 'Este movil tiene Tickets de Vencimientos activos, no puede cambiar el Plan.'
    }),
    'movilRepository.errors.este_movil_tiene_Tickets_Vencimientos_activos_no_puede_cambiar_estado': defineMessage({
        id: 'movilRepository.errors.este_movil_tiene_Tickets_Vencimientos_activos_no_puede_cambiar_estado',
        defaultMessage: 'Este movil tiene Tickets de Vencimientos activos, no puede cambiar el estado.'
    }),
    'movimientoStockController.errors.no_existe_el_objeto_buscado': defineMessage({
        id: 'movimientoStockController.errors.no_existe_el_objeto_buscado',
        defaultMessage: 'No existe el objeto buscado'
    }),
    'movimientoStockController.errors.no_se_puede_obtener_movimiento': defineMessage({
        id: 'movimientoStockController.errors.no_se_puede_obtener_movimiento',
        defaultMessage: 'No se puede obtener el movimiento'
    }),
    'movimientoStockController.errors.no_se_puede_eliminar_movimiento_stock': defineMessage({
        id: 'movimientoStockController.errors.no_se_puede_eliminar_movimiento_stock',
        defaultMessage: 'No se puede eliminar un movimiento de stock'
    }),
    'movimientoStockController.errors.no_se_puede_editar_movimiento_stock': defineMessage({
        id: 'movimientoStockController.errors.no_se_puede_editar_movimiento_stock',
        defaultMessage: 'No se puede editar un movimiento de stock'
    }),
    'movimientoStockRepository.errors.tipo_movimiento_stock_invalido': defineMessage({
        id: 'movimientoStockRepository.errors.tipo_movimiento_stock_invalido',
        defaultMessage: 'Tipo de movimiento de stock inválido'
    }),
    'movimientoStockRepository.errors.tipo_movimiento_incorrecto': defineMessage({
        id: 'movimientoStockRepository.errors.tipo_movimiento_incorrecto',
        defaultMessage: 'tipo movimiento incorrecto'
    }),
    'oTService.errors.no_se_pudo_obtener_archivo_modelo': defineMessage({
        id: 'oTService.errors.no_se_pudo_obtener_archivo_modelo',
        defaultMessage: 'No se pudo obtener el archivo modelo'
    }),
    'oTService.errors.fecha_vencimiento_es_obligatorio': defineMessage({
        id: 'oTService.errors.fecha_vencimiento_es_obligatorio',
        defaultMessage: 'Fecha de Vencimiento es obligatorio'
    }),
    'oTRepository.errors.tipo_archivo_no_reconocido': defineMessage({
        id: 'oTRepository.errors.tipo_archivo_no_reconocido',
        defaultMessage: 'El tipo de archivo no reconocido'
    }),
    'oTRepository.errors.archivo_no_cumple_formato_tickets_gestoria': defineMessage({
        id: 'oTRepository.errors.archivo_no_cumple_formato_tickets_gestoria',
        defaultMessage: 'El archivo no cumple el formato de Tickets de Gestoria'
    }),
    'perfilesRepository.errors.no_existe_el_permiso': defineMessage({
        id: 'perfilesRepository.errors.no_existe_el_permiso',
        defaultMessage: 'No existe el permiso.'
    }),
    'perfilesRepository.errors.existe_un_perfil_con_el_nombre_debe_ser_unico': defineMessage({
        id: 'perfilesRepository.errors.existe_un_perfil_con_el_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un perfil con el nombre y debe ser único.'
    }),
    'personaRepository.errors.direccion_email_ya_existe_debe_ser_unica': defineMessage({
        id: 'personaRepository.errors.direccion_email_ya_existe_debe_ser_unica',
        defaultMessage: 'La dirección de email ya existe debe ser única.'
    }),
    'personaRepository.errors.la_llave_ingresada_esta_asignada_a_otra_persona': defineMessage({
        id: 'personaRepository.errors.la_llave_ingresada_esta_asignada_a_otra_persona',
        defaultMessage: 'La llave ingresada está asignada a otra persona.'
    }),
    'personaRepository.errors.el_legajo_ingresado_ya_existe': defineMessage({
        id: 'personaRepository.errors.el_legajo_ingresado_ya_existe',
        defaultMessage: 'El legajo ingresado ya existe.'
    }),
    'planMantenimientoPreventivoRepository.errors.no_se_puede_borrar_region_esta_asociada_otro_elemento': defineMessage({
        id: 'planMantenimientoPreventivoRepository.errors.no_se_puede_borrar_region_esta_asociada_otro_elemento',
        defaultMessage: 'No se puede borrar la Región ya que esta asociada a otro elemento.'
    }),
    'planMantenimientoPreventivoRepository.errors.existe_plan_con_ese_nombre_debe_ser_unica': defineMessage({
        id: 'planMantenimientoPreventivoRepository.errors.existe_plan_con_ese_nombre_debe_ser_unica',
        defaultMessage: 'Ya existe un Plan con ese nombre y debe ser única.'
    }),
    'plantillaController.errors.no_existe_la_plantilla': defineMessage({
        id: 'plantillaController.errors.no_existe_la_plantilla',
        defaultMessage: 'No existe la plantilla'
    }),
    'plantillaRepository.errors.plantilla_con_ese_codigo_existe': defineMessage({
        id: 'plantillaRepository.errors.plantilla_con_ese_codigo_existe',
        defaultMessage: 'La plantilla con ese código ya existe.'
    }),
    'plantillaItemController.errors.no_existe_el_item': defineMessage({
        id: 'plantillaItemController.errors.no_existe_el_item',
        defaultMessage: 'No existe el item'
    }),
    'plantillaItemController.errors.item_no_corresponde_a_la_plantilla': defineMessage({
        id: 'plantillaItemController.errors.item_no_corresponde_a_la_plantilla',
        defaultMessage: 'El item no corresponde a la plantilla'
    }),
    'provinciaController.errors.debe_ingresar_un_pais_valido': defineMessage({
        id: 'provinciaController.errors.debe_ingresar_un_pais_valido',
        defaultMessage: 'Error, debe ingresar un pais valido'
    }),
    'provinciaRepository.errors.la_provincia_ya_existe': defineMessage({
        id: 'provinciaRepository.errors.la_provincia_ya_existe',
        defaultMessage: 'La provincia ya existe.'
    }),
    'regionRepository.errors.no_se_puede_borrar_region_esta_asociada_a_otro_elemento': defineMessage({
        id: 'regionRepository.errors.no_se_puede_borrar_region_esta_asociada_a_otro_elemento',
        defaultMessage: 'No se puede borrar la Región ya que esta asociada a otro elemento.'
    }),
    'regionRepository.errors.existe_region_con_ese_nombre_debe_ser_unica': defineMessage({
        id: 'regionRepository.errors.existe_region_con_ese_nombre_debe_ser_unica',
        defaultMessage: 'Ya existe una Región con ese nombre y debe ser única.'
    }),
    'servicioRepository.errors.no_se_puede_borrar_servicio_esta_asociada_a_otro_elemento': defineMessage({
        id: 'servicioRepository.errors.no_se_puede_borrar_servicio_esta_asociada_a_otro_elemento',
        defaultMessage: 'No se puede borrar el Servicio ya que está asociada a otro elemento.'
    }),
    'servicioRepository.errors.existe_servicio_con_ese_nombre_debe_ser_unico': defineMessage({
        id: 'servicioRepository.errors.existe_servicio_con_ese_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Servicio con ese nombre y debe ser único.'
    }),
    'servicioRepository.errors.existe_servicio_con_ese_nombre_debe_ser_unico': defineMessage({
        id: 'servicioRepository.errors.existe_servicio_con_ese_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Servicio con ese nombre y debe ser único.'
    }),
    'subregionRepository.errors.no_se_puede_borrar_sub_region_esta_asociada_a_otro_elemento': defineMessage({
        id: 'subregionRepository.errors.no_se_puede_borrar_sub_region_esta_asociada_a_otro_elemento',
        defaultMessage: 'No se puede borrar la Sub Región ya que esta asociada a otro elemento.'
    }),
    'subregionRepository.errors.existe_sub_region_con_ese_nombre_debe_ser_unica': defineMessage({
        id: 'subregionRepository.errors.existe_sub_region_con_ese_nombre_debe_ser_unica',
        defaultMessage: 'Ya existe una Sub Región con ese nombre y debe ser única.'
    }),
    'talleresRepository.errors.existe_taller_con_el_nombre_debe_ser_unico': defineMessage({
        id: 'talleresRepository.errors.existe_taller_con_el_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Taller con el nombre y debe ser único.'
    }),
    'talleresRepository.errors.existe_un_taller_con_esa_razon_social_debe_ser_unica': defineMessage({
        id: 'talleresRepository.errors.existe_un_taller_con_esa_razon_social_debe_ser_unica',
        defaultMessage: 'Ya existe un Taller con esa Razón Social y debe ser única.'
    }),
    'tareaRepository.errors.no_se_puede_borrar_la_tarea_esta_asociada_a_otro_elemento': defineMessage({
        id: 'tareaRepository.errors.no_se_puede_borrar_la_tarea_esta_asociada_a_otro_elemento',
        defaultMessage: 'No se puede borrar la Tarea ya que está asociada a otro elemento.'
    }),
    'tareaRepository.errors.existe_tarea_con_ese_nombre_debe_ser_unico': defineMessage({
        id: 'tareaRepository.errors.existe_tarea_con_ese_nombre_debe_ser_unico',
        defaultMessage: 'Ya existe un Tarea con ese Nombre y debe ser único.'
    }),
    'unidadDeMedidaController.errors.no_existe_la_unidad_con_ese_id': defineMessage({
        id: 'unidadDeMedidaController.errors.no_existe_la_unidad_con_ese_id',
        defaultMessage: 'No existe la unidad con ese id'
    }),
    'unidadDeMedidaService.errors.no_se_puede_modificar_una_unidad_de_sistema': defineMessage({
        id: 'unidadDeMedidaService.errors.no_se_puede_modificar_una_unidad_de_sistema',
        defaultMessage: 'No se puede modificar una unidad de sistema'
    }),
    'unidadDeMedidaRepository.errors.abreviatura_de_la_unidad_medida_ya_existe': defineMessage({
        id: 'unidadDeMedidaRepository.errors.abreviatura_de_la_unidad_medida_ya_existe',
        defaultMessage: 'La abreviatura de la unidad de medida ya existe.'
    }),
    'usuarioRepository.errors.el_usuario_ingresado_ya_existe': defineMessage({
        id: 'usuarioRepository.errors.el_usuario_ingresado_ya_existe',
        defaultMessage: 'El usuario ingresado ya existe.'
    }),
    'vencimientosRepository.errors.no_tiene_permiso_para_crear_vencimientos': defineMessage({
        id: 'vencimientosRepository.errors.no_tiene_permiso_para_crear_vencimientos',
        defaultMessage: 'No tiene permiso para crear vencimientos'
    }),
    'vencimientosRepository.errors.no_tiene_permiso_para_editar_vencimientos': defineMessage({
        id: 'vencimientosRepository.errors.no_tiene_permiso_para_editar_vencimientos',
        defaultMessage: 'No tiene permiso para editar vencimientos'
    }),
    'vencimientosRepository.errors.control_duplicado': defineMessage({
        id: 'vencimientosRepository.errors.control_duplicado',
        defaultMessage: 'Control de vencimiento ya creado'
    }),
    'vencimientosRepository.errors.movil_inactivo': defineMessage({
        id: 'vencimientosRepository.errors.movil_inactivo',
        defaultMessage: 'El vehículo se encuentra inactivo'
    }),
    'vencimientosRepository.errors.persona_inactiva': defineMessage({
        id: 'vencimientosRepository.errors.persona_inactivo',
        defaultMessage: 'La persona se encuentra inactiva'
    }),
    'vencimientosRepository.errors.ejecucion_por_unica_vez_invalido': defineMessage({
        id: 'vencimientosRepository.errors.ejecucion_por_unica_vez_invalido',
        defaultMessage: 'Dato inválido en ejecucion por unica vez, ingrese "Si" o "No".'
    }),
    'vencimientosRepository.errors.numero_invalido': defineMessage({
        id: 'vencimientosRepository.errors.numero_invalido',
        defaultMessage: 'Número inválido'
    }),
    'vencimientosRepository.errors.alerta_dias_previos': defineMessage({
        id: 'vencimientosRepository.errors.alerta_dias_previos',
        defaultMessage: 'Error en campo Primera Notificacion'
    }),
    'vencimientosRepository.errors.emision_dias_previos': defineMessage({
        id: 'vencimientosRepository.errors.emision_dias_previos',
        defaultMessage: 'Error en campo Emision de Ticket es campo obligatorio'
    }),
    'vencimientosRepository.valida_que_haya_o_persona_o_movil': defineMessage({
        id: 'vencimientosRepository.valida_que_haya_o_persona_o_movil',
        defaultMessage: 'Valida que haya o persona o movil'
    }),
    'vencimientosRepository.errors.archivo_sin_datos': defineMessage({
        id: 'vencimientosRepository.errors.archivo_sin_datos',
        defaultMessage: 'El archivo no contiene datos'
    }),
    'vencimientosRepository.errors.archivo_no_cumple_formato_faltan_columnas': defineMessage({
        id: 'vencimientosRepository.errors.archivo_no_cumple_formato_faltan_columnas',
        defaultMessage: 'Archivo no cumple formato, faltan columnas'
    }),
    'vencimientosRepository.errors.no_se_pudieron_leer_columnas_del_archivo': defineMessage({
        id: 'vencimientosRepository.errors.no_se_pudieron_leer_columnas_del_archivo',
        defaultMessage: 'No se pudieron leer las columnas del archivo'
    }),
    'vencimientosRepository.errors.ingreso_dni_dominio_un_campo': defineMessage({
        id: 'vencimientosRepository.errors.ingreso_dni_dominio_un_campo',
        defaultMessage: 'Ingreso DNI y dominio solo se admite un solo campo'
    }),
    'vencimientosRepository.errors.debe_escribir_dni_dominio': defineMessage({
        id: 'vencimientosRepository.errors.debe_escribir_dni_dominio',
        defaultMessage: 'Debe escribir un DNI o dominio'
    }),
    'vencimientosRepository.errors.servicio_requerido': defineMessage({
        id: 'vencimientosRepository.errors.servicio_requerido',
        defaultMessage: 'El servicio es requerido'
    }),
    'vencimientosRepository.errors.servicio_vencimiento_no_encontrado': defineMessage({
        id: 'vencimientosRepository.errors.servicio_vencimiento_no_encontrado',
        defaultMessage: 'No se encontró el servicio de vencimiento'
    }),
    'vencimientosRepository.errors.entidad_no_encontrada': defineMessage({
        id: 'vencimientosRepository.errors.entidad_no_encontrada',
        defaultMessage: 'Entidad no encontrada para el servicio'
    }),
    'vencimientosRepository.errors.fecha_expedicion_no_valida': defineMessage({
        id: 'vencimientosRepository.errors.fecha_expedicion_no_valida',
        defaultMessage: 'Fecha de expedicion no válida'
    }),
    'vencimientosRepository.errors.fecha_expedicion_superior_fecha_actual': defineMessage({
        id: 'vencimientosRepository.errors.fecha_expedicion_superior_fecha_actual',
        defaultMessage: 'La fecha de expedicion no puede ser superior a la fecha actual'
    }),
    'vencimientosRepository.errors.fecha_vencimiento_no_valida': defineMessage({
        id: 'vencimientosRepository.errors.fecha_vencimiento_no_valida',
        defaultMessage: 'La fecha de vencimiento no es válida'
    }),
    'ticketTareasCierre.errors.deber_ingresar_al_menos_una_tarea': defineMessage({
        id: 'ticketTareasCierre.errors.deber_ingresar_al_menos_una_tarea',
        defaultMessage: 'Debe ingresar al menos una tarea.'
    }),
    'infraccionesRepository.basicCardInfo.description.total': defineMessage({
        id: 'infraccionesRepository.basicCardInfo.description.total',
        defaultMessage: 'Total'
    }),
    'infraccionesRepository.basicCardInfo.description.pendientes_confirmacion': defineMessage({
        id: 'infraccionesRepository.basicCardInfo.description.pendientes_confirmacion',
        defaultMessage: 'Pendientes de Confirmación'
    }),
    'infraccionesRepository.basicCardInfo.description.pendientes_pago': defineMessage({
        id: 'infraccionesRepository.basicCardInfo.description.pendientes_pago',
        defaultMessage: 'Pendientes de Pago'
    }),
    'infraccionesRepository.basicCardInfo.description.abonadas': defineMessage({
        id: 'infraccionesRepository.basicCardInfo.description.abonadas',
        defaultMessage: 'Abonadas'
    }),
    'movilRepository.basicCardInfo.description.sin_posicion_gps': defineMessage({
        id: 'movilRepository.basicCardInfo.description.sin_posicion_gps',
        defaultMessage: 'Sin Posición GPS'
    }),
    'movilRepository.basicCardInfo.description.en_taller': defineMessage({
        id: 'movilRepository.basicCardInfo.description.en_taller',
        defaultMessage: 'En Taller'
    }),
    'movilRepository.basicCardInfo.description.doc_movil_vencida': defineMessage({
        id: 'movilRepository.basicCardInfo.description.doc_movil_vencida',
        defaultMessage: 'Doc. Móvil Vencida'
    }),
    'movilRepository.basicCardInfo.description.doc_chofer_vencida': defineMessage({
        id: 'movilRepository.basicCardInfo.description.doc_chofer_vencida',
        defaultMessage: 'Doc. Chofer Vencida'
    }),
    'movilRepository.basicCardInfo.description.vh_con_infracciones': defineMessage({
        id: 'movilRepository.basicCardInfo.description.vh_con_infracciones',
        defaultMessage: 'Vh. con Infracciones'
    }),
    'movilRepository.basicCardInfo.description.vh_con_cargas_invalidas': defineMessage({
        id: 'movilRepository.basicCardInfo.description.vh_con_cargas_invalidas',
        defaultMessage: 'Vh. con Cargas Inválidas'
    }),
    'solidGaugeRepository.dashboardOperativo2.cardTitle.MANT_PREVENTIVOS': defineMessage({
        id: 'solidGaugeRepository.dashboardOperativo2.cardTitle.MANT_PREVENTIVOS',
        defaultMessage: 'MANT. PREVENTIVOS'
    }),
    'solidGaugeRepository.dashboardOperativo2.cardTitle.MANT_CORRECTIVOS': defineMessage({
        id: 'solidGaugeRepository.dashboardOperativo2.cardTitle.MANT_CORRECTIVOS',
        defaultMessage: 'MANT. CORRECTIVOS'
    }),
    'solidGaugeRepository.dashboardOperativo2.cardTitle.VENCIMIENTOS_MOVILES': defineMessage({
        id: 'solidGaugeRepository.dashboardOperativo2.cardTitle.VENCIMIENTOS_MOVILES',
        defaultMessage: 'VENCIMIENTOS - MÓVILES'
    }),
    'solidGaugeRepository.dashboardOperativo2.cardTitle.VENCIMIENTOS_PERSONAS': defineMessage({
        id: 'solidGaugeRepository.dashboardOperativo2.cardTitle.VENCIMIENTOS_PERSONAS',
        defaultMessage: 'VENCIMIENTOS - PERSONAS'
    }),
    'solidGaugeRepository.dashboardOperativo2.cardTitle.GESTORIA': defineMessage({
        id: 'solidGaugeRepository.dashboardOperativo2.cardTitle.GESTORIA',
        defaultMessage: 'GESTORÍA'
    }),
    'llantaAsignacionController.errors.llanta_ya_esta_asignada': defineMessage({
        id: 'llantaAsignacionController.errors.llanta_ya_esta_asignada',
        defaultMessage: 'La llanta ya esta asignada a un móvil'
    }),
    'llantaAsignacionController.errors.llanta_en_recapado': defineMessage({
        id: 'llantaAsignacionController.errors.llanta_en_recapado',
        defaultMessage: 'La llanta se encuentra en recapado'
    }),
    'llantaController.errors.add_banda_es_requerida': defineMessage({
        id: 'llantaController.errors.add_banda_es_requerida',
        defaultMessage: 'La Base es requerida.'
    }),
    'llantaController.errors.add_llanta_posicion_en_movil_en_uso': defineMessage({
        id: 'llantaController.errors.add_llanta_posicion_en_movil_en_uso',
        defaultMessage: 'La posición selecionada en el móvil esta en uso.'
    }),
    'llantaController.errors.llanta_cambio_medidor_en_movil_en_uso': defineMessage({
        id: 'llantaController.errors.llanta_cambio_medidor_en_movil_en_uso',
        defaultMessage: 'No puede cambiar el medidor de una llanta asignada a un móvil.'
    }),
    'llantaAsignacionController.errors.llanta_no_pertenece_al_movil': defineMessage({
        id: 'llantaAsignacionController.errors.llanta_no_pertenece_al_movil',
        defaultMessage: 'Llanta no pertence al móvil.'
    }),
    'llantaController.errors.supero_recapados_maximo': defineMessage({
        id: 'llantaController.errors.supero_recapados_maximo',
        defaultMessage: 'No se permiten mas recapados en la llanta.'
    }),
    'llantaModeloController.errors.punto_medicion.milimetro_warning_debe_se_menor_a_milimitro_inicio': defineMessage({
        id: 'llantaModeloController.errors.punto_medicion.milimetro_warning_debe_se_menor_a_milimitro_inicio',
        defaultMessage: 'Espesor de recapado debe ser menor a mm en momento de compra.'
    }),
    'llantaModeloController.errors.punto_medicion.valores_no_pueden_ser_vacios': defineMessage({
        id: 'llantaModeloController.errors.punto_medicion.valores_no_pueden_ser_vacios',
        defaultMessage: 'El valores de un punto de medición no pueden ser vacíos.'
    }),
    'llantaModeloController.errors.punto_medicion.milimetro_danger_debe_se_menor_a_milimitro_warning': defineMessage({
        id: 'llantaModeloController.errors.punto_medicion.milimetro_danger_debe_se_menor_a_milimitro_warning',
        defaultMessage: 'Espesor de baja debe ser menor al espesor de recapado.'
    }),
    'llantaModeloController.errors.llanta_modelo_ya_existe': defineMessage({
        id: 'llantaModeloController.errors.llanta_modelo_ya_existe',
        defaultMessage: 'Ya existe un modelo de llanta con los datos ingresados.'
    }),
    'llantaModeloController.errors.existen_llantas_asociadas': defineMessage({
        id: 'llantaModeloController.errors.existen_llantas_asociadas',
        defaultMessage: 'Operacion denegada, existen llantas asociadas a este modelo.'
    }),
    'llantaAsignacionesGrid.kpis_card.llantas_entre_0mm_y_3mm': defineMessage({
        id: 'llantaAsignacionesGrid.kpis_card.llantas_entre_0mm_y_3mm',
        defaultMessage: 'llantas e/ 0 y 3mm'
    }),
    'llantaAsignacionesGrid.kpis_card.llantas_entre_3mm_y_6mm': defineMessage({
        id: 'llantaAsignacionesGrid.kpis_card.llantas_entre_3mm_y_6mm',
        defaultMessage: 'llantas e/ 3 y 6mm'
    }),
    'llantaAsignacionesGrid.kpis_card.inspeciones_vencidas': defineMessage({
        id: 'llantaAsignacionesGrid.kpis_card.inspeciones_vencidas',
        defaultMessage: 'Inspeciones Vencidas'
    }),
    'llantaAsignacionesGrid.kpis_card.KMs_promedio_por_llanta': defineMessage({
        id: 'llantaAsignacionesGrid.kpis_card.KMs_promedio_por_llanta',
        defaultMessage: 'KMs promedio por llanta'
    }),
    'llantaAsignacionesGrid.kpis_card.desgaste_cada_10000km': defineMessage({
        id: 'llantaAsignacionesGrid.kpis_card.desgaste_cada_10000km',
        defaultMessage: 'Desgaste (c/ 1000km)'
    }),
    'llantasGrid.kpis_card.llantas_entre_0mm_y_3mm': defineMessage({
        id: 'llantasGrid.kpis_card.llantas_entre_0mm_y_3mm',
        defaultMessage: 'llantas e/ 0 y 3mm'
    }),
    'llantasGrid.kpis_card.llantas_entre_3mm_y_6mm': defineMessage({
        id: 'llantasGrid.kpis_card.llantas_entre_3mm_y_6mm',
        defaultMessage: 'llantas e/ 3 y 6mm'
    }),
    'llantasGrid.kpis_card.inspeciones_vencidas': defineMessage({
        id: 'llantasGrid.kpis_card.inspeciones_vencidas',
        defaultMessage: 'Inspeciones Vencidas'
    }),
    'llantasGrid.kpis_card.KMs_promedio_por_llanta': defineMessage({
        id: 'llantasGrid.kpis_card.KMs_promedio_por_llanta',
        defaultMessage: 'KMs promedio por llanta'
    }),
    'llantasGrid.kpis_card.desgaste_cada_10000km': defineMessage({
        id: 'llantasGrid.kpis_card.desgaste_cada_10000km',
        defaultMessage: 'Desgaste (c/ 10000km)'
    }),
    'llantasGrid.kpis_card.llantas_sin_asignar': defineMessage({
        id: 'llantasGrid.kpis_card.llantas_sin_asignar',
        defaultMessage: 'Llantas sin Asignar'
    }),
    'llantaInspeccionesAbm.errors.firma_requerida': defineMessage({
        id: 'llantaInspeccionesAbm.errors.firma_requerida',
        defaultMessage: 'La firma es requerida'
    }),
    'llantaInspeccionesAbm.errors.odometro_es_requerido': defineMessage({
        id: 'llantaInspeccionesAbm.errors.odometro_es_requerido',
        defaultMessage: 'El odometro es requerido'
    }),
    'llantaController.errors.forzar_recapado_requiere_movil': defineMessage({
        id: 'llantaController.errors.forzar_recapado_requiere_movil',
        defaultMessage: 'Para forzar el recapado se requiere un móvil asignado'
    }),
    'llantaController.errors.servicio_REENCAUCHE_no_encontrado': defineMessage({
        id: 'llantaController.errors.servicio_REENCAUCHE_no_encontrado',
        defaultMessage: 'Servicio de REENCAUCHE no encontrado'
    }),
    'llantaController.errors.llanta_no_existe': defineMessage({
        id: 'llantaController.errors.llanta_no_existe',
        defaultMessage: 'Llanta no existe'
    }),
    'llantaController.errors.llanta_no_existe': defineMessage({
        id: 'llantaController.errors.ingrese_reemplazo',
        defaultMessage: 'Debe asignar una Llanta de Reemplazo'
    }),
    'llantaController.errors.llanta_tiene_asignada_un_movil': defineMessage({
        id: 'llantaController.errors.llanta_tiene_asignada_un_movil',
        defaultMessage: 'Llanta esta asignada a un móvil'
    }),
    'llantaController.errors.llanta_no_tiene_ticket_de_recapado': defineMessage({
        id: 'llantaController.errors.llanta_no_tiene_ticket_de_recapado',
        defaultMessage: 'Llanta no tiene tickets de recapado asignado'
    }),
    'llantaController.errors.llanta_a_desasignar_no_tiene_asigndo_un_movil': defineMessage({
        id: 'llantaController.errors.llanta_a_desasignar_no_tiene_asigndo_un_movil',
        defaultMessage: 'Llanta a desasignar no tiene asignado un móvil'
    }),
    'llantaController.errors.llanta_a_desasignar_requiere_reemplazo': defineMessage({
        id: 'llantaController.errors.llanta_a_desasignar_requiere_reemplazo',
        defaultMessage: 'Llanta a desasignar requiere reemplazo'
    }),
    'llantasGrid.kpis_card.llantas_rodando': defineMessage({
        id: 'llantasGrid.kpis_card.llantas_rodando',
        defaultMessage: 'Llantas Rodando'
    }),
    'dashboard.kpiMovilesDisponibles.titulo': defineMessage({
        id: 'dashboard.kpiMovilesDisponibles.titulo',
        defaultMessage: 'Móviles Operativos'
    }),
    'dashboard.kpiActivos.titulo': defineMessage({
        id: 'dashboard.kpiActivos.titulo',
        defaultMessage: 'Moviles Cargados/Registrados'
    }),
    'dashboard.kpiFueraDeServicio.titulo': defineMessage({
        id: 'dashboard.kpiFueraDeServicio.titulo',
        defaultMessage: 'Móviles Fuera de Servicio'
    }),
    'dashboard.kpiEnComodato.titulo': defineMessage({
        id: 'dashboard.kpiEnComodato.titulo',
        defaultMessage: 'Móviles En Comodato'
    }),
    'dashboard.kpiEnTaller.titulo': defineMessage({
        id: 'dashboard.kpiEnTaller.titulo',
        defaultMessage: 'Móviles En Reparación'
    }),
    'dashboard.kpiSinGps.titulo': defineMessage({
        id: 'dashboard.kpiSinGps.titulo',
        defaultMessage: 'Móviles Sin Disp. Sat.'
    }),
    'dashboard.kpiTicketsEnGestion.titulo': defineMessage({
        id: 'dashboard.kpiTicketsEnGestion.titulo',
        defaultMessage: 'Tickets en Gestión'
    }),
    'dashboard.kpiPresupuestados.titulo': defineMessage({
        id: 'dashboard.kpiPresupuestados.titulo',
        defaultMessage: 'Tickets Presupuestados'
    }),
    'dashboard.kpiListoParaRetirar.titulo': defineMessage({
        id: 'dashboard.kpiListoParaRetirar.titulo',
        defaultMessage: 'Tickets Listos para Retirar'
    }),
    'dashboard.kpiAprobados.titulo': defineMessage({
        id: 'dashboard.kpiAprobados.titulo',
        defaultMessage: 'Tickets Aprobados'
    }),
    'dashboard.kpiFueraDeServicio.titulo': defineMessage({
        id: 'dashboard.kpiFueraDeServicio.titulo',
        defaultMessage: 'Móviles Fuera de Servicio'
    }),
    'llantaController.errors.formulario_finalizar_recapado_incompleto': defineMessage({
        id: 'llantaController.errors.formulario_finalizar_recapado_incompleto',
        defaultMessage: 'Complete todos los campos.'
    }),
    'llantas.column_desgaste_cada_mil.restante_odometro.no_es_posible_el_calculo': defineMessage({
        id: 'llantas.column_desgaste_cada_mil.restante_odometro.no_es_posible_el_calculo',
        defaultMessage: 'No es posible el calculo, faltan datos'
    }),
    'llantaModeloController.errors.clase.clase_invalida_en_unidad_medidor': defineMessage({
        id: 'llantaModeloController.errors.clase.clase_invalida_en_unidad_medidor',
        defaultMessage: 'Clase no pertence a la unidad de medidor'
    }),
    'llantaModeloController.errors.unidad_medidor.unidad_medidor_invalido': defineMessage({
        id: 'llantaModeloController.errors.unidad_medidor.unidad_medidor_invalido',
        defaultMessage: 'Unidad medidor invalido'
    }),
    'llantasGrid.kpis_card.llantas_en_nivel_de_reenc_baja': defineMessage({
        id: 'llantasGrid.kpis_card.llantas_en_nivel_de_reenc_baja',
        defaultMessage: 'En nivel de Reenc./Baja'
    }),
    'llantasGrid.kpis_card.llantas_proximas_a_reenc_baja': defineMessage({
        id: 'llantasGrid.kpis_card.llantas_proximas_a_reenc_baja',
        defaultMessage: 'Próximas a Reenc./Baja'
    }),
    'llantaController.errors.ya_existe_una_llanta': defineMessage({
        id: 'llantaController.errors.ya_existe_una_llanta',
        defaultMessage: 'Ya existe una llanta con el serial ingresado.'
    }),
    'llantaController.errors.tipo_de_llanta_incompatible_con_movil': defineMessage({
        id: 'llantaController.errors.tipo_de_llanta_incompatible_con_movil',
        defaultMessage: 'Tipo de llanta incompatible con el vehículo'
    }),
    'llantaController.errors.llanta_baja.tipo_de_llanta_reemplazo_incompatible_con_movil': defineMessage({
        id: 'llantaController.errors.llanta_baja.tipo_de_llanta_reemplazo_incompatible_con_movil',
        defaultMessage: 'Tipo de llanta reemplazo incompatible con el vehículo'
    }),
    'llantaController.errors.base_requerida_para_desasignar': defineMessage({
        id: 'llantaController.errors.base_requerida_para_desasignar',
        defaultMessage: 'Base es requerida para desasignar'
    }),
    'llantaModeloController.errors.llanta_modelo_no_existe': defineMessage({
        id: 'llantaModeloController.errors.llanta_modelo_no_existe',
        defaultMessage: 'Modelo de llanta no existe'
    }),
    'llantaModeloController.errors.llanta_modelo_tiene_llantas_asignadas_no_se_puede_cambiar_unidad_medidor': defineMessage({
        id: 'llantaModeloController.errors.llanta_modelo_tiene_llantas_asignadas_no_se_puede_cambiar_unidad_medidor',
        defaultMessage: 'Modelo tiene llantas asignadas a  vehículos, no se puede cambiar unidad medidor.'
    }),
    'llantasGrid.kpis_card.Hrs_promedio_por_llanta': defineMessage({
        id: 'llantasGrid.kpis_card.Hrs_promedio_por_llanta',
        defaultMessage: 'Hrs promedio por llanta'
    }),
    'llantasGrid.kpis_card.desgaste_cada_10000hrs': defineMessage({
        id: 'llantasGrid.kpis_card.desgaste_cada_10000hrs',
        defaultMessage: 'Desgaste (c/ 1000Hrs)'
    }),
    'llantaController.errors.add_llanta_posicion_es_requerido': defineMessage({
        id: 'llantaController.errors.add_llanta_posicion_es_requerido',
        defaultMessage: 'Selecione una posición'
    }),
    'llantasRepository.errors.encabezado_no_esta_en_fila_correcta': defineMessage({
        id: 'movilesRepository.errors.encabezado_no_esta_en_fila_correcta',
        defaultMessage: 'Encabezado no esta en fila correcta.'
    }),
    'llantasRepository.errors.archivo_no_cumple_formato_faltan_columnas': defineMessage({
        id: 'llantasRepository.errors.archivo_no_cumple_formato_faltan_columnas',
        defaultMessage: 'Archivo no cumple formato faltan columnas.'
    }),
    'ropAbm.errors.ya_existe_rop_para_equipo': defineMessage({
        id: 'rops.errors.ya_existe_rop_para_equipo',
        defaultMessage: 'Ya existe un ROP para este equipo.'
    }),
    'kpi_moviles.gps': defineMessage({
        id: 'kpi_moviles.gps',
        defaultMessage: 'GPS'
    }),
    'kpi_moviles.gps_no_reportan': defineMessage({
        id: 'kpi_moviles.gps_no_reportan',
        defaultMessage: 'GPS no reportan'
    }),
    'kpi_moviles.gps_vehiculos_sin_GPS': defineMessage({
        id: 'kpi_moviles.gps_vehiculos_sin_GPS',
        defaultMessage: 'Vehículos sin GPS'
    }),
    'error.odometro_mayor_al_actual': defineMessage({
        id: 'error.odometro_mayor_al_actual',
        defaultMessage: 'Odómetro tiene que ser mayor al actual'
    }),
    'form.error': defineMessage({
        id: 'form.error',
        defaultMessage: 'Error'
    }),
    'login.errors.invalido': defineMessage({
        id: 'login.errors.invalido',
        defaultMessage: '  La combinación de nombre de usuario y contraseña no existe en nuestro sistema'
    }),
    'llantaController.no_se_puede_dar_de_baja_la_lanta_tickets_pendientes': defineMessage({
        id: 'llantaController.no_se_puede_dar_de_baja_la_lanta_tickets_pendientes',
        defaultMessage: 'No se puede dar de baja la llanta, tiene tickets pendientes'
    }),
    'tickets.sinTraduccion': defineMessage({
        id: 'tickets.sinTraduccion',
        defaultMessage: 'Falta traduccion'
    }),
    'tickets_estados.PENDIENTES': defineMessage({
        id: 'tickets_estados.PENDIENTES',
        defaultMessage: 'PENDIENTES'
    }),
    'tickets_estado.ABIERTO': defineMessage({
        id: 'tickets_estados.ABIERTO',
        defaultMessage: 'ABIERTO'
    }),
    'tickets_estado.ADIC_PRESUPUESTADO': defineMessage({
        id: 'tickets_estado.ADIC_PRESUPUESTADO',
        defaultMessage: 'ADIC PRESUPUESTADO'
    }),
    'tickets_estado.APROBADO': defineMessage({
        id: 'tickets_estado.APROBADO',
        defaultMessage: 'APROBADO'
    }),
    'tickets_estado.CANCELADO': defineMessage({
        id: 'tickets_estado.CANCELADO',
        defaultMessage: 'CANCELADO'
    }),
    'tickets_estado.CERRADO': defineMessage({
        id: 'tickets_estado.CERRADO',
        defaultMessage: 'CERRADO'
    }),
    'tickets_estado.CONFIRMAR_REPARACION': defineMessage({
        id: 'tickets_estado.CONFIRMAR_REPARACION',
        defaultMessage: 'CONFIRMAR REPARACION'
    }),
    'tickets_estado.COTIZAR_ADICIONAL': defineMessage({
        id: 'tickets_estado.COTIZAR_ADICIONAL',
        defaultMessage: 'COTIZAR ADICIONAL'
    }),
    'tickets_estado.EN_ESCRIBANIA': defineMessage({
        id: 'tickets_estado.EN_ESCRIBANIA',
        defaultMessage: 'EN ESCRIBANIA'
    }),
    'tickets_estado.EN_FORMULARIO': defineMessage({
        id: 'tickets_estado.EN_FORMULARIO',
        defaultMessage: 'EN FORMULARIO'
    }),
    'tickets_estado.EN_GESTION': defineMessage({
        id: 'tickets_estado.EN_GESTION',
        defaultMessage: 'EN GESTION'
    }),
    'tickets_estado.EN_REPARACION': defineMessage({
        id: 'tickets_estado.EN_REPARACION',
        defaultMessage: 'EN REPARACION'
    }),
    'tickets_estado.LISTO_PARA_RETIRAR': defineMessage({
        id: 'tickets_estado.LISTO_PARA_RETIRAR',
        defaultMessage: 'LISTO PARA RETIRAR'
    }),
    'tickets_estado.PRESUPUESTADO': defineMessage({
        id: 'tickets_estado.PRESUPUESTADO',
        defaultMessage: 'PRESUPUESTADO'
    }),
    'tickets_estado.PRESUPUESTADO_SV': defineMessage({
        id: 'tickets_estado.PRESUPUESTADO_SV',
        defaultMessage: 'PRESUPUESTADO SV'
    }),
    'tickets_estado.PROVISORIO': defineMessage({
        id: 'tickets_estado.PROVISORIO',
        defaultMessage: 'PROVISORIO'
    }),
    'tickets_estado.RECOTIZAR': defineMessage({
        id: 'tickets_estado.RECOTIZAR',
        defaultMessage: 'RECOTIZAR'
    }),
    'tickets_estado.RECOTIZAR_SV': defineMessage({
        id: 'tickets_estado.RECOTIZAR_SV',
        defaultMessage: 'RECOTIZAR SV'
    }),
    'tickets_estado.EN_REVISION': defineMessage({
        id: 'tickets_estado.EN_REVISION',
        defaultMessage: 'EN REVISION'
    }),
    'tickets_estado.FUERA_DE_ABONO': defineMessage({
        id: 'tickets_estado.FUERA_DE_ABONO',
        defaultMessage: 'FUERA DE ABONO'
    }),
    'tickets_estado.A_REPARAR': defineMessage({
        id: 'tickets_estado.A_REPARAR',
        defaultMessage: 'A REPARAR'
    }),
    'tickets_estado.VALIDADO_AUDITOR': defineMessage({
        id: 'tickets_estado.VALIDADO_AUDITOR',
        defaultMessage: 'VALIDADO AUDITOR'
    }),
    'tickets_estado.SOLICITUD_DE_PEDIDO': defineMessage({
        id: 'tickets_estado.SOLICITUD_DE_PEDIDO',
        defaultMessage: 'SOLICITUD DE PEDIDO'
    }),
    'tickets_tipo.DEFAULT': defineMessage({
        id: 'tickets_tipo.DEFAULT',
        defaultMessage: 'POR DEFECTO'
    }),
    'tickets_tipo.PREVENTIVO': defineMessage({
        id: 'tickets_tipo.PREVENTIVO',
        defaultMessage: 'PREVENTIVO'
    }),
    'tickets_tipo.PREDICTIVO': defineMessage({
        id: 'tickets_tipo.PREDICTIVO',
        defaultMessage: 'PREDICTIVO'
    }),
    'tickets_tipo.VENCIMIENTO': defineMessage({
        id: 'tickets_tipo.VENCIMIENTO',
        defaultMessage: 'VENCIMIENTO'
    }),
    'tickets_tipo.GESTORIA': defineMessage({
        id: 'tickets_tipo.GESTORIA.PROVISORIO',
        defaultMessage: 'GESTORIA'
    }),
    'tickets_tipo.CORRECTIVO': defineMessage({
        id: 'tickets_tipo.CORRECTIVO',
        defaultMessage: 'CORRECTIVO'
    }),
    'tickets_entidad.movil': defineMessage({
        id: 'tickets_entidad.movil',
        defaultMessage: 'MOVIL'
    }),
    'tickets_entidad.llanta': defineMessage({
        id: 'tickets_entidad.llanta',
        defaultMessage: "LLANTA"
    }),
    'permission.REPORTES_NO_REPORTAN': defineMessage({
        id: 'permission.REPORTES_NO_REPORTAN',
        defaultMessage: "REPORTES_NO_REPORTAN"
    }),
    'permission.REPORTES_ACTUALIZACION_KM': defineMessage({
        id: 'permission.REPORTES_ACTUALIZACION_KM',
        defaultMessage: "REPORTES_ACTUALIZACION_KM"
    }),
    'permission.REPORTES_KM_MOVIL_LISTAR': defineMessage({
        id: 'permission.REPORTES_KM_MOVIL_LISTAR',
        defaultMessage: "REPORTES_KM_MOVIL_LISTAR"
    }),
    'permission.REPORTES_MOVILES_INMOVILIZADOS': defineMessage({
        id: 'permission.REPORTES_MOVILES_INMOVILIZADOS',
        defaultMessage: "REPORTES_MOVILES_INMOVILIZADOS"
    }),
    'permission.DASHBOARD_GASTOS': defineMessage({
        id: 'permission.DASHBOARD_GASTOS',
        defaultMessage: "DASHBOARD_GASTOS"
    }),
    'permission.PERMISOS_LISTAR': defineMessage({
        id: 'permission.PERMISOS_LISTAR',
        defaultMessage: "PERMISOS_LISTAR"
    }),
    'permission.PERFILES_LISTAR': defineMessage({
        id: 'permission.PERFILES_LISTAR',
        defaultMessage: "PERFILES_LISTAR"
    }),
    'permission.PERFILES_CREAR': defineMessage({
        id: 'permission.PERFILES_CREAR',
        defaultMessage: "PERFILES_CREAR"
    }),
    'permission.PERFILES_DUPLICAR': defineMessage({
        id: 'permission.PERFILES_DUPLICAR',
        defaultMessage: "PERFILES_DUPLICAR"
    }),
    'permission.PERFILES_VISUALIZAR': defineMessage({
        id: 'permission.PERFILES_VISUALIZAR',
        defaultMessage: "PERFILES_VISUALIZAR"
    }),
    'permission.PERFILES_MODIFICAR': defineMessage({
        id: 'permission.PERFILES_MODIFICAR',
        defaultMessage: "PERFILES_MODIFICAR"
    }),
    'permission.PERFILES_ELIMINAR': defineMessage({
        id: 'permission.PERFILES_ELIMINAR',
        defaultMessage: "PERFILES_ELIMINAR"
    }),
    'permission.PERSONAS_LISTAR': defineMessage({
        id: 'permission.PERSONAS_LISTAR',
        defaultMessage: "PERSONAS_LISTAR"
    }),
    'permission.PERSONAS_CREAR': defineMessage({
        id: 'permission.PERSONAS_CREAR',
        defaultMessage: "PERSONAS_CREAR"
    }),
    'permission.PERSONAS_VISUALIZAR': defineMessage({
        id: 'permission.PERSONAS_VISUALIZAR',
        defaultMessage: "PERSONAS_VISUALIZAR"
    }),
    'permission.PERSONAS_MODIFICAR': defineMessage({
        id: 'permission.PERSONAS_MODIFICAR',
        defaultMessage: "PERSONAS_MODIFICAR"
    }),
    'permission.PERSONAS_BLANQUEAR_CLAVE': defineMessage({
        id: 'permission.PERSONAS_BLANQUEAR_CLAVE',
        defaultMessage: "PERSONAS_BLANQUEAR_CLAVE"
    }),
    'permission.MOVILES_LISTAR': defineMessage({
        id: 'permission.MOVILES_LISTAR',
        defaultMessage: "MOVILES_LISTAR"
    }),
    'permission.MOVILES_CREAR': defineMessage({
        id: 'permission.MOVILES_CREAR',
        defaultMessage: "MOVILES_CREAR"
    }),
    'permission.MOVILES_VISUALIZAR': defineMessage({
        id: 'permission.MOVILES_VISUALIZAR',
        defaultMessage: "MOVILES_VISUALIZAR"
    }),
    'permission.MOVILES_MODIFICAR': defineMessage({
        id: 'permission.MOVILES_MODIFICAR',
        defaultMessage: "MOVILES_MODIFICAR"
    }),
    'permission.MOVILES_CHOFERES_HISTORICO_LISTAR': defineMessage({
        id: 'permission.MOVILES_CHOFERES_HISTORICO_LISTAR',
        defaultMessage: "MOVILES_CHOFERES_HISTORICO_LISTAR"
    }),
    'permission.MOVILES_CECOS_HISTORICO_LISTAR': defineMessage({
        id: 'permission.MOVILES_CECOS_HISTORICO_LISTAR',
        defaultMessage: "MOVILES_CECOS_HISTORICO_LISTAR"
    }),
    'permission.MOVILES_GUARDA_HISTORICO_LISTAR': defineMessage({
        id: 'permission.MOVILES_GUARDA_HISTORICO_LISTAR',
        defaultMessage: "MOVILES_GUARDA_HISTORICO_LISTAR"
    }),
    'permission.MOVILES_MODIFICAR_KM': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_KM',
        defaultMessage: "MOVILES_MODIFICAR_KM"
    }),
    'permission.MOVILES_MODIFICAR_DATOS_GENERALES': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_DATOS_GENERALES',
        defaultMessage: "MOVILES_MODIFICAR_DATOS_GENERALES"
    }),
    'permission.MOVILES_MODIFICAR_CHOFERES': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_CHOFERES',
        defaultMessage: "MOVILES_MODIFICAR_CHOFERES"
    }),
    'permission.MOVILES_MODIFICAR_ADMINISTRACION': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_ADMINISTRACION',
        defaultMessage: "MOVILES_MODIFICAR_ADMINISTRACION"
    }),
    'permission.MOVILES_REASIGNAR_CC_SIN_RESTRICCION': defineMessage({
        id: 'permission.MOVILES_REASIGNAR_CC_SIN_RESTRICCION',
        defaultMessage: "MOVILES_REASIGNAR_CC_SIN_RESTRICCION"
    }),
    'permission.MOVILES_MODIFICAR_DIMENSIONES': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_DIMENSIONES',
        defaultMessage: "MOVILES_MODIFICAR_DIMENSIONES"
    }),
    'permission.MOVILES_MODIFICAR_LUGAR_GUARDA': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_LUGAR_GUARDA',
        defaultMessage: "MOVILES_MODIFICAR_LUGAR_GUARDA"
    }),
    'permission.MOVILES_MODIFICAR_EQUIPAMIENTO': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_EQUIPAMIENTO',
        defaultMessage: "MOVILES_MODIFICAR_EQUIPAMIENTO"
    }),
    'permission.MOVILES_MODIFICAR_MANTENIMIENTO': defineMessage({
        id: 'permission.MOVILES_MODIFICAR_MANTENIMIENTO',
        defaultMessage: "MOVILES_MODIFICAR_MANTENIMIENTO"
    }),
    'permission.MOVILES_CANCELAR_TICKETS_GESTORIA': defineMessage({
        id: 'permission.MOVILES_CANCELAR_TICKETS_GESTORIA',
        defaultMessage: "MOVILES_CANCELAR_TICKETS_GESTORIA"
    }),
    'permission.MOVILES_LISTAR_TODOS_LOS_CHOFERES': defineMessage({
        id: 'permission.MOVILES_LISTAR_TODOS_LOS_CHOFERES',
        defaultMessage: "MOVILES_LISTAR_TODOS_LOS_CHOFERES"
    }),
    'permission.MOVILES_VISUALIZAR_ATRIBUTOS_CONTRATO': defineMessage({
        id: 'permission.MOVILES_VISUALIZAR_ATRIBUTOS_CONTRATO',
        defaultMessage: "MOVILES_VISUALIZAR_ATRIBUTOS_CONTRATO"
    }),
    'permission.MOVILES_EXPORTAR_COSTO_PREVENTIVO': defineMessage({
        id: 'permission.MOVILES_EXPORTAR_COSTO_PREVENTIVO',
        defaultMessage: "MOVILES_EXPORTAR_COSTO_PREVENTIVO"
    }),
    'permission.MOVILES_EXPORTAR_COSTO_COMBUSTIBLES': defineMessage({
        id: 'permission.MOVILES_EXPORTAR_COSTO_COMBUSTIBLES',
        defaultMessage: "MOVILES_EXPORTAR_COSTO_COMBUSTIBLES"
    }),
    'permission.MOVILES_EXPORTAR_COSTO_CORRECTIVOS': defineMessage({
        id: 'permission.MOVILES_EXPORTAR_COSTO_CORRECTIVOS',
        defaultMessage: "MOVILES_EXPORTAR_COSTO_CORRECTIVOS"
    }),
    'permission.MOVILES_EXPORTAR_COSTO_VENCIMIENTOS': defineMessage({
        id: 'permission.MOVILES_EXPORTAR_COSTO_VENCIMIENTOS',
        defaultMessage: "MOVILES_EXPORTAR_COSTO_VENCIMIENTOS"
    }),
    'permission.MOVILES_EXPORTAR_COSTO_GESTORIA': defineMessage({
        id: 'permission.MOVILES_EXPORTAR_COSTO_GESTORIA',
        defaultMessage: "MOVILES_EXPORTAR_COSTO_GESTORIA"
    }),
    'permission.MOVILES_EXPORTAR_COSTO_INFRACCIONES': defineMessage({
        id: 'permission.MOVILES_EXPORTAR_COSTO_INFRACCIONES',
        defaultMessage: "MOVILES_EXPORTAR_COSTO_INFRACCIONES"
    }),
    'permission.MOVILES_DATOS_GENERALES_HISTORICO_LISTAR': defineMessage({
        id: 'permission.MOVILES_DATOS_GENERALES_HISTORICO_LISTAR',
        defaultMessage: "MOVILES_DATOS_GENERALES_HISTORICO_LISTAR"
    }),
    'permission.LLANTAS_LISTAR': defineMessage({
        id: 'permission.LLANTAS_LISTAR',
        defaultMessage: "LLANTAS_LISTAR"
    }),
    'permission.LLANTAS_CREAR': defineMessage({
        id: 'permission.LLANTAS_CREAR',
        defaultMessage: "LLANTAS_CREAR"
    }),
    'permission.LLANTAS_VISUALIZAR': defineMessage({
        id: 'permission.LLANTAS_VISUALIZAR',
        defaultMessage: "LLANTAS_VISUALIZAR"
    }),
    'permission.LLANTAS_VISUALIZAR_ODOMETRO': defineMessage({
        id: 'permission.LLANTAS_VISUALIZAR_ODOMETRO',
        defaultMessage: "LLANTAS_VISUALIZAR_ODOMETRO"
    }),
    'permission.LLANTAS_ELIMINAR': defineMessage({
        id: 'permission.LLANTAS_ELIMINAR',
        defaultMessage: "LLANTAS_ELIMINAR"
    }),
    'permission.LLANTAS_MODIFICAR': defineMessage({
        id: 'permission.LLANTAS_MODIFICAR',
        defaultMessage: "LLANTAS_MODIFICAR"
    }),
    'permission.LLANTAS_ODOMETRO_MODIFICAR': defineMessage({
        id: 'permission.LLANTAS_ODOMETRO_MODIFICAR',
        defaultMessage: "LLANTAS_ODOMETRO_MODIFICAR"
    }),
    'permission.LLANTAS_MODELOS_VISUALIZAR': defineMessage({
        id: 'permission.LLANTAS_MODELOS_VISUALIZAR',
        defaultMessage: "LLANTAS_MODELOS_VISUALIZAR"
    }),
    'permission.LLANTAS_MODELOS_LISTAR': defineMessage({
        id: 'permission.LLANTAS_MODELOS_LISTAR',
        defaultMessage: "LLANTAS_MODELOS_LISTAR"
    }),
    'permission.LLANTAS_MODELOS_CREAR': defineMessage({
        id: 'permission.LLANTAS_MODELOS_CREAR',
        defaultMessage: "LLANTAS_MODELOS_CREAR"
    }),
    'permission.LLANTAS_MODELOS_MODIFICAR': defineMessage({
        id: 'permission.LLANTAS_MODELOS_MODIFICAR',
        defaultMessage: "LLANTAS_MODELOS_MODIFICAR"
    }),
    'permission.LLANTAS_MODELOS_ELIMINAR': defineMessage({
        id: 'permission.LLANTAS_MODELOS_ELIMINAR',
        defaultMessage: "LLANTAS_MODELOS_ELIMINAR"
    }),
    'permission.LLANTAS_MARCAS_VISUALIZAR': defineMessage({
        id: 'permission.LLANTAS_MARCAS_VISUALIZAR',
        defaultMessage: "LLANTAS_MARCAS_VISUALIZAR"
    }),
    'permission.LLANTAS_MARCAS_LISTAR': defineMessage({
        id: 'permission.LLANTAS_MARCAS_LISTAR',
        defaultMessage: "LLANTAS_MARCAS_LISTAR"
    }),
    'permission.LLANTAS_MARCAS_CREAR': defineMessage({
        id: 'permission.LLANTAS_MARCAS_CREAR',
        defaultMessage: "LLANTAS_MARCAS_CREAR"
    }),
    'permission.LLANTAS_MARCAS_MODIFICAR': defineMessage({
        id: 'permission.LLANTAS_MARCAS_MODIFICAR',
        defaultMessage: "LLANTAS_MARCAS_MODIFICAR"
    }),
    'permission.LLANTAS_MARCAS_ELIMINAR': defineMessage({
        id: 'permission.LLANTAS_MARCAS_ELIMINAR',
        defaultMessage: "LLANTAS_MARCAS_ELIMINAR"
    }),
    'permission.LLANTAS_INSPECCIONES_VISUALIZAR': defineMessage({
        id: 'permission.LLANTAS_INSPECCIONES_VISUALIZAR',
        defaultMessage: "LLANTAS_INSPECCIONES_VISUALIZAR"
    }),
    'permission.LLANTAS_INSPECCIONES_LISTAR': defineMessage({
        id: 'permission.LLANTAS_INSPECCIONES_LISTAR',
        defaultMessage: "LLANTAS_INSPECCIONES_LISTAR"
    }),
    'permission.LLANTAS_INSPECCIONES_CREAR': defineMessage({
        id: 'permission.LLANTAS_INSPECCIONES_CREAR',
        defaultMessage: "LLANTAS_INSPECCIONES_CREAR"
    }),
    'permission.LLANTAS_INSPECCIONES_MODIFICAR': defineMessage({
        id: 'permission.LLANTAS_INSPECCIONES_MODIFICAR',
        defaultMessage: "LLANTAS_INSPECCIONES_MODIFICAR"
    }),
    'permission.LLANTAS_INSPECCIONES_ELIMINAR': defineMessage({
        id: 'permission.LLANTAS_INSPECCIONES_ELIMINAR',
        defaultMessage: "LLANTAS_INSPECCIONES_ELIMINAR"
    }),
    'permission.LLANTAS_ASIGNACIONES_LISTAR': defineMessage({
        id: 'permission.LLANTAS_ASIGNACIONES_LISTAR',
        defaultMessage: "LLANTAS_ASIGNACIONES_LISTAR"
    }),
    'permission.LLANTAS_MANTENIMIENTOS_CORRECTIVOS_CREAR': defineMessage({
        id: 'permission.LLANTAS_MANTENIMIENTOS_CORRECTIVOS_CREAR',
        defaultMessage: "LLANTAS_MANTENIMIENTOS_CORRECTIVOS_CREAR"
    }),
    'permission.LLANTAS_ODOMETRO_VISUALIZAR': defineMessage({
        id: 'permission.LLANTAS_ODOMETRO_VISUALIZAR',
        defaultMessage: "LLANTAS_ODOMETRO_VISUALIZAR"
    }),
    'permission.LLANTAS_SIN_NECESIDAD_REEMPLAZO': defineMessage({
        id: 'permission.LLANTAS_SIN_NECESIDAD_REEMPLAZO',
        defaultMessage: "LLANTAS_SIN_NECESIDAD_REEMPLAZO"
    }),
    'permission.USUARIO_VER_TODAS_LAS_LLANTAS': defineMessage({
        id: 'permission.USUARIO_VER_TODAS_LAS_LLANTAS',
        defaultMessage: "USUARIO_VER_TODAS_LAS_LLANTAS"
    }),
    'permission.MARCAS_LISTAR': defineMessage({
        id: 'permission.MARCAS_LISTAR',
        defaultMessage: "MARCAS_LISTAR"
    }),
    'permission.MARCAS_CREAR': defineMessage({
        id: 'permission.MARCAS_CREAR',
        defaultMessage: "MARCAS_CREAR"
    }),
    'permission.MARCAS_VISUALIZAR': defineMessage({
        id: 'permission.MARCAS_VISUALIZAR',
        defaultMessage: "MARCAS_VISUALIZAR"
    }),
    'permission.MARCAS_MODIFICAR': defineMessage({
        id: 'permission.MARCAS_MODIFICAR',
        defaultMessage: "MARCAS_MODIFICAR"
    }),
    'permission.MODELOS_LISTAR': defineMessage({
        id: 'permission.MODELOS_LISTAR',
        defaultMessage: "MODELOS_LISTAR"
    }),
    'permission.MODELOS_CREAR': defineMessage({
        id: 'permission.MODELOS_CREAR',
        defaultMessage: "MODELOS_CREAR"
    }),
    'permission.MODELOS_VISUALIZAR': defineMessage({
        id: 'permission.MODELOS_VISUALIZAR',
        defaultMessage: "MODELOS_VISUALIZAR"
    }),
    'permission.MODELOS_MODIFICAR': defineMessage({
        id: 'permission.MODELOS_MODIFICAR',
        defaultMessage: "MODELOS_MODIFICAR"
    }),
    'permission.MODELOS_ELIMINAR': defineMessage({
        id: 'permission.MODELOS_ELIMINAR',
        defaultMessage: "MODELOS_ELIMINAR"
    }),
    'permission.MODELO_TIPOS_LISTAR': defineMessage({
        id: 'permission.MODELO_TIPOS_LISTAR',
        defaultMessage: "MODELO_TIPOS_LISTAR"
    }),
    'permission.MODELO_TIPOS_CREAR': defineMessage({
        id: 'permission.MODELO_TIPOS_CREAR',
        defaultMessage: "MODELO_TIPOS_CREAR"
    }),
    'permission.MODELO_TIPOS_VISUALIZAR': defineMessage({
        id: 'permission.MODELO_TIPOS_VISUALIZAR',
        defaultMessage: "MODELO_TIPOS_VISUALIZAR"
    }),
    'permission.MODELO_TIPOS_MODIFICAR': defineMessage({
        id: 'permission.MODELO_TIPOS_MODIFICAR',
        defaultMessage: "MODELO_TIPOS_MODIFICAR"
    }),
    'permission.MODELO_TIPOS_ELIMINAR': defineMessage({
        id: 'permission.MODELO_TIPOS_ELIMINAR',
        defaultMessage: "MODELO_TIPOS_ELIMINAR"
    }),
    'permission.EQUIPAMIENTO_TIPOS_LISTAR': defineMessage({
        id: 'permission.EQUIPAMIENTO_TIPOS_LISTAR',
        defaultMessage: "EQUIPAMIENTO_TIPOS_LISTAR"
    }),
    'permission.EQUIPAMIENTO_TIPOS_CREAR': defineMessage({
        id: 'permission.EQUIPAMIENTO_TIPOS_CREAR',
        defaultMessage: "EQUIPAMIENTO_TIPOS_CREAR"
    }),
    'permission.EQUIPAMIENTO_TIPOS_VISUALIZAR': defineMessage({
        id: 'permission.EQUIPAMIENTO_TIPOS_VISUALIZAR',
        defaultMessage: "EQUIPAMIENTO_TIPOS_VISUALIZAR"
    }),
    'permission.EQUIPAMIENTO_TIPOS_MODIFICAR': defineMessage({
        id: 'permission.EQUIPAMIENTO_TIPOS_MODIFICAR',
        defaultMessage: "EQUIPAMIENTO_TIPOS_MODIFICAR"
    }),
    'permission.EQUIPAMIENTO_LISTAR': defineMessage({
        id: 'permission.EQUIPAMIENTO_LISTAR',
        defaultMessage: "EQUIPAMIENTO_LISTAR"
    }),
    'permission.EQUIPAMIENTO_CREAR': defineMessage({
        id: 'permission.EQUIPAMIENTO_CREAR',
        defaultMessage: "EQUIPAMIENTO_CREAR"
    }),
    'permission.EQUIPAMIENTO_VISUALIZAR': defineMessage({
        id: 'permission.EQUIPAMIENTO_VISUALIZAR',
        defaultMessage: "EQUIPAMIENTO_VISUALIZAR"
    }),
    'permission.CHECKLIST_LISTAR': defineMessage({
        id: 'permission.CHECKLIST_LISTAR',
        defaultMessage: "CHECKLIST_LISTAR"
    }),
    'permission.CHECKLIST_LISTAR_HISTORICO': defineMessage({
        id: 'permission.CHECKLIST_LISTAR_HISTORICO',
        defaultMessage: "CHECKLIST_LISTAR_HISTORICO"
    }),
    'permission.CHECKLIST_LISTAR_TIPO_FORMULARIOS': defineMessage({
        id: 'permission.CHECKLIST_LISTAR_TIPO_FORMULARIOS',
        defaultMessage: "CHECKLIST_LISTAR_TIPO_FORMULARIOS"
    }),
    'permission.CHECKLIST_CREAR_TIPO_FORMULARIOS': defineMessage({
        id: 'permission.CHECKLIST_CREAR_TIPO_FORMULARIOS',
        defaultMessage: "CHECKLIST_CREAR_TIPO_FORMULARIOS"
    }),
    'permission.CHECKLIST_EDITAR_TIPO_FORMULARIOS': defineMessage({
        id: 'permission.CHECKLIST_EDITAR_TIPO_FORMULARIOS',
        defaultMessage: "CHECKLIST_EDITAR_TIPO_FORMULARIOS"
    }),
    'permission.CHECKLIST_VISUALIZAR_TIPO_FORMULARIOS': defineMessage({
        id: 'permission.CHECKLIST_VISUALIZAR_TIPO_FORMULARIOS',
        defaultMessage: "CHECKLIST_VISUALIZAR_TIPO_FORMULARIOS"
    }),
    'permission.CHECKLIST_CREAR_HISTORICO': defineMessage({
        id: 'permission.CHECKLIST_CREAR_HISTORICO',
        defaultMessage: "CHECKLIST_CREAR_HISTORICO"
    }),
    'permission.CHECKLIST_EDITAR_HISTORICO': defineMessage({
        id: 'permission.CHECKLIST_EDITAR_HISTORICO',
        defaultMessage: "CHECKLIST_EDITAR_HISTORICO"
    }),
    'permission.CHECKLIST_VALIDAR_HISTORICO': defineMessage({
        id: 'permission.CHECKLIST_VALIDAR_HISTORICO',
        defaultMessage: "CHECKLIST_VALIDAR_HISTORICO"
    }),
    'permission.CHECKLIST_VISUALIZAR_HISTORICO': defineMessage({
        id: 'permission.CHECKLIST_VISUALIZAR_HISTORICO',
        defaultMessage: "CHECKLIST_VISUALIZAR_HISTORICO"
    }),
    'permission.CHECKLIST_COMENTAR': defineMessage({
        id: 'permission.CHECKLIST_COMENTAR',
        defaultMessage: "CHECKLIST_COMENTAR"
    }),
    'permission.BASES_LISTAR': defineMessage({
        id: 'permission.BASES_LISTAR',
        defaultMessage: "BASES_LISTAR"
    }),
    'permission.BASES_CREAR': defineMessage({
        id: 'permission.BASES_CREAR',
        defaultMessage: "BASES_CREAR"
    }),
    'permission.BASES_VISUALIZAR': defineMessage({
        id: 'permission.BASES_VISUALIZAR',
        defaultMessage: "BASES_VISUALIZAR"
    }),
    'permission.BASES_MODIFICAR': defineMessage({
        id: 'permission.BASES_MODIFICAR',
        defaultMessage: "BASES_MODIFICAR"
    }),
    'permission.BASES_MODIFICAR_INFORMACION_COMPLEMENTARIA': defineMessage({
        id: 'permission.BASES_MODIFICAR_INFORMACION_COMPLEMENTARIA',
        defaultMessage: "BASES_MODIFICAR_INFORMACION_COMPLEMENTARIA"
    }),
    'permission.USUARIO_TRABAJAR_VEHICULOS': defineMessage({
        id: 'permission.USUARIO_TRABAJAR_VEHICULOS',
        defaultMessage: "USUARIO_TRABAJAR_VEHICULOS"
    }),
    'permission.USUARIO_TRABAJA_CIADEORIGEN': defineMessage({
        id: 'permission.USUARIO_TRABAJA_CIADEORIGEN',
        defaultMessage: "USUARIO_TRABAJA_CIADEORIGEN"
    }),
    'permission.GERENCIADORES_LISTAR': defineMessage({
        id: 'permission.GERENCIADORES_LISTAR',
        defaultMessage: "GERENCIADORES_LISTAR"
    }),
    'permission.GERENCIADORES_CREAR': defineMessage({
        id: 'permission.GERENCIADORES_CREAR',
        defaultMessage: "GERENCIADORES_CREAR"
    }),
    'permission.GERENCIADORES_VISUALIZAR': defineMessage({
        id: 'permission.GERENCIADORES_VISUALIZAR',
        defaultMessage: "GERENCIADORES_VISUALIZAR"
    }),
    'permission.GERENCIADORES_MODIFICAR': defineMessage({
        id: 'permission.GERENCIADORES_MODIFICAR',
        defaultMessage: "GERENCIADORES_MODIFICAR"
    }),
    'permission.GERENCIADORES_ELIMINAR': defineMessage({
        id: 'permission.GERENCIADORES_ELIMINAR',
        defaultMessage: "GERENCIADORES_ELIMINAR"
    }),
    'permission.MANTENIMIENTOS_CORRECTIVOS_CREAR': defineMessage({
        id: 'permission.MANTENIMIENTOS_CORRECTIVOS_CREAR',
        defaultMessage: "MANTENIMIENTOS_CORRECTIVOS_CREAR"
    }),
    'permission.DASHBOARD_OPERATIVO_VISUALIZAR': defineMessage({
        id: 'permission.DASHBOARD_OPERATIVO_VISUALIZAR',
        defaultMessage: "DASHBOARD_OPERATIVO_VISUALIZAR"
    }),
    'permission.DASHBOARD_OPERATIVO2_VISUALIZAR': defineMessage({
        id: 'permission.DASHBOARD_OPERATIVO2_VISUALIZAR',
        defaultMessage: "DASHBOARD_OPERATIVO2_VISUALIZAR"
    }),
    'permission.DASHBOARD_ANALITICO_VISUALIZAR': defineMessage({
        id: 'permission.DASHBOARD_ANALITICO_VISUALIZAR',
        defaultMessage: "DASHBOARD_ANALITICO_VISUALIZAR"
    }),
    'permission.USUARIO_POSEER_MOVIL': defineMessage({
        id: 'permission.USUARIO_POSEER_MOVIL',
        defaultMessage: "USUARIO_POSEER_MOVIL"
    }),
    'permission.USUARIO_ACTUAR_COMO_GERENCIADOR': defineMessage({
        id: 'permission.USUARIO_ACTUAR_COMO_GERENCIADOR',
        defaultMessage: "USUARIO_ACTUAR_COMO_GERENCIADOR"
    }),
    'permission.USUARIO_TRABAJAR_BASES': defineMessage({
        id: 'permission.USUARIO_TRABAJAR_BASES',
        defaultMessage: "USUARIO_TRABAJAR_BASES"
    }),
    'permission.USUARIO_VER_TODOS_LOS_MOVILES': defineMessage({
        id: 'permission.USUARIO_VER_TODOS_LOS_MOVILES',
        defaultMessage: "USUARIO_VER_TODOS_LOS_MOVILES"
    }),
    'permission.USUARIO_VER_TODOS_LOS_TICKETS': defineMessage({
        id: 'permission.USUARIO_VER_TODOS_LOS_TICKETS',
        defaultMessage: "USUARIO_VER_TODOS_LOS_TICKETS"
    }),
    'permission.USUARIO_TRABAJAR_CON_TODAS_LAS_BASES': defineMessage({
        id: 'permission.USUARIO_TRABAJAR_CON_TODAS_LAS_BASES',
        defaultMessage: "USUARIO_TRABAJAR_CON_TODAS_LAS_BASES"
    }),
    'permission.USUARIO_FLOTA_OPERACIONES': defineMessage({
        id: 'permission.USUARIO_FLOTA_OPERACIONES',
        defaultMessage: "USUARIO_FLOTA_OPERACIONES"
    }),
    'permission.USUARIO_SUPERADMIN': defineMessage({
        id: 'permission.USUARIO_SUPERADMIN',
        defaultMessage: "USUARIO_SUPERADMIN"
    }),
    'permission.USUARIO_VER_TODOS_LAS_PERSONAS': defineMessage({
        id: 'permission.USUARIO_VER_TODOS_LAS_PERSONAS',
        defaultMessage: "USUARIO_VER_TODOS_LAS_PERSONAS"
    }),
    'permission.USUARIO_TRABAJAR_CC': defineMessage({
        id: 'permission.USUARIO_TRABAJAR_CC',
        defaultMessage: "USUARIO_TRABAJAR_CC"
    }),
    'permission.USUARIO_TRABAJAR_FACTURACION': defineMessage({
        id: 'permission.USUARIO_TRABAJAR_FACTURACION',
        defaultMessage: "USUARIO_TRABAJAR_FACTURACION"
    }),
    'permission.USUARIO_EDITAR_SYNC': defineMessage({
        id: 'permission.USUARIO_EDITAR_SYNC',
        defaultMessage: "USUARIO_EDITAR_SYNC"
    }),
    'permission.ES_RESPONSABLE_MOVIL': defineMessage({
        id: 'permission.ES_RESPONSABLE_MOVIL',
        defaultMessage: "ES_RESPONSABLE_MOVIL"
    }),
    'permission.ES_SUPERVISOR_MOVIL': defineMessage({
        id: 'permission.ES_SUPERVISOR_MOVIL',
        defaultMessage: "ES_SUPERVISOR_MOVIL"
    }),
    'permission.TICKETS_APROBAR_AUDITOR': defineMessage({
        id: 'permission.TICKETS_APROBAR_AUDITOR',
        defaultMessage: "TICKETS_APROBAR_AUDITOR"
    }),
    'permission.TICKETS_A_RECOTIZAR_AUDITOR': defineMessage({
        id: 'permission.TICKETS_A_RECOTIZAR_AUDITOR',
        defaultMessage: "TICKETS_A_RECOTIZAR_AUDITOR"
    }),
    'permission.TICKETS_LISTAR': defineMessage({
        id: 'permission.TICKETS_LISTAR',
        defaultMessage: "TICKETS_LISTAR"
    }),
    'permission.TICKETS_VISUALIZAR': defineMessage({
        id: 'permission.TICKETS_VISUALIZAR',
        defaultMessage: "TICKETS_VISUALIZAR"
    }),
    'permission.TICKETS_VER_HISTORIA': defineMessage({
        id: 'permission.TICKETS_VER_HISTORIA',
        defaultMessage: "TICKETS_VER_HISTORIA"
    }),
    'permission.TICKETS_VER_OTROS_TICKETS': defineMessage({
        id: 'permission.TICKETS_VER_OTROS_TICKETS',
        defaultMessage: "TICKETS_VER_OTROS_TICKETS"
    }),
    'permission.TICKETS_VER_INFORMACION': defineMessage({
        id: 'permission.TICKETS_VER_INFORMACION',
        defaultMessage: "TICKETS_VER_INFORMACION"
    }),
    'permission.TICKETS_VER_TAREAS': defineMessage({
        id: 'permission.TICKETS_VER_TAREAS',
        defaultMessage: "TICKETS_VER_TAREAS"
    }),
    'permission.TICKETS_CARGAR_PRESUPUESTO': defineMessage({
        id: 'permission.TICKETS_CARGAR_PRESUPUESTO',
        defaultMessage: "TICKETS_CARGAR_PRESUPUESTO"
    }),
    'permission.TICKETS_VER_PRESUPUESTOS': defineMessage({
        id: 'permission.TICKETS_VER_PRESUPUESTOS',
        defaultMessage: "TICKETS_VER_PRESUPUESTOS"
    }),
    'permission.TICKETS_COMENTAR': defineMessage({
        id: 'permission.TICKETS_COMENTAR',
        defaultMessage: "TICKETS_COMENTAR"
    }),
    'permission.TICKETS_CERRAR_PREVENTIVOS': defineMessage({
        id: 'permission.TICKETS_CERRAR_PREVENTIVOS',
        defaultMessage: "TICKETS_CERRAR_PREVENTIVOS"
    }),
    'permission.TICKETS_CERRAR_CORRECTIVOS': defineMessage({
        id: 'permission.TICKETS_CERRAR_CORRECTIVOS',
        defaultMessage: "TICKETS_CERRAR_CORRECTIVOS"
    }),
    'permission.TICKETS_CERRAR_VENCIMIENTOS': defineMessage({
        id: 'permission.TICKETS_CERRAR_VENCIMIENTOS',
        defaultMessage: "TICKETS_CERRAR_VENCIMIENTOS"
    }),
    'permission.TICKETS_CANCELAR_PREVENTIVOS': defineMessage({
        id: 'permission.TICKETS_CANCELAR_PREVENTIVOS',
        defaultMessage: "TICKETS_CANCELAR_PREVENTIVOS"
    }),
    'permission.TICKETS_CANCELAR_CORRECTIVOS': defineMessage({
        id: 'permission.TICKETS_CANCELAR_CORRECTIVOS',
        defaultMessage: "TICKETS_CANCELAR_CORRECTIVOS"
    }),
    'permission.TICKETS_CANCELAR_VENCIMIENTOS': defineMessage({
        id: 'permission.TICKETS_CANCELAR_VENCIMIENTOS',
        defaultMessage: "TICKETS_CANCELAR_VENCIMIENTOS"
    }),
    'permission.TICKETS_ASIGNAR': defineMessage({
        id: 'permission.TICKETS_ASIGNAR',
        defaultMessage: "TICKETS_ASIGNAR"
    }),
    'permission.TICKETS_PRESUPUESTAR': defineMessage({
        id: 'permission.TICKETS_PRESUPUESTAR',
        defaultMessage: "TICKETS_PRESUPUESTAR"
    }),
    'permission.TICKETS_APROBAR': defineMessage({
        id: 'permission.TICKETS_APROBAR',
        defaultMessage: "TICKETS_APROBAR"
    }),
    'permission.TICKETS_RECOTIZAR': defineMessage({
        id: 'permission.TICKETS_RECOTIZAR',
        defaultMessage: "TICKETS_RECOTIZAR"
    }),
    'permission.TICKETS_PASAR_LISTO_PARA_RETIRAR': defineMessage({
        id: 'permission.TICKETS_PASAR_LISTO_PARA_RETIRAR',
        defaultMessage: "TICKETS_PASAR_LISTO_PARA_RETIRAR"
    }),
    'permission.TICKETS_COTIZAR_ADICIONAL': defineMessage({
        id: 'permission.TICKETS_COTIZAR_ADICIONAL',
        defaultMessage: "TICKETS_COTIZAR_ADICIONAL"
    }),
    'permission.TICKETS_PRESUPUESTO_CARGA_REPUESTO_INICIAL': defineMessage({
        id: 'permission.TICKETS_PRESUPUESTO_CARGA_REPUESTO_INICIAL',
        defaultMessage: "TICKETS_PRESUPUESTO_CARGA_REPUESTO_INICIAL"
    }),
    'permission.TICKETS_PRESUPUESTO_CARGA_REPUESTO_ADICIONAL': defineMessage({
        id: 'permission.TICKETS_PRESUPUESTO_CARGA_REPUESTO_ADICIONAL',
        defaultMessage: "TICKETS_PRESUPUESTO_CARGA_REPUESTO_ADICIONAL"
    }),
    'permission.TICKETS_PRESUPUESTO_CARGA_MO_INICIAL': defineMessage({
        id: 'permission.TICKETS_PRESUPUESTO_CARGA_MO_INICIAL',
        defaultMessage: "TICKETS_PRESUPUESTO_CARGA_MO_INICIAL"
    }),
    'permission.TICKETS_PRESUPUESTO_CARGA_MO_ADICIONAL': defineMessage({
        id: 'permission.TICKETS_PRESUPUESTO_CARGA_MO_ADICIONAL',
        defaultMessage: "TICKETS_PRESUPUESTO_CARGA_MO_ADICIONAL"
    }),
    'permission.TICKETS_MODIFICAR_FECHA_REALIZADO': defineMessage({
        id: 'permission.TICKETS_MODIFICAR_FECHA_REALIZADO',
        defaultMessage: "TICKETS_MODIFICAR_FECHA_REALIZADO"
    }),
    'permission.TICKETS_MODIFICAR_GERENCIADOR': defineMessage({
        id: 'permission.TICKETS_MODIFICAR_GERENCIADOR',
        defaultMessage: "TICKETS_MODIFICAR_GERENCIADOR"
    }),
    'permission.TICKETS_MODIFICAR_TALLER': defineMessage({
        id: 'permission.TICKETS_MODIFICAR_TALLER',
        defaultMessage: "TICKETS_MODIFICAR_TALLER"
    }),
    'permission.TICKETS_MODIFICAR_EN_TALLER': defineMessage({
        id: 'permission.TICKETS_MODIFICAR_EN_TALLER',
        defaultMessage: "TICKETS_MODIFICAR_EN_TALLER"
    }),
    'permission.TICKETS_MODIFICAR_PRESUPUESTADOS': defineMessage({
        id: 'permission.TICKETS_MODIFICAR_PRESUPUESTADOS',
        defaultMessage: "TICKETS_MODIFICAR_PRESUPUESTADOS"
    }),
    'permission.TICKETS_CONFIRMAR_REPARACION': defineMessage({
        id: 'permission.TICKETS_CONFIRMAR_REPARACION',
        defaultMessage: "TICKETS_CONFIRMAR_REPARACION"
    }),
    'permission.TICKETS_ENVIAR_A_REPARAR': defineMessage({
        id: 'permission.TICKETS_ENVIAR_A_REPARAR',
        defaultMessage: "TICKETS_ENVIAR_A_REPARAR"
    }),
    'permission.TICKETS_APROBAR_ABONO': defineMessage({
        id: 'permission.TICKETS_APROBAR_ABONO',
        defaultMessage: "TICKETS_APROBAR_ABONO"
    }),
    'permission.TICKETS_RECHAZAR_ABONO': defineMessage({
        id: 'permission.TICKETS_RECHAZAR_ABONO',
        defaultMessage: "TICKETS_RECHAZAR_ABONO"
    }),
    'permission.TICKETS_PERSONA_LISTAR': defineMessage({
        id: 'permission.TICKETS_PERSONA_LISTAR',
        defaultMessage: "TICKETS_PERSONA_LISTAR"
    }),
    'permission.TICKETS_MOVIL_LISTAR': defineMessage({
        id: 'permission.TICKETS_MOVIL_LISTAR',
        defaultMessage: "TICKETS_MOVIL_LISTAR"
    }),
    'permission.TICKETS_SINIESTRO_MODIFICAR': defineMessage({
        id: 'permission.TICKETS_SINIESTRO_MODIFICAR',
        defaultMessage: "TICKETS_SINIESTRO_MODIFICAR"
    }),
    'permission.TICKETS_RECOTIZAR_AUDITOR': defineMessage({
        id: 'permission.TICKETS_RECOTIZAR_AUDITOR',
        defaultMessage: "TICKETS_RECOTIZAR_AUDITOR"
    }),
    'permission.TICKETS_EDITAR_CENTRO_COSTOS': defineMessage({
        id: 'permission.TICKETS_EDITAR_CENTRO_COSTOS',
        defaultMessage: "TICKETS_EDITAR_CENTRO_COSTOS"
    }),
    'permission.TICKETS_CREAR': defineMessage({
        id: 'permission.TICKETS_CREAR',
        defaultMessage: "TICKETS_CREAR"
    }),
    'permission.TICKETS_GESTORIA_CREAR': defineMessage({
        id: 'permission.TICKETS_GESTORIA_CREAR',
        defaultMessage: "TICKETS_GESTORIA_CREAR"
    }),
    'permission.TICKETS_EDITAR_KM_REALIZADO': defineMessage({
        id: 'permission.TICKETS_EDITAR_KM_REALIZADO',
        defaultMessage: "TICKETS_EDITAR_KM_REALIZADO"
    }),
    'permission.TICKETS_VER_DETALLE_EAM': defineMessage({
        id: 'permission.TICKETS_VER_DETALLE_EAM',
        defaultMessage: "TICKETS_VER_DETALLE_EAM"
    }),
    'permission.TICKETS_EXPORTAR_HISTORICO': defineMessage({
        id: 'permission.TICKETS_EXPORTAR_HISTORICO',
        defaultMessage: "TICKETS_EXPORTAR_HISTORICO"
    }),
    'permission.PERMISO_APRO_N1': defineMessage({
        id: 'permission.PERMISO_APRO_N1',
        defaultMessage: "PERMISO_APRO_N1"
    }),
    'permission.PERMISO_APRO_N2': defineMessage({
        id: 'permission.PERMISO_APRO_N2',
        defaultMessage: "PERMISO_APRO_N2"
    }),
    'permission.PERMISO_APRO_N3': defineMessage({
        id: 'permission.PERMISO_APRO_N3',
        defaultMessage: "PERMISO_APRO_N3"
    }),
    'permission.VENCIMIENTOS_LISTAR': defineMessage({
        id: 'permission.VENCIMIENTOS_LISTAR',
        defaultMessage: "VENCIMIENTOS_LISTAR"
    }),
    'permission.VENCIMIENTOS_CREAR': defineMessage({
        id: 'permission.VENCIMIENTOS_CREAR',
        defaultMessage: "VENCIMIENTOS_CREAR"
    }),
    'permission.VENCIMIENTOS_VISUALIZAR': defineMessage({
        id: 'permission.VENCIMIENTOS_VISUALIZAR',
        defaultMessage: "VENCIMIENTOS_VISUALIZAR"
    }),
    'permission.VENCIMIENTOS_MODIFICAR': defineMessage({
        id: 'permission.VENCIMIENTOS_MODIFICAR',
        defaultMessage: "VENCIMIENTOS_MODIFICAR"
    }),
    'permission.VENCIMIENTOS_ELIMINAR': defineMessage({
        id: 'permission.VENCIMIENTOS_ELIMINAR',
        defaultMessage: "VENCIMIENTOS_ELIMINAR"
    }),
    'permission.VENCIMIENTOS_FORZAR': defineMessage({
        id: 'permission.VENCIMIENTOS_FORZAR',
        defaultMessage: "VENCIMIENTOS_FORZAR"
    }),
    'permission.VENCIMIENTOS_GENERAR': defineMessage({
        id: 'permission.VENCIMIENTOS_GENERAR',
        defaultMessage: "VENCIMIENTOS_GENERAR"
    }),
    'permission.VENCIMIENTOS_PERSONA_LISTAR': defineMessage({
        id: 'permission.VENCIMIENTOS_PERSONA_LISTAR',
        defaultMessage: "VENCIMIENTOS_PERSONA_LISTAR"
    }),
    'permission.VENCIMIENTOS_MOVIL_LISTAR': defineMessage({
        id: 'permission.VENCIMIENTOS_MOVIL_LISTAR',
        defaultMessage: "VENCIMIENTOS_MOVIL_LISTAR"
    }),
    'permission.PREVENTIVOS_LISTAR': defineMessage({
        id: 'permission.PREVENTIVOS_LISTAR',
        defaultMessage: "PREVENTIVOS_LISTAR"
    }),
    'permission.PREVENTIVOS_CREAR': defineMessage({
        id: 'permission.PREVENTIVOS_CREAR',
        defaultMessage: "PREVENTIVOS_CREAR"
    }),
    'permission.PREVENTIVOS_VISUALIZAR': defineMessage({
        id: 'permission.PREVENTIVOS_VISUALIZAR',
        defaultMessage: "PREVENTIVOS_VISUALIZAR"
    }),
    'permission.PREVENTIVOS_MODIFICAR': defineMessage({
        id: 'permission.PREVENTIVOS_MODIFICAR',
        defaultMessage: "PREVENTIVOS_MODIFICAR"
    }),
    'permission.PREVENTIVOS_ELIMINAR': defineMessage({
        id: 'permission.PREVENTIVOS_ELIMINAR',
        defaultMessage: "PREVENTIVOS_ELIMINAR"
    }),
    'permission.PREVENTIVOS_FORZAR': defineMessage({
        id: 'permission.PREVENTIVOS_FORZAR',
        defaultMessage: "PREVENTIVOS_FORZAR"
    }),
    'permission.PREVENTIVOS_GENERAR': defineMessage({
        id: 'permission.PREVENTIVOS_GENERAR',
        defaultMessage: "PREVENTIVOS_GENERAR"
    }),
    'permission.PREVENTIVOS_MOVIL_LISTAR': defineMessage({
        id: 'permission.PREVENTIVOS_MOVIL_LISTAR',
        defaultMessage: "PREVENTIVOS_MOVIL_LISTAR"
    }),
    'permission.PREVENTIVOS_IMPORTAR': defineMessage({
        id: 'permission.PREVENTIVOS_IMPORTAR',
        defaultMessage: "PREVENTIVOS_IMPORTAR"
    }),
    'permission.TAREAS_LISTAR': defineMessage({
        id: 'permission.TAREAS_LISTAR',
        defaultMessage: "TAREAS_LISTAR"
    }),
    'permission.TAREAS_CREAR': defineMessage({
        id: 'permission.TAREAS_CREAR',
        defaultMessage: "TAREAS_CREAR"
    }),
    'permission.TAREAS_VISUALIZAR': defineMessage({
        id: 'permission.TAREAS_VISUALIZAR',
        defaultMessage: "TAREAS_VISUALIZAR"
    }),
    'permission.TAREAS_MODIFICAR': defineMessage({
        id: 'permission.TAREAS_MODIFICAR',
        defaultMessage: "TAREAS_MODIFICAR"
    }),
    'permission.TAREAS_ELIMINAR': defineMessage({
        id: 'permission.TAREAS_ELIMINAR',
        defaultMessage: "TAREAS_ELIMINAR"
    }),
    'permission.SERVICIOS_LISTAR': defineMessage({
        id: 'permission.SERVICIOS_LISTAR',
        defaultMessage: "SERVICIOS_LISTAR"
    }),
    'permission.SERVICIOS_CREAR': defineMessage({
        id: 'permission.SERVICIOS_CREAR',
        defaultMessage: "SERVICIOS_CREAR"
    }),
    'permission.SERVICIOS_VISUALIZAR': defineMessage({
        id: 'permission.SERVICIOS_VISUALIZAR',
        defaultMessage: "SERVICIOS_VISUALIZAR"
    }),
    'permission.SERVICIOS_MODIFICAR': defineMessage({
        id: 'permission.SERVICIOS_MODIFICAR',
        defaultMessage: "SERVICIOS_MODIFICAR"
    }),
    'permission.SERVICIOS_ELIMINAR': defineMessage({
        id: 'permission.SERVICIOS_ELIMINAR',
        defaultMessage: "SERVICIOS_ELIMINAR"
    }),
    'permission.REPORTAR_PROBLEMA': defineMessage({
        id: 'permission.REPORTAR_PROBLEMA',
        defaultMessage: "REPORTAR_PROBLEMA"
    }),
    'permission.AYUDA_ACCEDER': defineMessage({
        id: 'permission.AYUDA_ACCEDER',
        defaultMessage: "AYUDA_ACCEDER"
    }),
    'permission.INFORMES_ACCEDER': defineMessage({
        id: 'permission.INFORMES_ACCEDER',
        defaultMessage: "INFORMES_ACCEDER"
    }),
    'permission.AVL_ACCEDER': defineMessage({
        id: 'permission.AVL_ACCEDER',
        defaultMessage: "AVL_ACCEDER"
    }),
    'permission.PLANES_MANTENIMIENTO_LISTAR': defineMessage({
        id: 'permission.PLANES_MANTENIMIENTO_LISTAR',
        defaultMessage: "PLANES_MANTENIMIENTO_LISTAR"
    }),
    'permission.PLANES_MANTENIMIENTO_CREAR': defineMessage({
        id: 'permission.PLANES_MANTENIMIENTO_CREAR',
        defaultMessage: "PLANES_MANTENIMIENTO_CREAR"
    }),
    'permission.PLANES_MANTENIMIENTO_MODIFICAR': defineMessage({
        id: 'permission.PLANES_MANTENIMIENTO_MODIFICAR',
        defaultMessage: "PLANES_MANTENIMIENTO_MODIFICAR"
    }),
    'permission.PLANES_MANTENIMIENTO_VISUALIZAR': defineMessage({
        id: 'permission.PLANES_MANTENIMIENTO_VISUALIZAR',
        defaultMessage: "PLANES_MANTENIMIENTO_VISUALIZAR"
    }),
    'permission.PLANES_MANTENIMIENTO_ELIMINAR': defineMessage({
        id: 'permission.PLANES_MANTENIMIENTO_ELIMINAR',
        defaultMessage: "PLANES_MANTENIMIENTO_ELIMINAR"
    }),
    'permission.REGIONES_LISTAR': defineMessage({
        id: 'permission.REGIONES_LISTAR',
        defaultMessage: "REGIONES_LISTAR"
    }),
    'permission.REGIONES_CREAR': defineMessage({
        id: 'permission.REGIONES_CREAR',
        defaultMessage: "REGIONES_CREAR"
    }),
    'permission.REGIONES_VISUALIZAR': defineMessage({
        id: 'permission.REGIONES_VISUALIZAR',
        defaultMessage: "REGIONES_VISUALIZAR"
    }),
    'permission.REGIONES_MODIFICAR': defineMessage({
        id: 'permission.REGIONES_MODIFICAR',
        defaultMessage: "REGIONES_MODIFICAR"
    }),
    'permission.REGIONES_ELIMINAR': defineMessage({
        id: 'permission.REGIONES_ELIMINAR',
        defaultMessage: "REGIONES_ELIMINAR"
    }),
    'permission.SUBREGIONES_LISTAR': defineMessage({
        id: 'permission.SUBREGIONES_LISTAR',
        defaultMessage: "SUBREGIONES_LISTAR"
    }),
    'permission.SUBREGIONES_CREAR': defineMessage({
        id: 'permission.SUBREGIONES_CREAR',
        defaultMessage: "SUBREGIONES_CREAR"
    }),
    'permission.SUBREGIONES_VISUALIZAR': defineMessage({
        id: 'permission.SUBREGIONES_VISUALIZAR',
        defaultMessage: "SUBREGIONES_VISUALIZAR"
    }),
    'permission.SUBREGIONES_MODIFICAR': defineMessage({
        id: 'permission.SUBREGIONES_MODIFICAR',
        defaultMessage: "SUBREGIONES_MODIFICAR"
    }),
    'permission.SUBREGIONES_ELIMINAR': defineMessage({
        id: 'permission.SUBREGIONES_ELIMINAR',
        defaultMessage: "SUBREGIONES_ELIMINAR"
    }),
    'permission.TALLERES_LISTAR': defineMessage({
        id: 'permission.TALLERES_LISTAR',
        defaultMessage: "TALLERES_LISTAR"
    }),
    'permission.TALLERES_CREAR': defineMessage({
        id: 'permission.TALLERES_CREAR',
        defaultMessage: "TALLERES_CREAR"
    }),
    'permission.TALLERES_VISUALIZAR': defineMessage({
        id: 'permission.TALLERES_VISUALIZAR',
        defaultMessage: "TALLERES_VISUALIZAR"
    }),
    'permission.TALLERES_MODIFICAR': defineMessage({
        id: 'permission.TALLERES_MODIFICAR',
        defaultMessage: "TALLERES_MODIFICAR"
    }),
    'permission.TALLERES_ELIMINAR': defineMessage({
        id: 'permission.TALLERES_ELIMINAR',
        defaultMessage: "TALLERES_ELIMINAR"
    }),
    'permission.CENTRO_COSTOS_LISTAR': defineMessage({
        id: 'permission.CENTRO_COSTOS_LISTAR',
        defaultMessage: "CENTRO_COSTOS_LISTAR"
    }),
    'permission.CENTRO_COSTOS_CREAR': defineMessage({
        id: 'permission.CENTRO_COSTOS_CREAR',
        defaultMessage: "CENTRO_COSTOS_CREAR"
    }),
    'permission.CENTRO_COSTOS_MODIFICAR': defineMessage({
        id: 'permission.CENTRO_COSTOS_MODIFICAR',
        defaultMessage: "CENTRO_COSTOS_MODIFICAR"
    }),
    'permission.CENTRO_COSTOS_VISUALIZAR': defineMessage({
        id: 'permission.CENTRO_COSTOS_VISUALIZAR',
        defaultMessage: "CENTRO_COSTOS_VISUALIZAR"
    }),
    'permission.CENTRO_COSTOS_ELIMINAR': defineMessage({
        id: 'permission.CENTRO_COSTOS_ELIMINAR',
        defaultMessage: "CENTRO_COSTOS_ELIMINAR"
    }),
    'permission.CENTRO_BENEFICIOS_LISTAR': defineMessage({
        id: 'permission.CENTRO_BENEFICIOS_LISTAR',
        defaultMessage: "CENTRO_BENEFICIOS_LISTAR"
    }),
    'permission.CENTRO_BENEFICIOS_CREAR': defineMessage({
        id: 'permission.CENTRO_BENEFICIOS_CREAR',
        defaultMessage: "CENTRO_BENEFICIOS_CREAR"
    }),
    'permission.CENTRO_BENEFICIOS_MODIFICAR': defineMessage({
        id: 'permission.CENTRO_BENEFICIOS_MODIFICAR',
        defaultMessage: "CENTRO_BENEFICIOS_MODIFICAR"
    }),
    'permission.CENTRO_BENEFICIOS_VISUALIZAR': defineMessage({
        id: 'permission.CENTRO_BENEFICIOS_VISUALIZAR',
        defaultMessage: "CENTRO_BENEFICIOS_VISUALIZAR"
    }),
    'permission.CENTRO_BENEFICIOS_ELIMINAR': defineMessage({
        id: 'permission.CENTRO_BENEFICIOS_ELIMINAR',
        defaultMessage: "CENTRO_BENEFICIOS_ELIMINAR"
    }),
    'permission.FACTURAS_LISTAR': defineMessage({
        id: 'permission.FACTURAS_LISTAR',
        defaultMessage: "FACTURAS_LISTAR"
    }),
    'permission.FACTURAS_APROBAR': defineMessage({
        id: 'permission.FACTURAS_APROBAR',
        defaultMessage: "FACTURAS_APROBAR"
    }),
    'permission.FACTURAS_RECHAZAR': defineMessage({
        id: 'permission.FACTURAS_RECHAZAR',
        defaultMessage: "FACTURAS_RECHAZAR"
    }),
    'permission.FACTURAS_CREAR': defineMessage({
        id: 'permission.FACTURAS_CREAR',
        defaultMessage: "FACTURAS_CREAR"
    }),
    'permission.FACTURAS_VISUALIZAR': defineMessage({
        id: 'permission.FACTURAS_VISUALIZAR',
        defaultMessage: "FACTURAS_VISUALIZAR"
    }),
    'permission.FACTURAS_MODIFICAR': defineMessage({
        id: 'permission.FACTURAS_MODIFICAR',
        defaultMessage: "FACTURAS_MODIFICAR"
    }),
    'permission.FACTURAS_ELIMINAR': defineMessage({
        id: 'permission.FACTURAS_ELIMINAR',
        defaultMessage: "FACTURAS_ELIMINAR"
    }),
    'permission.FACTURAS_VER_PREFACTURADAS': defineMessage({
        id: 'permission.FACTURAS_VER_PREFACTURADAS',
        defaultMessage: "FACTURAS_VER_PREFACTURADAS"
    }),
    'permission.FACTURAS_EXPORTAR': defineMessage({
        id: 'permission.FACTURAS_EXPORTAR',
        defaultMessage: "FACTURAS_EXPORTAR"
    }),
    'permission.CATEGORIAS_VISUALIZAR': defineMessage({
        id: 'permission.CATEGORIAS_VISUALIZAR',
        defaultMessage: "CATEGORIAS_VISUALIZAR"
    }),
    'permission.CATEGORIAS_MODIFICAR': defineMessage({
        id: 'permission.CATEGORIAS_MODIFICAR',
        defaultMessage: "CATEGORIAS_MODIFICAR"
    }),
    'permission.CATEGORIAS_CREAR': defineMessage({
        id: 'permission.CATEGORIAS_CREAR',
        defaultMessage: "CATEGORIAS_CREAR"
    }),
    'permission.CATEGORIAS_ELIMINAR': defineMessage({
        id: 'permission.CATEGORIAS_ELIMINAR',
        defaultMessage: "CATEGORIAS_ELIMINAR"
    }),
    'permission.CATEGORIAS_LISTAR': defineMessage({
        id: 'permission.CATEGORIAS_LISTAR',
        defaultMessage: "CATEGORIAS_LISTAR"
    }),
    'permission.COMBUSTIBLES_LISTAR': defineMessage({
        id: 'permission.COMBUSTIBLES_LISTAR',
        defaultMessage: "COMBUSTIBLES_LISTAR"
    }),
    'permission.COMBUSTIBLES_CREAR': defineMessage({
        id: 'permission.COMBUSTIBLES_CREAR',
        defaultMessage: "COMBUSTIBLES_CREAR"
    }),
    'permission.COMBUSTIBLES_VISUALIZAR': defineMessage({
        id: 'permission.COMBUSTIBLES_VISUALIZAR',
        defaultMessage: "COMBUSTIBLES_VISUALIZAR"
    }),
    'permission.COMBUSTIBLES_LOG_VISUALIZAR': defineMessage({
        id: 'permission.COMBUSTIBLES_LOG_VISUALIZAR',
        defaultMessage: "COMBUSTIBLES_LOG_VISUALIZAR"
    }),
    'permission.COMBUSTIBLES_MODIFICAR': defineMessage({
        id: 'permission.COMBUSTIBLES_MODIFICAR',
        defaultMessage: "COMBUSTIBLES_MODIFICAR"
    }),
    'permission.COMBUSTIBLES_APROBAR': defineMessage({
        id: 'permission.COMBUSTIBLES_APROBAR',
        defaultMessage: "COMBUSTIBLES_APROBAR"
    }),
    'permission.COMBUSTIBLES_RECHAZAR': defineMessage({
        id: 'permission.COMBUSTIBLES_RECHAZAR',
        defaultMessage: "COMBUSTIBLES_RECHAZAR"
    }),
    'permission.COMBUSTIBLES_VALIDAR': defineMessage({
        id: 'permission.COMBUSTIBLES_VALIDAR',
        defaultMessage: "COMBUSTIBLES_VALIDAR"
    }),
    'permission.CALENDARIO_LISTAR': defineMessage({
        id: 'permission.CALENDARIO_LISTAR',
        defaultMessage: "CALENDARIO_LISTAR"
    }),
    'permission.USUARIO_ACTUAR_COMO_ESCRIBANO': defineMessage({
        id: 'permission.USUARIO_ACTUAR_COMO_ESCRIBANO',
        defaultMessage: "USUARIO_ACTUAR_COMO_ESCRIBANO"
    }),
    'permission.USUARIO_ACTUAR_COMO_GESTOR': defineMessage({
        id: 'permission.USUARIO_ACTUAR_COMO_GESTOR',
        defaultMessage: "USUARIO_ACTUAR_COMO_GESTOR"
    }),
    'permission.USUARIO_TRABAJAR_GESTORIA': defineMessage({
        id: 'permission.USUARIO_TRABAJAR_GESTORIA',
        defaultMessage: "USUARIO_TRABAJAR_GESTORIA"
    }),
    'permission.OT_LISTAR': defineMessage({
        id: 'permission.OT_LISTAR',
        defaultMessage: "OT_LISTAR"
    }),
    'permission.OT_CREAR': defineMessage({
        id: 'permission.OT_CREAR',
        defaultMessage: "OT_CREAR"
    }),
    'permission.OT_VISUALIZAR': defineMessage({
        id: 'permission.OT_VISUALIZAR',
        defaultMessage: "OT_VISUALIZAR"
    }),
    'permission.OT_MODIFICAR': defineMessage({
        id: 'permission.OT_MODIFICAR',
        defaultMessage: "OT_MODIFICAR"
    }),
    'permission.OT_ELIMINAR': defineMessage({
        id: 'permission.OT_ELIMINAR',
        defaultMessage: "OT_ELIMINAR"
    }),
    'permission.OT_EXPORTAR': defineMessage({
        id: 'permission.OT_EXPORTAR',
        defaultMessage: "OT_EXPORTAR"
    }),
    'permission.OT_IMPORTAR': defineMessage({
        id: 'permission.OT_IMPORTAR',
        defaultMessage: "OT_IMPORTAR"
    }),
    'permission.OT_COMPRAR_FORMULARIOS': defineMessage({
        id: 'permission.OT_COMPRAR_FORMULARIOS',
        defaultMessage: "OT_COMPRAR_FORMULARIOS"
    }),
    'permission.OT_ENVIAR_ESCRIBANIA': defineMessage({
        id: 'permission.OT_ENVIAR_ESCRIBANIA',
        defaultMessage: "OT_ENVIAR_ESCRIBANIA"
    }),
    'permission.OT_GESTIONAR': defineMessage({
        id: 'permission.OT_GESTIONAR',
        defaultMessage: "OT_GESTIONAR"
    }),
    'permission.OT_PASAR_PROVISORIO': defineMessage({
        id: 'permission.OT_PASAR_PROVISORIO',
        defaultMessage: "OT_PASAR_PROVISORIO"
    }),
    'permission.OT_CERRAR': defineMessage({
        id: 'permission.OT_CERRAR',
        defaultMessage: "OT_CERRAR"
    }),
    'permission.OT_CANCELAR': defineMessage({
        id: 'permission.OT_CANCELAR',
        defaultMessage: "OT_CANCELAR"
    }),
    'permission.INFRACCIONES_LISTAR': defineMessage({
        id: 'permission.INFRACCIONES_LISTAR',
        defaultMessage: "INFRACCIONES_LISTAR"
    }),
    'permission.MOSTRAR_BOTON_GOOGLE_PLAY': defineMessage({
        id: 'permission.MOSTRAR_BOTON_GOOGLE_PLAY',
        defaultMessage: "MOSTRAR_BOTON_GOOGLE_PLAY"
    }),
    'permission.INFRACCIONES_CREAR': defineMessage({
        id: 'permission.INFRACCIONES_CREAR',
        defaultMessage: "INFRACCIONES_CREAR"
    }),
    'permission.INFRACCIONES_MODIFICAR': defineMessage({
        id: 'permission.INFRACCIONES_MODIFICAR',
        defaultMessage: "INFRACCIONES_MODIFICAR"
    }),
    'permission.INFRACCIONES_VISUALIZAR': defineMessage({
        id: 'permission.INFRACCIONES_VISUALIZAR',
        defaultMessage: "INFRACCIONES_VISUALIZAR"
    }),
    'permission.INFRACCIONES_INFORMAR_PAGO': defineMessage({
        id: 'permission.INFRACCIONES_INFORMAR_PAGO',
        defaultMessage: "INFRACCIONES_INFORMAR_PAGO"
    }),
    'permission.INFRACCIONES_ELIMINAR': defineMessage({
        id: 'permission.INFRACCIONES_ELIMINAR',
        defaultMessage: "INFRACCIONES_ELIMINAR"
    }),
    'permission.INFRACCIONES_VALIDAR': defineMessage({
        id: 'permission.INFRACCIONES_VALIDAR',
        defaultMessage: "INFRACCIONES_VALIDAR"
    }),
    'permission.INFRACCIONES_ADJUNTAR': defineMessage({
        id: 'permission.INFRACCIONES_ADJUNTAR',
        defaultMessage: "INFRACCIONES_ADJUNTAR"
    }),
    'permission.TRANSACCIONES_LISTAR': defineMessage({
        id: 'permission.TRANSACCIONES_LISTAR',
        defaultMessage: "TRANSACCIONES_LISTAR"
    }),
    'permission.TRANSACCIONES_GENERAR': defineMessage({
        id: 'permission.TRANSACCIONES_GENERAR',
        defaultMessage: "TRANSACCIONES_GENERAR"
    }),
    'permission.GPS_DEVICES_LIST': defineMessage({
        id: 'permission.GPS_DEVICES_LIST',
        defaultMessage: "GPS_DEVICES_LIST"
    }),
    'permission.GPS_DEVICES_CREATE': defineMessage({
        id: 'permission.GPS_DEVICES_CREATE',
        defaultMessage: "GPS_DEVICES_CREATE"
    }),
    'permission.GPS_DEVICES_VIEW': defineMessage({
        id: 'permission.GPS_DEVICES_VIEW',
        defaultMessage: "GPS_DEVICES_VIEW"
    }),
    'permission.GPS_DEVICES_EDIT': defineMessage({
        id: 'permission.GPS_DEVICES_EDIT',
        defaultMessage: "GPS_DEVICES_EDIT"
    }),
    'permission.GPS_DEVICES_DELETE': defineMessage({
        id: 'permission.GPS_DEVICES_DELETE',
        defaultMessage: "GPS_DEVICES_DELETE"
    }),
    'permission.API_LOCATION_CREAR': defineMessage({
        id: 'permission.API_LOCATION_CREAR',
        defaultMessage: "API_LOCATION_CREAR"
    }),
    'permission.EXECUTE_CRON': defineMessage({
        id: 'permission.EXECUTE_CRON',
        defaultMessage: "EXECUTE_CRON"
    }),
    'permission.PANOL_LISTAR': defineMessage({
        id: 'permission.PANOL_LISTAR',
        defaultMessage: "PANOL_LISTAR"
    }),
    'permission.PANOL_PLANTILLAS_LISTAR': defineMessage({
        id: 'permission.PANOL_PLANTILLAS_LISTAR',
        defaultMessage: "PANOL_PLANTILLAS_LISTAR"
    }),
    'permission.PANOL_CONFIGURACION_LISTAR': defineMessage({
        id: 'permission.PANOL_CONFIGURACION_LISTAR',
        defaultMessage: "PANOL_CONFIGURACION_LISTAR"
    }),
    'permission.PANOL_ALMACEN_CREAR': defineMessage({
        id: 'permission.PANOL_ALMACEN_CREAR',
        defaultMessage: "PANOL_ALMACEN_CREAR"
    }),
    'permission.PANOL_ALMACEN_INGRESAR_ITEM': defineMessage({
        id: 'permission.PANOL_ALMACEN_INGRESAR_ITEM',
        defaultMessage: "PANOL_ALMACEN_INGRESAR_ITEM"
    }),
    'permission.PANOL_ALMACEN_EGRESAR_ITEM': defineMessage({
        id: 'permission.PANOL_ALMACEN_EGRESAR_ITEM',
        defaultMessage: "PANOL_ALMACEN_EGRESAR_ITEM"
    }),
    'permission.PANOL_ALMACEN_TRANSFERIR': defineMessage({
        id: 'permission.PANOL_ALMACEN_TRANSFERIR',
        defaultMessage: "PANOL_ALMACEN_TRANSFERIR"
    }),
    'permission.PANOL_ALMACEN_AJUSTAR_STOCK': defineMessage({
        id: 'permission.PANOL_ALMACEN_AJUSTAR_STOCK',
        defaultMessage: "PANOL_ALMACEN_AJUSTAR_STOCK"
    }),
    'permission.PANOL_PLANTILLAS_VISUALIZAR': defineMessage({
        id: 'permission.PANOL_PLANTILLAS_VISUALIZAR',
        defaultMessage: "PANOL_PLANTILLAS_VISUALIZAR"
    }),
    'permission.PANOL_PLANTILLAS_MODIFICAR': defineMessage({
        id: 'permission.PANOL_PLANTILLAS_MODIFICAR',
        defaultMessage: "PANOL_PLANTILLAS_MODIFICAR"
    }),
    'permission.PANOL_PLANTILLAS_ELIMINAR': defineMessage({
        id: 'permission.PANOL_PLANTILLAS_ELIMINAR',
        defaultMessage: "PANOL_PLANTILLAS_ELIMINAR"
    }),
    'permission.PANOL_PLANTILLAS_CREAR': defineMessage({
        id: 'permission.PANOL_PLANTILLAS_CREAR',
        defaultMessage: "PANOL_PLANTILLAS_CREAR"
    }),
    'permission.PANOL_CONFIGURACION_ELIMINAR': defineMessage({
        id: 'permission.PANOL_CONFIGURACION_ELIMINAR',
        defaultMessage: "PANOL_CONFIGURACION_ELIMINAR"
    }),
    'permission.PANOL_CONFIGURACION_MODIFICAR': defineMessage({
        id: 'permission.PANOL_CONFIGURACION_MODIFICAR',
        defaultMessage: "PANOL_CONFIGURACION_MODIFICAR"
    }),
    'permission.PANOL_CONFIGURACION_CREAR': defineMessage({
        id: 'permission.PANOL_CONFIGURACION_CREAR',
        defaultMessage: "PANOL_CONFIGURACION_CREAR"
    }),
    'permission.PANOL_CATEGORIAS_MODIFICAR': defineMessage({
        id: 'permission.PANOL_CATEGORIAS_MODIFICAR',
        defaultMessage: "PANOL_CATEGORIAS_MODIFICAR"
    }),
    'permission.PANOL_CATEGORIAS_ELIMINAR': defineMessage({
        id: 'permission.PANOL_CATEGORIAS_ELIMINAR',
        defaultMessage: "PANOL_CATEGORIAS_ELIMINAR"
    }),
    'permission.PANOL_CATEGORIAS_CREAR': defineMessage({
        id: 'permission.PANOL_CATEGORIAS_CREAR',
        defaultMessage: "PANOL_CATEGORIAS_CREAR"
    }),
    'permission.PANOL_ITEMS_CREAR': defineMessage({
        id: 'permission.PANOL_ITEMS_CREAR',
        defaultMessage: "PANOL_ITEMS_CREAR"
    }),
    'permission.PANOL_MARCAS_CREAR': defineMessage({
        id: 'permission.PANOL_MARCAS_CREAR',
        defaultMessage: "PANOL_MARCAS_CREAR"
    }),
    'permission.PANOL_MARCAS_MODIFICAR': defineMessage({
        id: 'permission.PANOL_MARCAS_MODIFICAR',
        defaultMessage: "PANOL_MARCAS_MODIFICAR"
    }),
    'permission.PANOL_MARCAS_ELIMINAR': defineMessage({
        id: 'permission.PANOL_MARCAS_ELIMINAR',
        defaultMessage: "PANOL_MARCAS_ELIMINAR"
    }),
    'permission.PANOL_STOCK_AJUSTE_CREAR': defineMessage({
        id: 'permission.PANOL_STOCK_AJUSTE_CREAR',
        defaultMessage: "PANOL_STOCK_AJUSTE_CREAR"
    }),
    'permission.PANOL_STOCK_AJUSTE_ELIMINAR': defineMessage({
        id: 'permission.PANOL_STOCK_AJUSTE_ELIMINAR',
        defaultMessage: "PANOL_STOCK_AJUSTE_ELIMINAR"
    }),
    'permission.PANOL_STOCK_EGRESO_CREAR': defineMessage({
        id: 'permission.PANOL_STOCK_EGRESO_CREAR',
        defaultMessage: "PANOL_STOCK_EGRESO_CREAR"
    }),
    'permission.PANOL_STOCK_EGRESO_ELIMINAR': defineMessage({
        id: 'permission.PANOL_STOCK_EGRESO_ELIMINAR',
        defaultMessage: "PANOL_STOCK_EGRESO_ELIMINAR"
    }),
    'permission.PANOL_STOCK_CREAR': defineMessage({
        id: 'permission.PANOL_STOCK_CREAR',
        defaultMessage: "PANOL_STOCK_CREAR"
    }),
    'permission.PANOL_STOCK_ELIMINAR': defineMessage({
        id: 'permission.PANOL_STOCK_ELIMINAR',
        defaultMessage: "PANOL_STOCK_ELIMINAR"
    }),
    'permission.PANOL_STOCK_TRANSFERENCIA_CREAR': defineMessage({
        id: 'permission.PANOL_STOCK_TRANSFERENCIA_CREAR',
        defaultMessage: "PANOL_STOCK_TRANSFERENCIA_CREAR"
    }),
    'permission.PANOL_PLANTILLAS_DETALLE_CREAR': defineMessage({
        id: 'permission.PANOL_PLANTILLAS_DETALLE_CREAR',
        defaultMessage: "PANOL_PLANTILLAS_DETALLE_CREAR"
    }),
    'permission.PANOL_PLANTILLAS_DETALLE_ELIMINAR': defineMessage({
        id: 'permission.PANOL_PLANTILLAS_DETALLE_ELIMINAR',
        defaultMessage: "PANOL_PLANTILLAS_DETALLE_ELIMINAR"
    }),
    'permission.PANOL_SUBCATEGORIAS_CREAR': defineMessage({
        id: 'permission.PANOL_SUBCATEGORIAS_CREAR',
        defaultMessage: "PANOL_SUBCATEGORIAS_CREAR"
    }),
    'permission.PANOL_SUBCATEGORIAS_MODIFICAR': defineMessage({
        id: 'permission.PANOL_SUBCATEGORIAS_MODIFICAR',
        defaultMessage: "PANOL_SUBCATEGORIAS_MODIFICAR"
    }),
    'permission.PANOL_SUBCATEGORIAS_ELIMINAR': defineMessage({
        id: 'permission.PANOL_SUBCATEGORIAS_ELIMINAR',
        defaultMessage: "PANOL_SUBCATEGORIAS_ELIMINAR"
    }),
    'permission.PANOL_MEDIDAS_VISUALIZAR': defineMessage({
        id: 'permission.PANOL_MEDIDAS_VISUALIZAR',
        defaultMessage: "PANOL_MEDIDAS_VISUALIZAR"
    }),
    'permission.PANOL_MEDIDAS_MODIFICAR': defineMessage({
        id: 'permission.PANOL_MEDIDAS_MODIFICAR',
        defaultMessage: "PANOL_MEDIDAS_MODIFICAR"
    }),
    'permission.PANOL_MEDIDAS_ELIMINAR': defineMessage({
        id: 'permission.PANOL_MEDIDAS_ELIMINAR',
        defaultMessage: "PANOL_MEDIDAS_ELIMINAR"
    }),
    'permission.PANOL_ITEMS_MODIFICAR': defineMessage({
        id: 'permission.PANOL_ITEMS_MODIFICAR',
        defaultMessage: "PANOL_ITEMS_MODIFICAR"
    }),
    'permission.PANOL_ITEMS_ELIMINAR': defineMessage({
        id: 'permission.PANOL_ITEMS_ELIMINAR',
        defaultMessage: "PANOL_ITEMS_ELIMINAR"
    }),
    'permission.ROPS_LISTAR': defineMessage({
        id: 'permission.ROPS_LISTAR',
        defaultMessage: "ROPS_LISTAR"
    }),
    'permission.ROPS_CREAR': defineMessage({
        id: 'permission.ROPS_CREAR',
        defaultMessage: "ROPS_CREAR"
    }),
    'permission.ROPS_VISUALIZAR': defineMessage({
        id: 'permission.ROPS_VISUALIZAR',
        defaultMessage: "ROPS_VISUALIZAR"
    }),
    'permission.ROPS_RECOVERY': defineMessage({
        id: 'permission.ROPS_RECOVERY',
        defaultMessage: "ROPS_RECOVERY"
    }),
    'permission.ROP_LOG_VISUALIZAR': defineMessage({
        id: 'permission.ROP_LOG_VISUALIZAR',
        defaultMessage: "ROP_LOG_VISUALIZAR"
    }),
    'permission.GASTOS_LISTAR': defineMessage({
        id: 'permission.GASTOS_LISTAR',
        defaultMessage: "GASTOS_LISTAR"
    }),
    'permission.GASTOS_VISUALIZAR': defineMessage({
        id: 'permission.GASTOS_VISUALIZAR',
        defaultMessage: "GASTOS_VISUALIZAR"
    }),
    'permission.GASTOS_EDITAR': defineMessage({
        id: 'permission.GASTOS_EDITAR',
        defaultMessage: "GASTOS_EDITAR"
    }),
    'permission.GASTOS_CREAR': defineMessage({
        id: 'permission.GASTOS_CREAR',
        defaultMessage: "GASTOS_CREAR"
    }),
    'permission.GASTOS_LISTAR_HISTORICO': defineMessage({
        id: 'permission.GASTOS_LISTAR_HISTORICO',
        defaultMessage: "GASTOS_LISTAR_HISTORICO"
    }),
    'permission.GASTOS_ELIMINAR': defineMessage({
        id: 'permission.GASTOS_ELIMINAR',
        defaultMessage: "GASTOS_ELIMINAR"
    }),
    'permission.GASTOS_TIPO_LISTAR': defineMessage({
        id: 'permission.GASTOS_TIPO_LISTAR',
        defaultMessage: "GASTOS_TIPO_LISTAR"
    }),
    'permission.GASTOS_TIPO_VISUALIZAR': defineMessage({
        id: 'permission.GASTOS_TIPO_VISUALIZAR',
        defaultMessage: "GASTOS_TIPO_VISUALIZAR"
    }),
    'permission.GASTOS_TIPO_EDITAR': defineMessage({
        id: 'permission.GASTOS_TIPO_EDITAR',
        defaultMessage: "GASTOS_TIPO_EDITAR"
    }),
    'permission.GASTOS_TIPO_CREAR': defineMessage({
        id: 'permission.GASTOS_TIPO_CREAR',
        defaultMessage: "GASTOS_TIPO_CREAR"
    }),
    'permission.GASTOS_TIPO_ELIMINAR': defineMessage({
        id: 'permission.GASTOS_TIPO_ELIMINAR',
        defaultMessage: "GASTOS_TIPO_ELIMINAR"
    }),
    'combustiblesGridNew.kpis_card.cargas_validas': defineMessage({
        id: 'combustiblesGridNew.kpis_card.cargas_validas',
        defaultMessage: "Cargas Válidas"
    }),
    'combustiblesGridNew.kpis_card.cargas_sin_comprobacion': defineMessage({
        id: 'combustiblesGridNew.kpis_card.cargas_sin_comprobacion',
        defaultMessage: "Cargas Sin Comprobación"
    }),
    'combustiblesGridNew.kpis_card.cantidad_cargas_invalidas': defineMessage({
        id: 'combustiblesGridNew.kpis_card.cantidad_cargas_invalidas',
        defaultMessage: "Cantidad de Cargas Inválidas"
    }),
    'combustiblesGridNew.kpis_card.vh_con_cargas_invalidas': defineMessage({
        id: 'combustiblesGridNew.kpis_card.vh_con_cargas_invalidas',
        defaultMessage: "Vh. con Cargas Inválidas"
    }),
    'combustiblesGridNew.kpis_card.monto_cargas_invalidas': defineMessage({
        id: 'combustiblesGridNew.kpis_card.monto_cargas_invalidas',
        defaultMessage: "Monto Cargas Inválidas"
    }),
    'combustiblesGridNew.kpis_card.litros_cargas_invalidas': defineMessage({
        id: 'combustiblesGridNew.kpis_card.litros_cargas_invalidas',
        defaultMessage: "Litros Cargas Inválidas"
    }),
    'formularioController.errors.checklist_no_procesado_dado_vehiculo_con_ROP_correctivo_pendiente': defineMessage({
        id: 'formularioController.errors.checklist_no_procesado_dado_vehiculo_con_ROP_correctivo_pendiente',
        defaultMessage: "No se ha procesado el checklist dado que este vehículo cuenta con un ROP correctivo pendiente. Para poder crear el checklist primero se deberá solucionar el ROP en curso."
    }),
    'tipoFormularioController.errors.formulario_asociado_autoreferencia': defineMessage({
        id: 'tipoFormularioController.errors.formulario_asociado_autoreferencia',
        defaultMessage: "No se puede asociar una pregunta al mismo tipo de formulario que se está editando."
    }),
    'tipoFormularioController.errors.formulario_asociado_no_puede_tener_sus_propios_asociados': defineMessage({
        id: 'tipoFormularioController.errors.formulario_asociado_no_puede_tener_sus_propios_asociados',
        defaultMessage: "El tipo de formulario elegido ya tiene sus propias preguntas de \"Formulario Asociado\" — no puede a su vez asociarse (solo se permite un nivel de anidado)."
    }),
    'tipoFormularioController.errors.formulario_asociado_ya_es_asociado_de_otro': defineMessage({
        id: 'tipoFormularioController.errors.formulario_asociado_ya_es_asociado_de_otro',
        defaultMessage: "Este tipo de formulario ya está asociado a otro — no puede además tener sus propias preguntas de \"Formulario Asociado\" (solo se permite un nivel de anidado)."
    }),
    // VEC-3955: proveedor por atributo con servicios.proveedores.habilitado
    'tipoFormularioController.errors.atributo_sin_proveedor': defineMessage({
        id: 'tipoFormularioController.errors.atributo_sin_proveedor',
        defaultMessage: "Cada pregunta que genera ticket correctivo debe tener un proveedor."
    }),
    'tipoFormularioController.errors.proveedor_no_brinda_el_servicio': defineMessage({
        id: 'tipoFormularioController.errors.proveedor_no_brinda_el_servicio',
        defaultMessage: "El proveedor elegido no brinda el servicio de la pregunta."
    }),
    'tipoFormularioController.errors.proveedor_distinto_entre_preguntas': defineMessage({
        id: 'tipoFormularioController.errors.proveedor_distinto_entre_preguntas',
        defaultMessage: "Todas las preguntas que generan ticket correctivo deben tener el mismo proveedor: el checklist genera un único ticket."
    }),
    'tipoFormularioController.errors.atributo_sin_items': defineMessage({
        id: 'tipoFormularioController.errors.atributo_sin_items',
        defaultMessage: "Cada pregunta que genera ticket correctivo debe tener al menos una mano de obra o un repuesto."
    }),
    'checklistController.errors.tipo_formulario_sin_proveedor': defineMessage({
        id: 'checklistController.errors.tipo_formulario_sin_proveedor',
        defaultMessage: "Este tipo de formulario tiene preguntas que generan ticket sin proveedor configurado. Pedí que lo corrijan antes de cargar el checklist."
    }),
    'infracciones.errors.acta_duplicada': defineMessage({
        id: 'infracciones.errors.acta_duplicada',
        defaultMessage: 'No se puede realizar la acción. El número de acta ya existe.'
    }),
    'ticketsRepository.errors.encabezado_no_esta_en_fila_correcta': defineMessage({
        id: 'ticketsRepository.errors.encabezado_no_esta_en_fila_correcta',
        defaultMessage: "Encabezado no esta en fila correcta"
    }),
    'ticketsRepository.errors.archivo_no_cumple_formato_faltan_columnas': defineMessage({
        id: 'ticketsRepository.errors.archivo_no_cumple_formato_faltan_columnas',
        defaultMessage: "Archivo no cumple formato faltan columnas"
    }),
    'ticketsRepository.errors.no_se_pudieron_leer_columnas_del_archivo': defineMessage({
        id: 'ticketsRepository.errors.no_se_pudieron_leer_columnas_del_archivo',
        defaultMessage: "No se ppudieron leer las oclumnas del archivo"
    }),
    'ticketsRepository.errors.el_movil_es_requerido': defineMessage({
        id: 'ticketsRepository.errors.el_movil_es_requerido',
        defaultMessage: "El móvil es requerido"
    }),
    'ticketsRepository.errors.el_tipo_servicio_es_requerido': defineMessage({
        id: 'ticketsRepository.errors.el_tipo_servicio_es_requerido',
        defaultMessage: "Tipo de servicio es requerido"
    }),
    'ticketsRepository.errors.el_servicio_es_requerido': defineMessage({
        id: 'ticketsRepository.errors.el_servicio_es_requerido',
        defaultMessage: "El servicio es requerido"
    }),
    'ticketsRepository.errors.fecha_ticket_requerida': defineMessage({
        id: 'ticketsRepository.errors.fecha_ticket_requerida',
        defaultMessage: "Fecha de ticket requerida"
    }),
    'ticketsRepository.errors.fecha_realizado_requerida': defineMessage({
        id: 'ticketsRepository.errors.fecha_realizado_requerida',
        defaultMessage: "Fecha de realizado requerida"
    }),
    'ticketsRepository.errors.gerenciador_requerido': defineMessage({
        id: 'ticketsRepository.errors.gerenciador_requerido',
        defaultMessage: "El gerenciador es requerido"
    }),
    'ticketsRepository.errors.movil_no_existe': defineMessage({
        id: 'ticketsRepository.errors.movil_no_existe',
        defaultMessage: "No existe el móvil con ese dominio "
    }),
    'ticketsRepository.errors.tipo_servicio_no_valido': defineMessage({
        id: 'ticketsRepository.errors.tipo_servicio_no_valido',
        defaultMessage: "El tipo de servicio debe ser CORRECTIVO O PREVENTIVO"
    }),
    'ticketsRepository.errors.tipo_servicio_no_encontrado': defineMessage({
        id: 'ticketsRepository.errors.tipo_servicio_no_encontrado',
        defaultMessage: "No se encontró el tipo de servicio"
    }),
    'ticketsRepository.errors.tipo_servicio_y_tarea_no_asociadas': defineMessage({
        id: 'ticketsRepository.errors.tipo_servicio_y_tarea_no_asociadas',
        defaultMessage: "Una o varias tareas no estan asociadas al servicio"
    }),
    'ticketsRepository.errors.tarea_no_encontrada': defineMessage({
        id: 'ticketsRepository.errors.tarea_no_encontrada',
        defaultMessage: "Una o varias tareas no encontradas"
    }),
    'ticketsRepository.errors.formato_fecha_ticket_invalida': defineMessage({
        id: 'ticketsRepository.errors.formato_fecha_ticket_invalida',
        defaultMessage: "La fecha del ticket no está en un formato válido"
    }),
    'ticketsRepository.errors.formato_fecha_hora_realizado_invalida': defineMessage({
        id: 'ticketsRepository.errors.formato_fecha_hora_realizado_invalida',
        defaultMessage: "La fecha de realizado del ticket no está en un formato válido"
    }),
    'ticketsRepository.errors.formato_fecha_turno_invalida': defineMessage({
        id: 'ticketsRepository.errors.formato_fecha_turno_invalida',
        defaultMessage: "La fecha del turno no está en un formato válido"
    }),
    'ticketsRepository.errors.formato_fecha_presupuesto_invalida': defineMessage({
        id: 'ticketsRepository.errors.formato_fecha_presupuesto_invalida',
        defaultMessage: "La fecha del presupuesto no está en un formato válido"
    }),
    'ticketsRepository.errors.presupuesto_mano_obra_requerido': defineMessage({
        id: 'ticketsRepository.errors.presupuesto_mano_obra_requerido',
        defaultMessage: "El Presupuesto de mano de obra es requerido"
    }),
    'ticketsRepository.errors.fecha_realizado_menor_ticket': defineMessage({
        id: 'ticketsRepository.errors.fecha_realizado_menor_ticket',
        defaultMessage: "La fecha Realizado debe ser mayor o igual a la fecha del ticket"
    }),
    'ticketsRepository.errors.fecha_turno_menor_igual_fecha_actual': defineMessage({
        id: 'ticketsRepository.errors.fecha_turno_menor_igual_fecha_actual',
        defaultMessage: "La fecha del turno debe ser menor o igual a la fecha actual"
    }),
    'ticketsRepository.errors.km_generado_numerico': defineMessage({
        id: 'ticketsRepository.errors.km_generado_numerico',
        defaultMessage: "El Km generado debe ser numérico"
    }),
    'ticketsRepository.errors.km_realizado_numerico': defineMessage({
        id: 'ticketsRepository.errors.km_realizado_numerico',
        defaultMessage: "El Km realizado debe ser numérico"
    }),
    'ticketsRepository.errors.km_realizado_mayor_generado': defineMessage({
        id: 'ticketsRepository.errors.km_realizado_mayor_generado',
        defaultMessage: "El Km realizado debe ser mayor o igual al generado"
    }),
    'ticketsRepository.errors.gerenciador_no_existe': defineMessage({
        id: 'ticketsRepository.errors.gerenciador_no_existe',
        defaultMessage: "El gerenciador no existe o no esta activo"
    }),
    'ticketsRepository.errors.taller_no_existe': defineMessage({
        id: 'ticketsRepository.errors.taller_no_existe',
        defaultMessage: "El taller no existe o no está activo"
    }),
    'ticketsRepository.errors.no_vinculado_gerenciador': defineMessage({
        id: 'ticketsRepository.errors.no_vinculado_gerenciador',
        defaultMessage: "El taller No está vinculado al Gerenciador"
    }),
    'ticketsRepository.errors.fecha_ticket_mayor_actual': defineMessage({
        id: 'ticketsRepository.errors.fecha_ticket_mayor_actual',
        defaultMessage: "La fecha del ticket debe ser menor o igual a la fecha del día"
    }),
    'ticketsRepository.errors.la_fecha_del_presupuesto_debe_ser_menor_a_fecha_de_hoy': defineMessage({
        id: 'ticketsRepository.errors.la_fecha_del_presupuesto_debe_ser_menor_a_fecha_de_hoy',
        defaultMessage: "La fecha del presupuesto debe ser menor o igual a la fecha del día"
    }),
    'ticketsRepository.errors.el_presupuesto_mano_obra_debe_ser_numerico': defineMessage({
        id: 'ticketsRepository.errors.el_presupuesto_mano_obra_debe_ser_numerico',
        defaultMessage: "El presupuesto de mano de obra debe ser numérico"
    }),
    'ticketsRepository.errors.el_presupuesto_repuestos_debe_ser_numerico': defineMessage({
        id: 'ticketsRepository.errors.el_presupuesto_repuestos_debe_ser_numerico',
        defaultMessage: "El presupuesto de repuestos debe ser numérico"
    }),
    'ticketsRepository.errors.los_impuestos_presupuesto_deben_ser_numericos': defineMessage({
        id: 'ticketsRepository.errors.los_impuestos_presupuesto_deben_ser_numericos',
        defaultMessage: "Los impuestos del presupuesto deben ser numéricos"
    }),
    'ticketsRepository.errors.el_total_presupuesto_debe_ser_numerico': defineMessage({
        id: 'ticketsRepository.errors.el_total_presupuesto_debe_ser_numerico',
        defaultMessage: "El total del presupuesto debe ser numérico"
    }),
    'ticketsRepository.errors.el_total_presupuesto_debe_ser_suma_componentes': defineMessage({
        id: 'ticketsRepository.errors.el_total_presupuesto_debe_ser_suma_componentes',
        defaultMessage: "El total del presupuesto debe ser igual a la suma de Mano de Obra + Repuestos + Impuestos"
    }),
    'ticketsRepository.errors.no_se_guardo_ticket_cerrado': defineMessage({
        id: 'ticketsRepository.errors.no_se_guardo_ticket_cerrado',
        defaultMessage: "No se guardó el ticket cerrado"
    }),
    'ticketsRepository.errors.tarea_no_asociada': defineMessage({
        id: 'ticketsRepository.errors.tarea_no_asociada',
        defaultMessage: "La tarea no está asociada con el servicio"
    }),
    'ticketsRepository.errors.ticket_ya_registrado': defineMessage({
        id: 'ticketsRepository.errors.ticket_ya_registrado',
        defaultMessage: "Ya existe un ticket registrado"
    }),
    'ticketsRepository.errors.impuestos_no_numericos': defineMessage({
        id: 'ticketsRepository.errors.impuestos_no_numericos',
        defaultMessage: "Los impuiestos del presupuesto debe ser numérico"
    }),
    'ticketsRepository.errors.total_no_numerico': defineMessage({
        id: 'ticketsRepository.errors.total_no_numerico',
        defaultMessage: "El total del presupuesto debe ser numérico"
    }),
    'ticketsRepository.errors.ticket_no_guardado': defineMessage({
        id: 'ticketsRepository.errors.ticket_no_guardado',
        defaultMessage: "No se guardó el ticket cerrado"
    }),
    'ticketsRepository.errors.ticket_ya_existente': defineMessage({
        id: 'ticketsRepository.errors.ticket_ya_existente',
        defaultMessage: "Ya existe un ticket registrado"
    }),
    'ticketsRepository.errors.fecha_realizado_menor_igual_fecha_actual': defineMessage({
        id: 'ticketsRepository.errors.fecha_realizado_menor_igual_fecha_actual',
        defaultMessage: "La fecha de realizado debe ser menor o igual a la fecha actual"
    }),
    'ticketsRepository.errors.archivo_sin_datos': defineMessage({
        id: 'ticketsRepository.errors.archivo_sin_datos',
        defaultMessage: "El archivo no contiene datos"
    }),
    'ticketsRepository.errors.debe_ser_s_n': defineMessage({
        id: 'ticketsRepository.errors.debe_ser_s_n',
        defaultMessage: "Es sinisetro debe tener un valor S o N"
    }),
    'ticketsRepository.errors.nro_siniestro_sin_casilla_s': defineMessage({
        id: 'ticketsRepository.errors.nro_siniestro_sin_casilla_s',
        defaultMessage: "Se registro nro de sinistro pero no se activo casilla Es Siniestro"
    }),
    'formulario.mesnsajes.checklist_cerrado': defineMessage({
        id: 'formulario.mesnsajes.checklist_cerrado',
        defaultMessage: "Checklist Cerrado"
    }),
    'División_no_existe': defineMessage({
        id: 'División_no_existe',
        defaultMessage: "División no existe"
    }),
    'División_requeridad': defineMessage({
        id: 'División_requeridad',
        defaultMessage: "División requeridad"
    }),
    'No_se_pudo_eliminar_la_división_tiene_moviles_asignados': defineMessage({
        id: 'No_se_pudo_eliminar_la_división_tiene_moviles_asignados',
        defaultMessage: "No se pudo eliminar la división, tiene moviles asignados"
    }),
    'Debes_ingresar_al_menos_una_tarea_o_un_repuesto': defineMessage({
        id: 'Debes_ingresar_al_menos_una_tarea_o_un_repuesto',
        defaultMessage: "Debes ingresar al menos una tarea o un repuesto"
    }),
    'Sin_Definir': defineMessage({
        id: 'Sin_Definir',
        defaultMessage: "Sin Definir"
    }),
    'Reagenda_de_turno': defineMessage({
        id: 'Reagenda_de_turno',
        defaultMessage: "Reagenda de turno"
    }),
    'Cancelación_de_turno': defineMessage({
        id: 'Cancelación_de_turno',
        defaultMessage: "Cancelación de turno"
    }),
    'Cancelación_de_ticket': defineMessage({
        id: 'Cancelación_de_ticket',
        defaultMessage: "Cancelación de ticket"
    }),
    'Cancelacion_automatica_por_inactivacion_de_vehiculo': defineMessage({
        id: 'Cancelacion_automatica_por_inactivacion_de_vehiculo',
        defaultMessage: "Cancelación automática por inactivación de vehículo"
    }),
    'Asignacion_de_turnos': defineMessage({
        id: 'Asignacion_de_turnos',
        defaultMessage: "Asignación de Turnos"
    }),
    'En_Mantenimiento': defineMessage({
        id: 'En_Mantenimiento',
        defaultMessage: "En Mantenimiento"
    }),
    'ociosidad': defineMessage({
        id: 'ociosidad',
        defaultMessage: "Ociosidad"
    }),
    'exclusion_programa_preventivo': defineMessage({
        id: 'exclusion_programa_preventivo',
        defaultMessage: "Exclusión de Programa Preventivo"
    }),
    'rechazo_solicitud': defineMessage({
        id: 'rechazo_solicitud',
        defaultMessage: "Rechazo de Solicitud"
    }),
    'No_es_posible_esa_acción_al_elemento': defineMessage({
        id: 'No_es_posible_esa_acción_al_elemento',
        defaultMessage: "No es posible esa acción al elemento"
    }),
    'Ya_existe_el_motivo': defineMessage({
        id: 'Ya_existe_el_motivo',
        defaultMessage: "Ya existe el motivo"
    }),
    'No_se_puede_realizar_la_acción._El_dominio_ya_existe': defineMessage({
        id: 'No_se_puede_realizar_la_acción._El_dominio_ya_existe',
        defaultMessage: 'No se puede realizar la acción. El dominio ya existe'
    }),
    'El_dato_de_chasis_ingresado_está_duplicado': defineMessage({
        id: 'El_dato_de_chasis_ingresado_está_duplicado',
        defaultMessage: "El dato de chasis ingresado está duplicado"
    }),
      'Chasis_requerido': defineMessage({
        id: 'Chasis_requerido',
        defaultMessage: "Chasis requerido"
    }),
    'El_VIN_debe_contener_exactamente_17_caracteres': defineMessage({
        id: 'El_VIN_debe_contener_exactamente_17_caracteres',
        defaultMessage: "El VIN debe contener exactamente 17 caracteres"
    }),
    'validation.chasis_invalid': defineMessage({
        id: 'validation.chasis_invalid',
        defaultMessage: "El VIN debe contener 17 caracteres | El VIN no cumple con un formato válido | El VIN posee caracteres alfabéticos en minúscula"
    }),
    'No_se_puede_realizar_la_acción._El_vehículo_ya_existe': defineMessage({
        id: 'No_se_puede_realizar_la_acción._El_vehículo_ya_existe',
        defaultMessage: 'No se puede realizar la acción. El vehículo ya existe'
    }),
    'movilesGrid.render.filtros_supervisor.label': defineMessage({
        id: 'movilesGrid.render.filtros_supervisor.label',
        defaultMessage: 'Supervisor'
    }),
    'movilesGrid.render.filtros_supervisor.placeholder': defineMessage({
        id: 'movilesGrid.render.filtros_supervisor.placeholder',
        defaultMessage: 'Supervisor'
    }),
    'movilesGrid.render.filtros_temporal.label': defineMessage({
        id: 'movilesGrid.render.filtros_temporal.label',
        defaultMessage: 'Temporal'
    }),
    'movilesGrid.render.filtros_temporal.placeholder': defineMessage({
        id: 'movilesGrid.render.filtros_temporal.placeholder',
        defaultMessage: 'Temporal'
    }),
    'ID_Ruta_existe': defineMessage({
        id: 'ID_Ruta_existe',
        defaultMessage: 'ID Ruta existe'
    }),
    'login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario': defineMessage({
        id: 'login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario',
        defaultMessage: 'No se encontró número de teléfono asociado a su usuario'
    }),
    'login.errors.Numero_de_telefono_invalido': defineMessage({
        id: 'login.errors.Numero_de_telefono_invalido',
        defaultMessage: 'Número de teléfono inválido'
    }),
    'TicketTareasItemsCierre.errors.deber_ingresar_al_menos_una_tarea_o_item': defineMessage({
        id: 'TicketTareasItemsCierre.errors.deber_ingresar_al_menos_una_tarea_o_item',
        defaultMessage: 'Debe ingresar al menos una tarea. o item'
    }),
    // VEC-3779: obligatorios del cierre. Keys nuevas a propósito (el catálogo remoto resuelve por key,
    // así que reusar una existente heredaría su texto viejo).
    'TicketTareasItemsCierre.errors.cantidad_requerida': defineMessage({
        id: 'TicketTareasItemsCierre.errors.cantidad_requerida',
        defaultMessage: 'La cantidad de las tareas e ítems del cierre no puede ser 0'
    }),
    'TicketTareasItemsCierre.errors.clasificacion_requerida': defineMessage({
        id: 'TicketTareasItemsCierre.errors.clasificacion_requerida',
        defaultMessage: 'Debe indicar la clasificación de los ítems del cierre'
    }),
    'ticketsService.errors.gerenciador_taller_no_modificable_en_estado': defineMessage({
        id: 'ticketsService.errors.gerenciador_taller_no_modificable_en_estado',
        defaultMessage: 'No es posible modificar el gerenciador o el taller del ticket en su estado actual.'
    }),
    'ticketsService.errors.item_no_brindado_por_proveedor': defineMessage({
        id: 'ticketsService.errors.item_no_brindado_por_proveedor',
        defaultMessage: 'Alguno de los ítems indicados no lo brinda el proveedor para su servicio.'
    }),
    'ticketsService.errors.fecha_hora_turno_invalida': defineMessage({
        id: 'ticketsService.errors.fecha_hora_turno_invalida',
        defaultMessage: 'La Fecha de Turno no es válida.'
    }),
    'ticketsService.errors.cierre_cantidad_requerida': defineMessage({
        id: 'ticketsService.errors.cierre_cantidad_requerida',
        defaultMessage: 'La cantidad de las tareas e ítems del cierre no puede ser 0'
    }),
    'ticketsService.errors.cierre_clasificacion_requerida': defineMessage({
        id: 'ticketsService.errors.cierre_clasificacion_requerida',
        defaultMessage: 'Debe indicar la clasificación de los ítems del cierre'
    }),
    '2fa.error.El_codigo_no-pudo_ser_verificado': defineMessage({
        id: '2fa.error.El_codigo_no-pudo_ser_verificado',
        defaultMessage: 'El código no pudo ser verificado'
    }),
    '2fa.totp.error.codigo_invalido': defineMessage({
        id: '2fa.totp.error.codigo_invalido',
        defaultMessage: 'El código TOTP no pudo ser verificado'
    }),
    '2fa.totp.error.setup_no_completado': defineMessage({
        id: '2fa.totp.error.setup_no_completado',
        defaultMessage: 'Debe completar la configuración TOTP antes de verificar'
    }),
    '2fa.recovery.error.codigo_invalido': defineMessage({
        id: '2fa.recovery.error.codigo_invalido',
        defaultMessage: 'El código de recuperación es inválido o ya fue utilizado'
    }),
    '2fa.error.metodo_no_habilitado': defineMessage({
        id: '2fa.error.metodo_no_habilitado',
        defaultMessage: 'Método 2FA no disponible. Contacte al administrador.'
    }),
    '2fa.error.sesion_invalida': defineMessage({
        id: '2fa.error.sesion_invalida',
        defaultMessage: 'Sesión inválida. Vuelva a iniciar sesión.'
    }),
    'personaRepository.errors.direccion_email_existe_en_usuario_sso': defineMessage({
        id: 'personaRepository.errors.direccion_email_existe_en_usuario_sso',
        defaultMessage: 'Dirección email existe en Usuario SSO'
    }),
    'personaRepository.errors.usuario_sso_existe_en_email': defineMessage({
        id: 'personaRepository.errors.usuario_sso_existe_en_email',
        defaultMessage: 'Usuario SSO existe en email'
    }),
    'personaRepository.errors.usuario_sso_existe': defineMessage({
        id: 'personaRepository.errors.usuario_sso_existe',
        defaultMessage: 'Usuario SSO existe'
    }),
    'CompaniaOrigenController.errors.Nombre_de_la_compania_de_origen_ya_existe': defineMessage({
        id: 'CompaniaOrigenController.errors.Nombre_de_la_compania_de_origen_ya_existe',
        defaultMessage: 'Nombre de la compania de origen ya existe'
    }),
    'CompaniaOrigenController.errors.Compania_de_origen_no_existe': defineMessage({
        id: 'CompaniaOrigenController.errors.Compania_de_origen_no_existe',
        defaultMessage: 'Compania_de_origen_no_existe'
    }),
    'CompaniaOrigenController.errors.error_al_subir_el_archivo': defineMessage({
        id: 'CompaniaOrigenController.errors.error_al_subir_el_archivo',
        defaultMessage: 'Ocurrió un error al subir el archivo'
    }),
    'CompaniaOrigenController.errors.no_pudo_realizar_importacion_fallo_creacion_log': defineMessage({
        id: 'CompaniaOrigenController.errors.no_pudo_realizar_importacion_fallo_creacion_log',
        defaultMessage: 'No se pudo realizar la importación por fallo en la creación del log'
    }),
    'CompaniaOrigenController.errors.archivo_no_cumple_formato_faltan_columnas': defineMessage({
        id: 'CompaniaOrigenController.errors.archivo_no_cumple_formato_faltan_columnas',
        defaultMessage: 'El archivo no cumple con el formato, faltan columnas'
    }),
    'CompaniaOrigenController.errors.no_se_pudieron_leer_columnas_del_archivo': defineMessage({
        id: 'CompaniaOrigenController.errors.no_se_pudieron_leer_columnas_del_archivo',
        defaultMessage: 'No se pudieron leer las columnas del archivo'
    }),
    'CompaniaOrigenController.errors.el_archivo_no_tiene_datos_validos': defineMessage({
        id: 'CompaniaOrigenController.errors.el_archivo_no_tiene_datos_validos',
        defaultMessage: 'El archivo no tiene datos validos'
    }),
    'authController.errors.azure_fallo_token': defineMessage({
        id: 'authController.errors.azure_fallo_token',
        defaultMessage: 'Fallo en generación de token'
    }),
    'ticketsRepository.errors.Transportadora_no_existe': defineMessage({
        id: 'ticketsRepository.errors.Transportadora_no_existe',
        defaultMessage: 'Transportadora no existe'
    }),
    'ticketsRepository.errors.Rentadora_no_existe': defineMessage({
        id: 'ticketsRepository.errors.Rentadora_no_existe',
        defaultMessage: 'Rentadora no existe'
    }),
    'periodosController.errors.no_existe_configPeriodo_con_ese_id': defineMessage({
        id: 'periodosController.errors.no_existe_configPeriodo_con_ese_id',
        defaultMessage: 'No existe configuracion de periodo con ese id'
    }),
    'periodosController.errors.ya_existe_configPeriodo': defineMessage({
        id: 'periodosController.errors.ya_existe_configPeriodo',
        defaultMessage: 'No es posible generar mas de una configuracion de periodo, ya existe una creada'
    }),
    'PeriodoRepository.errors.frecuencia_invalida': defineMessage({
        id: 'PeriodoRepository.errors.frecuencia_invalida',
        defaultMessage: 'Frecuencia inválida'
    }),
    'movilRepository.errors.motivo_cambio_estado_requerido': defineMessage({
        id: 'movilRepository.errors.motivo_cambio_estado_requerido',
        defaultMessage: 'Motivo del cambio de estado es requerido'
    }),
    'movilRepository.errors.motivo_valor_unidad_duplicado': defineMessage({
        id: 'movilRepository.errors.motivo_valor_unidad_duplicado',
        defaultMessage: 'Valor de unidad duplicado en otro vehículo'
    }),
    'movilRepository.errors.unidad_medidor_id_incorrecto': defineMessage({
        id: 'movilRepository.errors.unidad_medidor_id_incorrecto',
        defaultMessage: 'Unidad medidor es incorrecta'
    }),
    'formularioRecurrenciaService.dashboard.total_controles_programados': defineMessage({
        id: 'formularioRecurrenciaService.dashboard.total_controles_programados',
        defaultMessage: 'Total de controles programados'
    }),
    'formularioRecurrenciaService.dashboard.pendientes': defineMessage({
        id: 'formularioRecurrenciaService.dashboard.pendientes',
        defaultMessage: 'Pendientes (A vencer)'
    }),
    'formularioRecurrenciaService.dashboard.vencidas': defineMessage({
        id: 'formularioRecurrenciaService.dashboard.vencidas',
        defaultMessage: 'Vencidas'
    }),
    'formularioRecurrenciaService.dashboard.realizadas': defineMessage({
        id: 'formularioRecurrenciaService.dashboard.realizadas',
        defaultMessage: 'Realizadas (Sin vencer)'
    }),
    'formularioTransportadora.error.nombre_requerido': defineMessage({
        id: 'formularioTransportadora.error.nombre_requerido',
        defaultMessage: 'El nombre es requerido y debe ser un string no vacío'
    }),
    'formularioTransportadora.error.nombre_repetido': defineMessage({
        id: 'formularioTransportadora.error.nombre_repetido',
        defaultMessage: 'Ya existe una transportadora con ese nombre'
    }),
    'formularioTransportadora.error.no_existe_transportadora_con_ese_id': defineMessage({
        id: 'formularioTransportadora.error.no_existe_transportadora_con_ese_id',
        defaultMessage: 'No existe transportadora con ese id'
    }),
    'formularioTransportadora.error.no_se_puede_eliminar_por_relaciones': defineMessage({
        id: 'formularioTransportadora.error.no_se_puede_eliminar_por_relaciones',
        defaultMessage: 'No se puede eliminar la transportadora porque tiene relaciones con otros elementos'
    }),
    'formularioTransportadora.error.no_se_puede_inactivar_por_relaciones': defineMessage({
        id: 'formularioTransportadora.error.no_se_puede_inactivar_por_relaciones',
        defaultMessage: 'No se puede inactivar la transportadora porque tiene relaciones con otros elementos'
    }),
    'ya_existe_una_sede_externa_con_este_nombre': defineMessage({
        id: 'ya_existe_una_sede_externa_con_este_nombre',
        defaultMessage: 'Ya existe una sede externa con este nombre'
    }),
    'PowerBIReport.errors_handleError.error_en_configuracion_powerbi': defineMessage({
        id: 'PowerBIReport.errors_handleError.error_en_configuracion_powerbi',
        defaultMessage: 'Error en configuración PowerBI'
    }),
    'PowerBIReport.errors_handleError.contacte_al_administrador': defineMessage({
        id: 'PowerBIReport.errors_handleError.contacte_al_administrador',
        defaultMessage: 'Contacte al administrador.'
    }),
    'PowerBIReport.errors_handleError.button_aceptar': defineMessage({
        id: 'PowerBIReport.errors_handleError.button_aceptar',
        defaultMessage: 'Aceptar'
    }),
    'basesRepository.errors.error_periodo_iniciado_no_se_puede_modificar_subregion': defineMessage({
        id: 'basesRepository.errors.error_periodo_iniciado_no_se_puede_modificar_subregion',
        defaultMessage: 'No se puede modificar la subregión porque el período ya fue iniciado'
    }),
    'subregionRepository.errors.error_periodo_iniciado_no_se_puede_modificar_region': defineMessage({
        id: 'subregionRepository.errors.error_periodo_iniciado_no_se_puede_modificar_region',
        defaultMessage: 'No se puede modificar la región porque el período ya fue iniciado'
    }),
    'moviles.historial_estados.movil_id_requerido': defineMessage({
        id: 'moviles.historial_estados.movil_id_requerido',
        defaultMessage: 'El ID del móvil es requerido'
    }),
    'moviles.historial_estados.formato_fecha_invalido': defineMessage({
        id: 'moviles.historial_estados.formato_fecha_invalido',
        defaultMessage: 'Formato de filtro fecha inválido (fecha)'
    }),
    'moviles.historial_estados.formato_fecha_desde_invalido': defineMessage({
        id: 'moviles.historial_estados.formato_fecha_desde_invalido',
        defaultMessage: 'Formato de filtro fecha inválido (fecha desde)'
    }),
    'moviles.historial_estados.formato_fecha_hasta_invalido': defineMessage({
        id: 'moviles.historial_estados.formato_fecha_hasta_invalido',
        defaultMessage: 'Formato de filtro fecha inválido (fecha hasta)'
    }),
    'moviles.historico_administracion.formato_fecha_invalido': defineMessage({
        id: 'moviles.historico_administracion.formato_fecha_invalido',
        defaultMessage: 'Formato de filtro fecha inválido'
    }),
    'SafeFeedbackService.dashboard.reportes_pendientes': defineMessage({
        id: 'SafeFeedbackService.dashboard.reportes_pendientes',
        defaultMessage: 'Pendientes'
    }),
    'SafeFeedbackService.dashboard.reportes_confirmados': defineMessage({
        id: 'SafeFeedbackService.dashboard.reportes_confirmados',
        defaultMessage: 'Confirmados'
    }),
    'SafeFeedbackService.dashboard.reportes_desestimados': defineMessage({
        id: 'SafeFeedbackService.dashboard.reportes_desestimados',
        defaultMessage: 'Desestimados'
    }),
    'SafeFeedbackRankingService.dashboard.conductores_evaluados': defineMessage({
        id: 'SafeFeedbackRankingService.dashboard.conductores_evaluados',
        defaultMessage: 'Conductores evaluados'
    }),
    'SafeFeedbackRankingService.dashboard.total_eventos': defineMessage({
        id: 'SafeFeedbackRankingService.dashboard.total_eventos',
        defaultMessage: 'Total eventos'
    }),
    'SafeFeedbackRankingService.dashboard.confirmados': defineMessage({
        id: 'SafeFeedbackRankingService.dashboard.confirmados',
        defaultMessage: 'Confirmados'
    }),
    'SafeFeedbackRankingService.dashboard.desestimados': defineMessage({
        id: 'SafeFeedbackRankingService.dashboard.desestimados',
        defaultMessage: 'Desestimados'
    }),
    'SafeFeedbackRankingService.dashboard.puntos_acumulados': defineMessage({
        id: 'SafeFeedbackRankingService.dashboard.puntos_acumulados',
        defaultMessage: 'Puntos acumulados'
    }),
    'correctivosAbm.no_se_puede_crear_ticket': defineMessage({
        id: 'correctivosAbm.no_se_puede_crear_ticket',
        defaultMessage: 'No se puede crear el ticket'
    }),
    'correctivosAbm.max_tickets_blocked': defineMessage({
        id: 'correctivosAbm.max_tickets_blocked',
        defaultMessage: 'Ya existen el máximo ({limite}) de tickets activos para el {entidad} {entidadName} y servicio {servicio}.'
    }),
    'correctivosAbm.max_tickets_blocked_generico': defineMessage({
        id: 'correctivosAbm.max_tickets_blocked_generico',
        defaultMessage: 'La entidad supera el máximo permitido de tickets activos para el servicio.'
    }),
    'correctivosAbm.advertencia_ya_existen_tickets': defineMessage({
        id: 'correctivosAbm.advertencia_ya_existen_tickets',
        defaultMessage: 'Atención'
    }),
    'correctivosAbm.max_tickets_warning': defineMessage({
        id: 'correctivosAbm.max_tickets_warning',
        defaultMessage: 'Este {entidad} ({entidadName}) ya tiene tickets activos para el servicio ({servicio})'
    }),
    'personas.documento_numero_obligatorio': defineMessage({
        id: 'personas.documento_numero_obligatorio',
        defaultMessage: 'El campo Número de documento es obligatorio.'
    }),
    'personas.documento_numero_duplicado': defineMessage({
        id: 'personas.documento_numero_duplicado',
        defaultMessage: 'Ya existe otra persona con el mismo tipo y número de documento.'
    }),
    'personas.licencia_obligatoria': defineMessage({
        id: 'personas.licencia_obligatoria',
        defaultMessage: 'El bloque de licencia es obligatorio para el perfil asignado.'
    }),
    'personas.transportadora_obligatoria': defineMessage({
        id: 'personas.transportadora_obligatoria',
        defaultMessage: 'El campo Transportadora es obligatorio.'
    }),
    'personas.funcion_obligatoria': defineMessage({
        id: 'personas.funcion_obligatoria',
        defaultMessage: 'El campo Función es obligatorio.'
    }),
    'movilController.errors.transportadora_obligatoria': defineMessage({
        id: 'movilController.errors.transportadora_obligatoria',
        defaultMessage: 'El campo Transportadora es obligatorio.'
    }),
    'movilController.errors.funcion_obligatoria': defineMessage({
        id: 'movilController.errors.funcion_obligatoria',
        defaultMessage: 'El campo Función es obligatorio.'
    }),
    'movilController.errors.funcion_inexistente': defineMessage({
        id: 'movilController.errors.funcion_inexistente',
        defaultMessage: 'La Función indicada no existe.'
    }),
    // Unit system labels - Metric
    'units.metrico.distance': defineMessage({
        id: 'units.metrico.distance',
        defaultMessage: 'km'
    }),
    'units.metrico.distancePlural': defineMessage({
        id: 'units.metrico.distancePlural',
        defaultMessage: 'kms'
    }),
    'units.metrico.volume': defineMessage({
        id: 'units.metrico.volume',
        defaultMessage: 'lts'
    }),
    'units.metrico.volumeFull': defineMessage({
        id: 'units.metrico.volumeFull',
        defaultMessage: 'litros'
    }),
    'units.metrico.weight': defineMessage({
        id: 'units.metrico.weight',
        defaultMessage: 'kg'
    }),
    'units.metrico.dimension': defineMessage({
        id: 'units.metrico.dimension',
        defaultMessage: 'mts'
    }),
    'units.metrico.fuelEfficiency': defineMessage({
        id: 'units.metrico.fuelEfficiency',
        defaultMessage: 'LT/100Km'
    }),
    'units.metrico.costPerDistance': defineMessage({
        id: 'units.metrico.costPerDistance',
        defaultMessage: 'Costo/Km'
    }),
    'units.metrico.distancePerVolume': defineMessage({
        id: 'units.metrico.distancePerVolume',
        defaultMessage: 'Kms por Litro'
    }),
    'units.metrico.costPerVolume': defineMessage({
        id: 'units.metrico.costPerVolume',
        defaultMessage: 'Costo por Litro'
    }),
    // Unit system labels - Imperial
    'units.imperial.distance': defineMessage({
        id: 'units.imperial.distance',
        defaultMessage: 'mi'
    }),
    'units.imperial.distancePlural': defineMessage({
        id: 'units.imperial.distancePlural',
        defaultMessage: 'mi'
    }),
    'units.imperial.volume': defineMessage({
        id: 'units.imperial.volume',
        defaultMessage: 'gal'
    }),
    'units.imperial.volumeFull': defineMessage({
        id: 'units.imperial.volumeFull',
        defaultMessage: 'galones'
    }),
    'units.imperial.weight': defineMessage({
        id: 'units.imperial.weight',
        defaultMessage: 'lb'
    }),
    'units.imperial.dimension': defineMessage({
        id: 'units.imperial.dimension',
        defaultMessage: 'ft'
    }),
    'units.imperial.fuelEfficiency': defineMessage({
        id: 'units.imperial.fuelEfficiency',
        defaultMessage: 'GAL/100Mi'
    }),
    'units.imperial.costPerDistance': defineMessage({
        id: 'units.imperial.costPerDistance',
        defaultMessage: 'Costo/Mi'
    }),
    'units.imperial.distancePerVolume': defineMessage({
        id: 'units.imperial.distancePerVolume',
        defaultMessage: 'Mi por Galón'
    }),
    'units.imperial.costPerVolume': defineMessage({
        id: 'units.imperial.costPerVolume',
        defaultMessage: 'Costo por Galón'
    }),
    'SafeFeedbackTipoFormulario.ya_existe_un_tipo_activo': defineMessage({
        id: 'SafeFeedbackTipoFormulario.ya_existe_un_tipo_activo',
        defaultMessage: 'Ya existe un tipo de formulario activo, desactive el existente'
    }),
    'permission.ERIC_CHATBOT_CONSULTAR': defineMessage({
        id: 'permission.ERIC_CHATBOT_CONSULTAR',
        defaultMessage: 'Consultar análisis Eric IA (analista)'
    }),
    'permission.ERIC_CREAR': defineMessage({
        id: 'permission.ERIC_CREAR',
        defaultMessage: 'Crear inspección Eric IA (app móvil)'
    }),
    'permission.ERIC_INSPECTOR_CREAR': defineMessage({
        id: 'permission.ERIC_INSPECTOR_CREAR',
        defaultMessage: 'Crear inspección Eric IA'
    }),
    'permission.ERIC_INSPECTOR_LISTAR': defineMessage({
        id: 'permission.ERIC_INSPECTOR_LISTAR',
        defaultMessage: 'Listar inspecciones Eric IA'
    }),
    'permission.ERIC_INSPECTOR_VISUALIZAR': defineMessage({
        id: 'permission.ERIC_INSPECTOR_VISUALIZAR',
        defaultMessage: 'Visualizar inspección Eric IA'
    }),
    'permission.ERIC_INSPECTOR_MODIFICAR': defineMessage({
        id: 'permission.ERIC_INSPECTOR_MODIFICAR',
        defaultMessage: 'Modificar inspección Eric IA'
    }),
    'permission.ERIC_INSPECTOR_CREAR_TICKET': defineMessage({
        id: 'permission.ERIC_INSPECTOR_CREAR_TICKET',
        defaultMessage: 'Crear ticket desde inspección Eric IA'
    }),
    'permission.ERIC_INSPECTOR_CONFIGURAR': defineMessage({
        id: 'permission.ERIC_INSPECTOR_CONFIGURAR',
        defaultMessage: 'Configurar integración Eric IA'
    }),
    'permission.ERIC_INSPECTOR_CONSULTAR': defineMessage({
        id: 'permission.ERIC_INSPECTOR_CONSULTAR',
        defaultMessage: 'Consultar inspecciones Eric IA'
    }),

    // ── Eric IA — Enums ────────────────────────────────────────────────────────
    'eric_inspeccion_estado.PROCESANDO': defineMessage({
        id: 'eric_inspeccion_estado.PROCESANDO',
        defaultMessage: 'Procesando'
    }),
    'eric_inspeccion_estado.COMPLETADA': defineMessage({
        id: 'eric_inspeccion_estado.COMPLETADA',
        defaultMessage: 'Completada'
    }),

    'eric_danio_estado_incremental.NUEVO': defineMessage({
        id: 'eric_danio_estado_incremental.NUEVO',
        defaultMessage: 'Nuevo'
    }),
    'eric_danio_estado_incremental.PERSISTENTE': defineMessage({
        id: 'eric_danio_estado_incremental.PERSISTENTE',
        defaultMessage: 'Persistente'
    }),
    'eric_danio_estado_incremental.RESUELTO': defineMessage({
        id: 'eric_danio_estado_incremental.RESUELTO',
        defaultMessage: 'Resuelto'
    }),

    'eric_danio_resolucion.REPARADO': defineMessage({
        id: 'eric_danio_resolucion.REPARADO',
        defaultMessage: 'Reparado'
    }),
    'eric_danio_resolucion.ACEPTADO': defineMessage({
        id: 'eric_danio_resolucion.ACEPTADO',
        defaultMessage: 'Aceptado'
    }),
    'eric_danio_resolucion.RECHAZADO': defineMessage({
        id: 'eric_danio_resolucion.RECHAZADO',
        defaultMessage: 'Rechazado'
    }),

    'eric_ocr_motivo.NO_COINCIDE': defineMessage({
        id: 'eric_ocr_motivo.NO_COINCIDE',
        defaultMessage: 'No coincide'
    }),
    'eric_ocr_motivo.REGLA_NEGOCIO_ODOMETRO': defineMessage({
        id: 'eric_ocr_motivo.REGLA_NEGOCIO_ODOMETRO',
        defaultMessage: 'Regla de negocio — odómetro'
    }),

    'eric_errores_motivo.TIMEOUT': defineMessage({
        id: 'eric_errores_motivo.TIMEOUT',
        defaultMessage: 'Timeout del proveedor'
    }),
    'eric_errores_motivo.ERROR_PROVEEDOR': defineMessage({
        id: 'eric_errores_motivo.ERROR_PROVEEDOR',
        defaultMessage: 'Error del proveedor'
    }),
    'eric_errores_motivo.FOTOS_INSUFICIENTES': defineMessage({
        id: 'eric_errores_motivo.FOTOS_INSUFICIENTES',
        defaultMessage: 'Fotos insuficientes'
    }),

    // ── Eric IA — Motivos de rechazo (InspektLabs rejection reasons) ───────────
    'eric_rechazo.INCOMPATIBLE_IMAGE': defineMessage({
        id: 'eric_rechazo.INCOMPATIBLE_IMAGE',
        defaultMessage: 'Imagen no compatible'
    }),
    'eric_rechazo.UNSUPPORTED_FILE_FORMAT': defineMessage({
        id: 'eric_rechazo.UNSUPPORTED_FILE_FORMAT',
        defaultMessage: 'Formato de archivo no soportado'
    }),
    'eric_rechazo.INCOMPATIBLE_VIDEO': defineMessage({
        id: 'eric_rechazo.INCOMPATIBLE_VIDEO',
        defaultMessage: 'Video no compatible'
    }),
    'eric_rechazo.IMAGES_AND_VIDEO_IN_BATCH': defineMessage({
        id: 'eric_rechazo.IMAGES_AND_VIDEO_IN_BATCH',
        defaultMessage: 'Imágenes y video subidos juntos'
    }),
    'eric_rechazo.NO_IMAGE_OR_VIDEO_IN_BATCH': defineMessage({
        id: 'eric_rechazo.NO_IMAGE_OR_VIDEO_IN_BATCH',
        defaultMessage: 'No se encontraron imágenes ni video'
    }),
    'eric_rechazo.ALL_SIDE_NOT_COVERED': defineMessage({
        id: 'eric_rechazo.ALL_SIDE_NOT_COVERED',
        defaultMessage: 'No se capturaron todos los lados del vehículo'
    }),
    'eric_rechazo.PHOTO_OF_PHOTO': defineMessage({
        id: 'eric_rechazo.PHOTO_OF_PHOTO',
        defaultMessage: 'Fotografía de una fotografía'
    }),
    'eric_rechazo.LOW_LIGHT': defineMessage({
        id: 'eric_rechazo.LOW_LIGHT',
        defaultMessage: 'Baja luminosidad'
    }),
    'eric_rechazo.NON_CAR': defineMessage({
        id: 'eric_rechazo.NON_CAR',
        defaultMessage: 'No es un vehículo'
    }),
    'eric_rechazo.MULTIPLE_CARS': defineMessage({
        id: 'eric_rechazo.MULTIPLE_CARS',
        defaultMessage: 'Múltiples vehículos en la inspección'
    }),
    'eric_rechazo.MULTIPLE_STICKERS': defineMessage({
        id: 'eric_rechazo.MULTIPLE_STICKERS',
        defaultMessage: 'Exceso de stickers en el vehículo'
    }),
    'eric_rechazo.CAR_INTERIOR': defineMessage({
        id: 'eric_rechazo.CAR_INTERIOR',
        defaultMessage: 'Imágenes tomadas desde el interior'
    }),
    'eric_rechazo.GARAGE_WORKSHOP_INSPECTION': defineMessage({
        id: 'eric_rechazo.GARAGE_WORKSHOP_INSPECTION',
        defaultMessage: 'Inspección realizada en taller o garaje'
    }),
    'eric_rechazo.LARGE_SIZE_CLAIM': defineMessage({
        id: 'eric_rechazo.LARGE_SIZE_CLAIM',
        defaultMessage: 'Daño severo — requiere inspección manual'
    }),
    'eric_rechazo.INSUFFICIENT_COVERAGE': defineMessage({
        id: 'eric_rechazo.INSUFFICIENT_COVERAGE',
        defaultMessage: 'Cobertura insuficiente del vehículo'
    }),
    'eric_rechazo.ALL_FRAMES_NOT_RECEIVED': defineMessage({
        id: 'eric_rechazo.ALL_FRAMES_NOT_RECEIVED',
        defaultMessage: 'Carga de fotos incompleta'
    }),
    'eric_rechazo.VIN_MANIPULATION': defineMessage({
        id: 'eric_rechazo.VIN_MANIPULATION',
        defaultMessage: 'Manipulación de número de chasis (VIN)'
    }),
    'eric_rechazo.LICENCE_PLATE_MANIPULATION': defineMessage({
        id: 'eric_rechazo.LICENCE_PLATE_MANIPULATION',
        defaultMessage: 'Manipulación de patente'
    }),
    'eric_rechazo.IMAGE_MANIPULATION': defineMessage({
        id: 'eric_rechazo.IMAGE_MANIPULATION',
        defaultMessage: 'Imágenes alteradas o invertidas'
    }),
    'eric_rechazo.BLURRY': defineMessage({
        id: 'eric_rechazo.BLURRY',
        defaultMessage: 'Imágenes borrosas'
    }),
    'eric_rechazo.MULTIPLE_LOCATIONS': defineMessage({
        id: 'eric_rechazo.MULTIPLE_LOCATIONS',
        defaultMessage: 'Imágenes tomadas en múltiples ubicaciones'
    }),
    'eric_rechazo.MUDDY_VEHICLE': defineMessage({
        id: 'eric_rechazo.MUDDY_VEHICLE',
        defaultMessage: 'Vehículo cubierto de barro'
    }),
    'eric_rechazo.HIGH_DIRT_OR_SNOW': defineMessage({
        id: 'eric_rechazo.HIGH_DIRT_OR_SNOW',
        defaultMessage: 'Vehículo con suciedad o nieve'
    }),

    // ── Eric IA — Tipos de vehículo (InspektLabs vehicleType) ─────────────────
    'eric_vehiculo_tipo.sedan': defineMessage({ id: 'eric_vehiculo_tipo.sedan', defaultMessage: 'Sedán' }),
    'eric_vehiculo_tipo.car_sedan': defineMessage({ id: 'eric_vehiculo_tipo.car_sedan', defaultMessage: 'Sedán' }),
    'eric_vehiculo_tipo.hatchback': defineMessage({ id: 'eric_vehiculo_tipo.hatchback', defaultMessage: 'Hatchback' }),
    'eric_vehiculo_tipo.car_hatchback': defineMessage({ id: 'eric_vehiculo_tipo.car_hatchback', defaultMessage: 'Hatchback' }),
    'eric_vehiculo_tipo.suv': defineMessage({ id: 'eric_vehiculo_tipo.suv', defaultMessage: 'SUV' }),
    'eric_vehiculo_tipo.car_suv': defineMessage({ id: 'eric_vehiculo_tipo.car_suv', defaultMessage: 'SUV' }),
    'eric_vehiculo_tipo.pickup': defineMessage({ id: 'eric_vehiculo_tipo.pickup', defaultMessage: 'Pickup' }),
    'eric_vehiculo_tipo.car_pickup': defineMessage({ id: 'eric_vehiculo_tipo.car_pickup', defaultMessage: 'Pickup' }),
    'eric_vehiculo_tipo.pickup_truck': defineMessage({ id: 'eric_vehiculo_tipo.pickup_truck', defaultMessage: 'Pickup' }),
    'eric_vehiculo_tipo.car_pickup_truck': defineMessage({ id: 'eric_vehiculo_tipo.car_pickup_truck', defaultMessage: 'Pickup' }),
    'eric_vehiculo_tipo.minivan': defineMessage({ id: 'eric_vehiculo_tipo.minivan', defaultMessage: 'Minivan' }),
    'eric_vehiculo_tipo.car_minivan': defineMessage({ id: 'eric_vehiculo_tipo.car_minivan', defaultMessage: 'Minivan' }),
    'eric_vehiculo_tipo.van': defineMessage({ id: 'eric_vehiculo_tipo.van', defaultMessage: 'Furgoneta' }),
    'eric_vehiculo_tipo.car_van': defineMessage({ id: 'eric_vehiculo_tipo.car_van', defaultMessage: 'Furgoneta' }),
    'eric_vehiculo_tipo.truck': defineMessage({ id: 'eric_vehiculo_tipo.truck', defaultMessage: 'Camión' }),
    'eric_vehiculo_tipo.car_truck': defineMessage({ id: 'eric_vehiculo_tipo.car_truck', defaultMessage: 'Camión' }),
    'eric_vehiculo_tipo.coupe': defineMessage({ id: 'eric_vehiculo_tipo.coupe', defaultMessage: 'Coupé' }),
    'eric_vehiculo_tipo.car_coupe': defineMessage({ id: 'eric_vehiculo_tipo.car_coupe', defaultMessage: 'Coupé' }),
    'eric_vehiculo_tipo.convertible': defineMessage({ id: 'eric_vehiculo_tipo.convertible', defaultMessage: 'Descapotable' }),
    'eric_vehiculo_tipo.car_convertible': defineMessage({ id: 'eric_vehiculo_tipo.car_convertible', defaultMessage: 'Descapotable' }),
    'eric_vehiculo_tipo.wagon': defineMessage({ id: 'eric_vehiculo_tipo.wagon', defaultMessage: 'Station Wagon' }),
    'eric_vehiculo_tipo.car_wagon': defineMessage({ id: 'eric_vehiculo_tipo.car_wagon', defaultMessage: 'Station Wagon' }),
    'eric_vehiculo_tipo.station_wagon': defineMessage({ id: 'eric_vehiculo_tipo.station_wagon', defaultMessage: 'Station Wagon' }),
    'eric_vehiculo_tipo.car_station_wagon': defineMessage({ id: 'eric_vehiculo_tipo.car_station_wagon', defaultMessage: 'Station Wagon' }),
    'eric_vehiculo_tipo.crossover': defineMessage({ id: 'eric_vehiculo_tipo.crossover', defaultMessage: 'Crossover' }),
    'eric_vehiculo_tipo.car_crossover': defineMessage({ id: 'eric_vehiculo_tipo.car_crossover', defaultMessage: 'Crossover' }),
    'eric_vehiculo_tipo.mpv': defineMessage({ id: 'eric_vehiculo_tipo.mpv', defaultMessage: 'Monovolumen' }),
    'eric_vehiculo_tipo.car_mpv': defineMessage({ id: 'eric_vehiculo_tipo.car_mpv', defaultMessage: 'Monovolumen' }),
    'eric_vehiculo_tipo.bus': defineMessage({ id: 'eric_vehiculo_tipo.bus', defaultMessage: 'Bus' }),
    'eric_vehiculo_tipo.tractor': defineMessage({ id: 'eric_vehiculo_tipo.tractor', defaultMessage: 'Tractor' }),

    'movilRelacionService.errors.activo_asociado_ya_posee_vinculacion_para_ese_periodo': defineMessage({
        id: 'movilRelacionService.errors.activo_asociado_ya_posee_vinculacion_para_ese_periodo',
        defaultMessage: 'El activo asociado ya posee una vinculación activa.'
    }),
    'movilRelacionService.errors.un_activo_no_puede_vincularse_consigo_mismo': defineMessage({
        id: 'movilRelacionService.errors.un_activo_no_puede_vincularse_consigo_mismo',
        defaultMessage: 'Un activo no puede vincularse consigo mismo.'
    }),
    'movilRelacionService.errors.la_relacion_ya_se_encuentra_cerrada': defineMessage({
        id: 'movilRelacionService.errors.la_relacion_ya_se_encuentra_cerrada',
        defaultMessage: 'La relación ya se encuentra cerrada.'
    }),
    'movilRelacionService.errors.la_fecha_de_cierre_ingresada_no_es_valida': defineMessage({
        id: 'movilRelacionService.errors.la_fecha_de_cierre_ingresada_no_es_valida',
        defaultMessage: 'La fecha de cierre ingresada no es válida.'
    }),
    'movilRelacionService.errors.la_fecha_de_cierre_no_puede_ser_anterior_a_la_fecha_de_inicio': defineMessage({
        id: 'movilRelacionService.errors.la_fecha_de_cierre_no_puede_ser_anterior_a_la_fecha_de_inicio',
        defaultMessage: 'La fecha de cierre no puede ser anterior a la fecha de inicio.'
    }),
    'movilRelacionService.errors.el_tipo_de_modelo_no_permite_vinculacion': defineMessage({
        id: 'movilRelacionService.errors.el_tipo_de_modelo_no_permite_vinculacion',
        defaultMessage: 'El tipo de modelo del vehículo no permite la vinculación de activos.'
    }),
    'personaController.errors.la_persona_no_tiene_id_asociado': defineMessage({
        id: 'personaController.errors.la_persona_no_tiene_id_asociado',
        defaultMessage: 'La persona no tiene un id asociado.'
    }),
    'personaController.errors.la_persona_no_ingreso_moviles': defineMessage({
        id: 'personaController.errors.la_persona_no_ingreso_moviles',
        defaultMessage: 'La persona no ingresó móviles.'
    }),
    'personaController.errors.id_persona_invalido': defineMessage({
        id: 'personaController.errors.id_persona_invalido',
        defaultMessage: 'El id de la persona es inválido.'
    }),
    'personaController.errors.perfil_id_requerido': defineMessage({
        id: 'personaController.errors.perfil_id_requerido',
        defaultMessage: 'El id del perfil es requerido.'
    }),
    'personaController.errors.archivo_no_encontrado': defineMessage({
        id: 'personaController.errors.archivo_no_encontrado',
        defaultMessage: 'Archivo no encontrado.'
    }),
    'personaController.errors.import.no_se_recibio_ningun_archivo': defineMessage({
        id: 'personaController.errors.import.no_se_recibio_ningun_archivo',
        defaultMessage: 'No se recibió ningún archivo.'
    }),
    'personaController.errors.import.error_al_subir_el_archivo': defineMessage({
        id: 'personaController.errors.import.error_al_subir_el_archivo',
        defaultMessage: 'Error al subir el archivo.'
    }),
    'personaController.errors.import.error_al_leer_el_excel': defineMessage({
        id: 'personaController.errors.import.error_al_leer_el_excel',
        defaultMessage: 'Error al leer el Excel.'
    }),
    'personaController.errors.import.el_excel_no_contiene_filas_en_la_hoja_principal': defineMessage({
        id: 'personaController.errors.import.el_excel_no_contiene_filas_en_la_hoja_principal',
        defaultMessage: 'El Excel no contiene filas en la hoja principal.'
    }),
    'personaController.errors.import.faltan_columnas_requeridas_en_el_excel': defineMessage({
        id: 'personaController.errors.import.faltan_columnas_requeridas_en_el_excel',
        defaultMessage: 'Faltan columnas requeridas en el Excel.'
    }),
    'personaController.errors.import.el_excel_tiene_celdas_vacias_en_columnas_obligatorias': defineMessage({
        id: 'personaController.errors.import.el_excel_tiene_celdas_vacias_en_columnas_obligatorias',
        defaultMessage: 'El Excel tiene celdas vacías en columnas obligatorias.'
    }),
    'personaController.errors.import.celda_vacia_en_columna_obligatoria': defineMessage({
        id: 'personaController.errors.import.celda_vacia_en_columna_obligatoria',
        defaultMessage: 'Celda vacía en columna obligatoria.'
    }),
    'personaController.errors.import.celda_vacia_en_columna_obligatoria_para_usuario': defineMessage({
        id: 'personaController.errors.import.celda_vacia_en_columna_obligatoria_para_usuario',
        defaultMessage: 'Celda vacía en columna obligatoria para usuario.'
    }),
    'personaController.errors.import.duplicados_en_el_excel': defineMessage({
        id: 'personaController.errors.import.duplicados_en_el_excel',
        defaultMessage: 'Duplicados en el Excel.'
    }),
    'presupuestosService.errors.clasificacion_requerida': defineMessage({
        id: 'presupuestosService.errors.clasificacion_requerida',
        defaultMessage: 'Todos los ítems del presupuesto deben tener una clasificación asignada.'
    }),
    'presupuestosService.errors.borradorNoHabilitado': defineMessage({
        id: 'presupuestosService.errors.borradorNoHabilitado',
        defaultMessage: 'La funcionalidad de guardado de borrador no está habilitada.'
    }),
    'itemClasificacionesService.errors.clasificacion_ya_existe': defineMessage({
        id: 'itemClasificacionesService.errors.clasificacion_ya_existe',
        defaultMessage: 'Ya existe una clasificación con ese nombre.'
    }),
    'itemClasificacionesService.errors.clasificacion_no_encontrada': defineMessage({
        id: 'itemClasificacionesService.errors.clasificacion_no_encontrada',
        defaultMessage: 'La clasificación no fue encontrada.'
    }),
    'servicios.errors.niveles_aprobacion_invalidos': defineMessage({
        id: 'servicios.errors.niveles_aprobacion_invalidos',
        defaultMessage: 'El monto de aprobación Nivel 1 no puede ser mayor al Nivel 2.'
    }),
    'preventivosRepository.errors.preventivo_unica_vez_ya_ejecutado': defineMessage({
        id: 'preventivosRepository.errors.preventivo_unica_vez_ya_ejecutado',
        defaultMessage: 'El servicio es de ejecución única y ya fue ejecutado, por lo que el control no está disponible para una nueva programación.'
    }),
    // VEC-3951: lista todos los ítems excedidos de una vez y no muestra el valor máximo (para no
    // revelarle el tope al proveedor). Reemplaza a 'valor_unitario_supera_maximo', que mostraba {max}.
    'ticketsPresupuestos.errors.items_superan_valor_maximo': defineMessage({
        id: 'ticketsPresupuestos.errors.items_superan_valor_maximo',
        defaultMessage: 'Los siguientes ítems superan el monto máximo permitido: {items}.'
    }),
    // VEC-3781 Sc. 02. El Scenario pide que el mensaje "indique el rango permitido para ese ítem",
    // así que el rango va en el texto y no solo el tope. El mínimo es siempre 0: `items` no tiene
    // columna de costo mínimo, el rango es [0, valorMaximo].
    'inventarioStockService.errors.costo_fuera_de_rango': defineMessage({
        id: 'inventarioStockService.errors.costo_fuera_de_rango',
        defaultMessage: 'El costo unitario está fuera del rango permitido para este ítem ({min} a {max}).'
    }),
    // VEC-3317 — Submódulo de Solicitudes de Stock del módulo de Inventario v3.0.
    // El par de ubicación incompleto y el tipo inválido REUSAN las keys de
    // `inventarioStockService` a propósito: el hecho que describen es idéntico y no depende de la
    // pantalla, así que dos keys para el mismo error serían dos traducciones que mantener.
    'inventarioSolicitudService.errors.modulo_no_habilitado': defineMessage({
        id: 'inventarioSolicitudService.errors.modulo_no_habilitado',
        defaultMessage: 'El módulo de Inventario no está habilitado.'
    }),
    'inventarioSolicitudService.errors.vista_invalida': defineMessage({
        id: 'inventarioSolicitudService.errors.vista_invalida',
        defaultMessage: 'La vista solicitada no existe.'
    }),
    'inventarioSolicitudService.errors.rango_invalido': defineMessage({
        id: 'inventarioSolicitudService.errors.rango_invalido',
        defaultMessage: 'La fecha hasta no puede ser anterior a la fecha desde.'
    }),
    // VEC-3318 — gestión de una solicitud pendiente. El par de ubicación incompleto y el tipo
    // inválido siguen reusando las keys de `inventarioStockService`, igual que en la grilla.
    'inventarioSolicitudService.errors.detalle_cerrado': defineMessage({
        id: 'inventarioSolicitudService.errors.detalle_cerrado',
        defaultMessage: 'Esta solicitud ya fue finalizada o cancelada.'
    }),
    'inventarioSolicitudService.errors.modo_invalido': defineMessage({
        id: 'inventarioSolicitudService.errors.modo_invalido',
        defaultMessage: 'Indicá cómo se resuelve la solicitud: por transferencia desde otro depósito o por compra.'
    }),
    'inventarioSolicitudService.errors.cantidad_invalida': defineMessage({
        id: 'inventarioSolicitudService.errors.cantidad_invalida',
        defaultMessage: 'La cantidad a despachar tiene que ser un número entero mayor a cero.'
    }),
    // Lleva el tope en el context, para que el usuario sepa cuál es el máximo.
    'inventarioSolicitudService.errors.cantidad_mayor_al_tope': defineMessage({
        id: 'inventarioSolicitudService.errors.cantidad_mayor_al_tope',
        defaultMessage: 'No podés despachar más de {tope} unidades de una vez.'
    }),
    'inventarioSolicitudService.errors.ubicacion_invalida': defineMessage({
        id: 'inventarioSolicitudService.errors.ubicacion_invalida',
        defaultMessage: 'El depósito seleccionado no es válido.'
    }),
    'inventarioSolicitudService.errors.origen_es_el_destino': defineMessage({
        id: 'inventarioSolicitudService.errors.origen_es_el_destino',
        defaultMessage: 'El depósito de origen no puede ser el mismo al que se le pidió el repuesto.'
    }),
    // Lleva `disponible` y `solicitado` en el context: el mensaje tiene que decir cuánto falta.
    'inventarioSolicitudService.errors.stock_insuficiente_en_origen': defineMessage({
        id: 'inventarioSolicitudService.errors.stock_insuficiente_en_origen',
        defaultMessage: 'El depósito de origen no tiene stock suficiente: hay {disponible} disponibles y se pidieron {solicitado}.'
    }),
    'inventarioSolicitudService.errors.motivo_requerido': defineMessage({
        id: 'inventarioSolicitudService.errors.motivo_requerido',
        defaultMessage: 'Indicá el motivo de la cancelación.'
    }),
    // VEC-3905 — alta y edición de una solicitud desde el ticket.
    //
    // La cantidad tiene claves PROPIAS y no reusa las del despacho: allá los mensajes dicen
    // "despachar", y el que pide no está despachando nada.
    'inventarioSolicitudService.errors.usuario_no_resuelto': defineMessage({
        id: 'inventarioSolicitudService.errors.usuario_no_resuelto',
        defaultMessage: 'No se pudo identificar al usuario que hace la solicitud. Volvé a iniciar sesión.'
    }),
    'inventarioSolicitudService.errors.ticket_no_solicitable': defineMessage({
        id: 'inventarioSolicitudService.errors.ticket_no_solicitable',
        defaultMessage: 'No se pueden pedir repuestos para un ticket cerrado o cancelado.'
    }),
    'inventarioSolicitudService.errors.detalles_requeridos': defineMessage({
        id: 'inventarioSolicitudService.errors.detalles_requeridos',
        defaultMessage: 'Indicá al menos un repuesto para solicitar.'
    }),
    'inventarioSolicitudService.errors.item_requerido': defineMessage({
        id: 'inventarioSolicitudService.errors.item_requerido',
        defaultMessage: 'Cada renglón de la solicitud tiene que indicar un repuesto.'
    }),
    // Lleva `item` en el context.
    'inventarioSolicitudService.errors.item_repetido': defineMessage({
        id: 'inventarioSolicitudService.errors.item_repetido',
        defaultMessage: 'Hay un repuesto repetido en la solicitud. Juntá las cantidades en un solo renglón.'
    }),
    // Lleva `item` en el context.
    'inventarioSolicitudService.errors.item_inactivo': defineMessage({
        id: 'inventarioSolicitudService.errors.item_inactivo',
        defaultMessage: 'Uno de los repuestos está dado de baja del catálogo y no se puede solicitar.'
    }),
    'inventarioSolicitudService.errors.ubicacion_no_resuelta': defineMessage({
        id: 'inventarioSolicitudService.errors.ubicacion_no_resuelta',
        defaultMessage: 'No se puede determinar a qué depósito pedirle: el vehículo del ticket no tiene una base asignada.'
    }),
    // Lleva `items` y `detalles` en el context: la pantalla usa el detalleId para ofrecer editarla.
    'inventarioSolicitudService.errors.ya_existe_pendiente': defineMessage({
        id: 'inventarioSolicitudService.errors.ya_existe_pendiente',
        defaultMessage: 'Ya hay una solicitud pendiente de ese repuesto para este ticket. Editá la cantidad de la existente o cancelala.'
    }),
    'inventarioSolicitudService.errors.cantidad_solicitada_invalida': defineMessage({
        id: 'inventarioSolicitudService.errors.cantidad_solicitada_invalida',
        defaultMessage: 'La cantidad a solicitar tiene que ser un número entero mayor a cero.'
    }),
    // Lleva el tope en el context.
    'inventarioSolicitudService.errors.cantidad_solicitada_mayor_al_tope': defineMessage({
        id: 'inventarioSolicitudService.errors.cantidad_solicitada_mayor_al_tope',
        defaultMessage: 'No podés solicitar más de {tope} unidades de una vez.'
    }),
    // Lleva `despachada` en el context.
    'inventarioSolicitudService.errors.cantidad_menor_a_lo_despachado': defineMessage({
        id: 'inventarioSolicitudService.errors.cantidad_menor_a_lo_despachado',
        defaultMessage: 'No podés pedir menos de lo que ya te entregaron ({despachada} unidades).'
    }),
    'inventarioSolicitudService.errors.ediciones_invalidas': defineMessage({
        id: 'inventarioSolicitudService.errors.ediciones_invalidas',
        defaultMessage: 'Los ajustes de cantidad no tienen el formato esperado.'
    }),
    // Lleva `detalle` en el context.
    'inventarioSolicitudService.errors.detalle_repetido': defineMessage({
        id: 'inventarioSolicitudService.errors.detalle_repetido',
        defaultMessage: 'Hay un repuesto ajustado dos veces en el mismo env\u00edo.'
    }),
    // Lleva `detalle` en el context.
    'inventarioSolicitudService.errors.detalle_de_otro_ticket': defineMessage({
        id: 'inventarioSolicitudService.errors.detalle_de_otro_ticket',
        defaultMessage: 'Una de las solicitudes que se intenta ajustar es de otro ticket.'
    }),
    'inventarioSolicitudService.errors.detalle_no_editable': defineMessage({
        id: 'inventarioSolicitudService.errors.detalle_no_editable',
        defaultMessage: 'La solicitud cambió mientras la editabas. Actualizá la pantalla y volvé a intentar.'
    }),
    'panol.items.errors.valor_supera_maximo': defineMessage({
        id: 'panol.items.errors.valor_supera_maximo',
        defaultMessage: 'El valor del ítem "{descripcion}" supera el máximo permitido ({max}).'
    }),
    'ticketsPresupuestos.errors.item_aprobado_no_eliminable': defineMessage({
        id: 'ticketsPresupuestos.errors.item_aprobado_no_eliminable',
        defaultMessage: "No se puede eliminar el ítem aprobado {descripcion} en una recotización parcial."
    }),
    'ticketsPresupuestos.errors.tarea_aprobada_no_eliminable': defineMessage({
        id: 'ticketsPresupuestos.errors.tarea_aprobada_no_eliminable',
        defaultMessage: "No se puede eliminar la tarea aprobada {descripcion} en una recotización parcial."
    }),
    'ticketsPresupuestos.errors.item_aprobado_no_modificable': defineMessage({
        id: 'ticketsPresupuestos.errors.item_aprobado_no_modificable',
        defaultMessage: "No se puede modificar el campo {campo} del ítem aprobado {descripcion} en una recotización parcial. Valor original: {valorOriginal}, valor enviado: {valorNuevo}."
    }),
    'ticketsPresupuestos.errors.tarea_aprobada_no_modificable': defineMessage({
        id: 'ticketsPresupuestos.errors.tarea_aprobada_no_modificable',
        defaultMessage: "No se puede modificar el campo {campo} de la tarea aprobada {descripcion} en una recotización parcial. Valor original: {valorOriginal}, valor enviado: {valorNuevo}."
    }),
    'ticketsPresupuestos.errors.presupuesto_no_encontrado': defineMessage({
        id: 'ticketsPresupuestos.errors.presupuesto_no_encontrado',
        defaultMessage: 'No se encontró el presupuesto con id {id}.'
    }),
    'ticketsPresupuestos.errors.presupuestos_distinto_ticket': defineMessage({
        id: 'ticketsPresupuestos.errors.presupuestos_distinto_ticket',
        defaultMessage: 'Los presupuestos indicados no pertenecen al mismo ticket.'
    }),
    'ticketsPresupuestos.errors.presupuesto_pendiente_ya_existe': defineMessage({
        id: 'ticketsPresupuestos.errors.presupuesto_pendiente_ya_existe',
        defaultMessage: "Ya existe un presupuesto con estado Pendiente, Pendiente-Auditor o Validado-Auditor para este ticket. Debe resolverse antes de crear uno nuevo."
    }),
    'ticketsDerivados.solo_correctivo': defineMessage({
        id: 'ticketsDerivados.solo_correctivo',
        defaultMessage: 'Solo se puede crear un ticket derivado desde tickets de tipo Correctivo'
    }),
    'ticketsDerivados.solo_presupuesto_simple': defineMessage({
        id: 'ticketsDerivados.solo_presupuesto_simple',
        defaultMessage: 'La creación de ticket derivado solo está disponible con presupuesto simple'
    }),
    'ticketsDerivados.tareas_cierre_deshabilitadas': defineMessage({
        id: 'ticketsDerivados.tareas_cierre_deshabilitadas',
        defaultMessage: 'La creación de ticket derivado requiere tareas de cierre habilitadas'
    }),
    'ticketsDerivados.titulo_obligatorio': defineMessage({
        id: 'ticketsDerivados.titulo_obligatorio',
        defaultMessage: 'El título del ticket derivado no puede estar vacío'
    }),
    'ticketsDerivados.seleccion_vacia': defineMessage({
        id: 'ticketsDerivados.seleccion_vacia',
        defaultMessage: 'Debés seleccionar al menos un ítem o una tarea'
    }),
    'ticketsDerivados.servicio_obligatorio': defineMessage({
        id: 'ticketsDerivados.servicio_obligatorio',
        defaultMessage: 'Debés seleccionar el servicio del ticket derivado'
    }),
    'ticketsDerivados.servicio_no_corresponde': defineMessage({
        id: 'ticketsDerivados.servicio_no_corresponde',
        defaultMessage: 'El servicio seleccionado no corresponde a los ítems o tareas elegidos'
    }),
    'ticketsDerivados.limite_alcanzado': defineMessage({
        id: 'ticketsDerivados.limite_alcanzado',
        defaultMessage: 'No se puede crear el ticket derivado: el móvil {entidadName} ya alcanzó el límite de {limite} ticket(s) activo(s) para el servicio {servicio}'
    }),
    // VEC-3715 — sub-módulo de Programación de Preventivos, habilitable por cliente.
    'programasPreventivoService.errors.modulo_no_habilitado': defineMessage({
        id: 'programasPreventivoService.errors.modulo_no_habilitado',
        defaultMessage: 'El módulo de Programación de Preventivos no está habilitado.'
    }),
    'programasPreventivoService.errors.nombre_obligatorio': defineMessage({
        id: 'programasPreventivoService.errors.nombre_obligatorio',
        defaultMessage: 'El nombre del programa es obligatorio.'
    }),
    'programasPreventivoService.errors.nombre_ya_utilizado': defineMessage({
        id: 'programasPreventivoService.errors.nombre_ya_utilizado',
        defaultMessage: 'Ya existe un programa con ese nombre.'
    }),
    'programasPreventivoService.errors.fecha_inicio_obligatoria': defineMessage({
        id: 'programasPreventivoService.errors.fecha_inicio_obligatoria',
        defaultMessage: 'La fecha de inicio es obligatoria.'
    }),
    'programasPreventivoService.errors.fecha_fin_obligatoria': defineMessage({
        id: 'programasPreventivoService.errors.fecha_fin_obligatoria',
        defaultMessage: 'La fecha de fin es obligatoria.'
    }),
    'programasPreventivoService.errors.fecha_fin_anterior_a_inicio': defineMessage({
        id: 'programasPreventivoService.errors.fecha_fin_anterior_a_inicio',
        defaultMessage: 'La fecha de fin no puede ser anterior a la fecha de inicio.'
    }),
    'programasPreventivoService.errors.fecha_limite_no_posterior_a_inicio': defineMessage({
        id: 'programasPreventivoService.errors.fecha_limite_no_posterior_a_inicio',
        defaultMessage: 'La fecha de publicación debe ser posterior a la fecha de inicio.'
    }),
    'programasPreventivoService.errors.solapamiento_con_tipo': defineMessage({
        id: 'programasPreventivoService.errors.solapamiento_con_tipo',
        defaultMessage: 'El período se superpone con el programa "{programa}", que ya incluye el tipo de vehículo {tipos}.'
    }),
    'programasPreventivoService.errors.tipos_obligatorio': defineMessage({
        id: 'programasPreventivoService.errors.tipos_obligatorio',
        defaultMessage: 'Debe seleccionar al menos un tipo de vehículo.'
    }),
    'programasPreventivoService.errors.programa_no_encontrado': defineMessage({
        id: 'programasPreventivoService.errors.programa_no_encontrado',
        defaultMessage: 'Programa no encontrado.'
    }),
    'programasPreventivoService.errors.vehiculo_no_encontrado': defineMessage({
        id: 'programasPreventivoService.errors.vehiculo_no_encontrado',
        defaultMessage: 'Vehículo no encontrado.'
    }),
    'programasPreventivoService.errors.programa_no_editable': defineMessage({
        id: 'programasPreventivoService.errors.programa_no_editable',
        defaultMessage: 'El programa no admite cambios en este estado.'
    }),
    'programasPreventivoService.errors.nombre_invalido': defineMessage({
        id: 'programasPreventivoService.errors.nombre_invalido',
        defaultMessage: 'El nombre del programa no es válido.'
    }),
    'programasPreventivoService.errors.fecha_inicio_invalida': defineMessage({
        id: 'programasPreventivoService.errors.fecha_inicio_invalida',
        defaultMessage: 'La fecha de inicio no tiene un formato válido.'
    }),
    'programasPreventivoService.errors.fecha_fin_invalida': defineMessage({
        id: 'programasPreventivoService.errors.fecha_fin_invalida',
        defaultMessage: 'La fecha de fin no tiene un formato válido.'
    }),
    'programasPreventivoService.errors.fecha_inicio_no_posterior_a_hoy': defineMessage({
        id: 'programasPreventivoService.errors.fecha_inicio_no_posterior_a_hoy',
        defaultMessage: 'La fecha de inicio debe ser a partir de mañana.'
    }),
    'programasPreventivoService.errors.fecha_limite_obligatoria': defineMessage({
        id: 'programasPreventivoService.errors.fecha_limite_obligatoria',
        defaultMessage: 'La fecha de publicación es obligatoria.'
    }),
    'programasPreventivoService.errors.fecha_limite_no_anterior_a_fin': defineMessage({
        id: 'programasPreventivoService.errors.fecha_limite_no_anterior_a_fin',
        defaultMessage: 'La fecha de publicación debe ser anterior a la fecha de fin.'
    }),
    'programasPreventivoService.errors.fecha_limite_invalida': defineMessage({
        id: 'programasPreventivoService.errors.fecha_limite_invalida',
        defaultMessage: 'La fecha de publicación no tiene un formato válido.'
    }),
    'programasPreventivoService.errors.tipos_invalidos': defineMessage({
        id: 'programasPreventivoService.errors.tipos_invalidos',
        defaultMessage: 'Los tipos de vehículo enviados no son válidos.'
    }),
    'programasPreventivoService.errors.programa_no_editable_estado_actual': defineMessage({
        id: 'programasPreventivoService.errors.programa_no_editable_estado_actual',
        defaultMessage: 'El programa ya no puede editarse en su estado actual: solo se pueden editar programas en Borrador cuyo período operativo todavía no comenzó.'
    }),
    'programasPreventivoService.errors.programa_no_eliminable': defineMessage({
        id: 'programasPreventivoService.errors.programa_no_eliminable',
        defaultMessage: 'El programa ya no puede eliminarse en su estado actual: solo se pueden eliminar programas en Borrador cuyo período operativo todavía no comenzó.'
    }),
    'programasPreventivoService.errors.grilla_no_generable': defineMessage({
        id: 'programasPreventivoService.errors.grilla_no_generable',
        defaultMessage: 'La grilla solo se puede generar o regenerar desde el estado Borrador.'
    }),
    'solicitudService.errors.ticket_invalido': defineMessage({
        id: 'solicitudService.errors.ticket_invalido',
        defaultMessage: "El ticket indicado no existe o no es un correctivo."
    }),
    'solicitudService.errors.movil_no_coincide': defineMessage({
        id: 'solicitudService.errors.movil_no_coincide',
        defaultMessage: "El ticket no corresponde al vehículo de la solicitud ni a uno de sus activos vinculados."
    }),
    'solicitudService.errors.ticket_ya_vinculado': defineMessage({
        id: 'solicitudService.errors.ticket_ya_vinculado',
        defaultMessage: "El ticket ya está vinculado a otra solicitud."
    }),
    'solicitudService.errors.usuario_invalido': defineMessage({
        id: 'solicitudService.errors.usuario_invalido',
        defaultMessage: "No se pudo identificar al usuario. Ingrese nuevamente."
    }),
    'solicitudService.errors.modulo_no_habilitado': defineMessage({
        id: 'solicitudService.errors.modulo_no_habilitado',
        defaultMessage: "El módulo de Solicitudes no está habilitado."
    }),
    'solicitudService.errors.movil_inexistente': defineMessage({
        id: 'solicitudService.errors.movil_inexistente',
        defaultMessage: "El vehículo seleccionado no existe."
    }),
    'solicitudService.errors.inmovilizado_requerido': defineMessage({
        id: 'solicitudService.errors.inmovilizado_requerido',
        defaultMessage: "Debe indicar si el vehículo está paralizado."
    }),
    'solicitudService.errors.adjunto_invalido': defineMessage({
        id: 'solicitudService.errors.adjunto_invalido',
        defaultMessage: "Uno de los archivos adjuntos no existe."
    }),
    'solicitudService.errors.fecha_hora_turno_invalida': defineMessage({
        id: 'solicitudService.errors.fecha_hora_turno_invalida',
        defaultMessage: "La fecha de turno no es válida."
    }),
    'solicitudService.errors.solicitud_no_pendiente': defineMessage({
        id: 'solicitudService.errors.solicitud_no_pendiente',
        defaultMessage: "La solicitud ya no está pendiente."
    }),
    'solicitudService.errors.cancelar_solo_creador': defineMessage({
        id: 'solicitudService.errors.cancelar_solo_creador',
        defaultMessage: "Solo el usuario que creó la solicitud puede cancelarla."
    }),
    'solicitudService.errors.maximo_adjuntos': defineMessage({
        id: 'solicitudService.errors.maximo_adjuntos',
        defaultMessage: "La solicitud admite como máximo 3 archivos adjuntos."
    }),
    'solicitudService.errors.motivo_rechazo_invalido': defineMessage({
        id: 'solicitudService.errors.motivo_rechazo_invalido',
        defaultMessage: "El motivo de rechazo no es válido."
    }),
    'programasPreventivoService.errors.motivo_exclusion_invalido': defineMessage({
        id: 'programasPreventivoService.errors.motivo_exclusion_invalido',
        defaultMessage: 'El motivo de exclusión seleccionado no es válido.'
    }),
    'programasPreventivoService.errors.comentario_obligatorio_motivo_otro': defineMessage({
        id: 'programasPreventivoService.errors.comentario_obligatorio_motivo_otro',
        defaultMessage: 'El comentario es obligatorio para el motivo "Otro".'
    }),
    'programasPreventivoService.errors.vehiculo_ya_excluido': defineMessage({
        id: 'programasPreventivoService.errors.vehiculo_ya_excluido',
        defaultMessage: 'El vehículo ya está excluido del programa.'
    }),
    'programasPreventivoService.errors.vehiculo_ya_incluido': defineMessage({
        id: 'programasPreventivoService.errors.vehiculo_ya_incluido',
        defaultMessage: 'El vehículo ya está incluido en el programa.'
    }),
    'programasPreventivoService.errors.fecha_sugerida_invalida': defineMessage({
        id: 'programasPreventivoService.errors.fecha_sugerida_invalida',
        defaultMessage: 'La fecha ingresada no es válida.'
    }),
    'programasPreventivoService.errors.vehiculo_excluido_no_editable': defineMessage({
        id: 'programasPreventivoService.errors.vehiculo_excluido_no_editable',
        defaultMessage: 'No se puede editar la fecha de un vehículo excluido.'
    }),
    'periodoRegla.errors.periodos_config_id_requerido': defineMessage({
        id: 'periodoRegla.errors.periodos_config_id_requerido',
        defaultMessage: 'Debe indicar la configuración de período.'
    }),
    'periodoRegla.errors.nombre_requerido': defineMessage({
        id: 'periodoRegla.errors.nombre_requerido',
        defaultMessage: 'El nombre es requerido.'
    }),
    'periodoRegla.errors.porcentaje_requerido': defineMessage({
        id: 'periodoRegla.errors.porcentaje_requerido',
        defaultMessage: 'El porcentaje es requerido.'
    }),
    'periodoRegla.errors.porcentaje_invalido': defineMessage({
        id: 'periodoRegla.errors.porcentaje_invalido',
        defaultMessage: 'Ingresá un valor entero entre 1 y 100.'
    }),
    'periodoRegla.errors.accion_requerida': defineMessage({
        id: 'periodoRegla.errors.accion_requerida',
        defaultMessage: 'Seleccioná al menos una acción.'
    }),
    'periodoRegla.errors.ya_existe_regla_bloqueo_activa': defineMessage({
        id: 'periodoRegla.errors.ya_existe_regla_bloqueo_activa',
        defaultMessage: 'Ya existe una regla de bloqueo activa para esta configuración. Desactivala antes de activar otra.'
    }),
    'validacionGranular.errors.item_incompleto': defineMessage({
        id: 'validacionGranular.errors.item_incompleto',
        defaultMessage: 'Falta información del ítem a validar.'
    }),
    'validacionGranular.errors.decision_invalida': defineMessage({
        id: 'validacionGranular.errors.decision_invalida',
        defaultMessage: 'La decisión ingresada no es válida.'
    }),
    'validacionGranular.errors.motivo_obligatorio': defineMessage({
        id: 'validacionGranular.errors.motivo_obligatorio',
        defaultMessage: 'El motivo es obligatorio para rechazar un ítem.'
    }),
    'validacionGranular.errors.motivo_muy_largo': defineMessage({
        id: 'validacionGranular.errors.motivo_muy_largo',
        defaultMessage: 'El motivo no puede superar los 240 caracteres.'
    }),
    // VEC-3312 — Catálogo de ítems del módulo de Inventario v3.0.
    'inventarioItemService.errors.modulo_no_habilitado': defineMessage({
        id: 'inventarioItemService.errors.modulo_no_habilitado',
        defaultMessage: 'El módulo de Inventario no está habilitado.'
    }),
    'inventarioItemService.errors.item_no_encontrado': defineMessage({
        id: 'inventarioItemService.errors.item_no_encontrado',
        defaultMessage: 'El ítem no fue encontrado.'
    }),
    'inventarioItemService.errors.sin_permiso_desactivar': defineMessage({
        id: 'inventarioItemService.errors.sin_permiso_desactivar',
        defaultMessage: 'No tiene permiso para cambiar el estado del ítem.'
    }),
    'inventarioItemService.errors.numero_de_parte_requerido': defineMessage({
        id: 'inventarioItemService.errors.numero_de_parte_requerido',
        defaultMessage: 'El número de parte es requerido.'
    }),
    'inventarioItemService.errors.numero_de_parte_duplicado': defineMessage({
        id: 'inventarioItemService.errors.numero_de_parte_duplicado',
        defaultMessage: 'Ya existe un ítem con ese número de parte.'
    }),
    'inventarioItemService.errors.descripcion_requerida': defineMessage({
        id: 'inventarioItemService.errors.descripcion_requerida',
        defaultMessage: 'La descripción es requerida.'
    }),
    'inventarioItemService.errors.categoria_requerida': defineMessage({
        id: 'inventarioItemService.errors.categoria_requerida',
        defaultMessage: 'La categoría es requerida.'
    }),
    'inventarioItemService.errors.subcategoria_requerida': defineMessage({
        id: 'inventarioItemService.errors.subcategoria_requerida',
        defaultMessage: 'La subcategoría es requerida.'
    }),
    'inventarioItemService.errors.unidad_requerida': defineMessage({
        id: 'inventarioItemService.errors.unidad_requerida',
        defaultMessage: 'La unidad de medida es requerida.'
    }),
    'inventarioItemService.errors.stock_minimo_requerido': defineMessage({
        id: 'inventarioItemService.errors.stock_minimo_requerido',
        defaultMessage: 'El stock mínimo es requerido.'
    }),
    'inventarioItemService.errors.stock_minimo_invalido': defineMessage({
        id: 'inventarioItemService.errors.stock_minimo_invalido',
        defaultMessage: 'El stock mínimo debe ser un número mayor o igual a cero.'
    }),
    'inventarioItemService.errors.costo_invalido': defineMessage({
        id: 'inventarioItemService.errors.costo_invalido',
        defaultMessage: 'El costo debe ser un número mayor o igual a cero.'
    }),
    'inventarioItemImport.errors.no_se_recibio_ningun_archivo': defineMessage({
        id: 'inventarioItemImport.errors.no_se_recibio_ningun_archivo',
        defaultMessage: 'No se recibió ningún archivo.'
    }),
    'inventarioItemImport.errors.error_al_subir_el_archivo': defineMessage({
        id: 'inventarioItemImport.errors.error_al_subir_el_archivo',
        defaultMessage: 'Hubo un error al subir el archivo.'
    }),
    'inventarioItemImport.errors.error_al_leer_el_excel': defineMessage({
        id: 'inventarioItemImport.errors.error_al_leer_el_excel',
        defaultMessage: 'No se pudo leer el Excel. Verifique que sea un archivo .xlsx o .xls válido.'
    }),
    'inventarioItemImport.errors.el_excel_no_contiene_filas': defineMessage({
        id: 'inventarioItemImport.errors.el_excel_no_contiene_filas',
        defaultMessage: 'El Excel no contiene filas para importar. Los datos deben empezar en la fila 3.'
    }),
    'inventarioItemImport.errors.faltan_columnas_obligatorias': defineMessage({
        id: 'inventarioItemImport.errors.faltan_columnas_obligatorias',
        defaultMessage: 'Faltan columnas obligatorias en el archivo. Descargue la plantilla y vuelva a intentar.'
    }),
    'inventarioItemImport.errors.error_desconocido': defineMessage({
        id: 'inventarioItemImport.errors.error_desconocido',
        defaultMessage: 'Ocurrió un error desconocido al importar la fila.'
    }),
    'disponibilidadActiva.motivo.plazoVencido': defineMessage({
        id: 'disponibilidadActiva.motivo.plazoVencido',
        defaultMessage: 'El plazo de 2 días para justificar esta ociosidad venció.'
    }),
    // VEC-3894: fecha_retorno de Disponibilidad Activa (dato informativo, sin relación con
    // el motivo) — formato inválido o anterior a la fecha de inicio de la ociosidad.
    'disponibilidadActiva.fechaRetorno.invalida': defineMessage({
        id: 'disponibilidadActiva.fechaRetorno.invalida',
        defaultMessage: 'La fecha de retorno no es válida: no puede ser anterior a la fecha de inicio de la ociosidad ({fechaInicioOciosidad}).'
    }),
    // VEC-3432 — Catálogo de Mano de Obra del módulo de Inventario v3.0.
    'inventarioManoObraService.errors.modulo_no_habilitado': defineMessage({
        id: 'inventarioManoObraService.errors.modulo_no_habilitado',
        defaultMessage: 'El módulo de Inventario no está habilitado.'
    }),
    'inventarioManoObraService.errors.sin_permiso_desactivar': defineMessage({
        id: 'inventarioManoObraService.errors.sin_permiso_desactivar',
        defaultMessage: 'No tiene permiso para cambiar el estado del ítem de mano de obra.'
    }),
    'inventarioManoObraService.errors.numero_de_parte_requerido': defineMessage({
        id: 'inventarioManoObraService.errors.numero_de_parte_requerido',
        defaultMessage: 'El número de parte es requerido.'
    }),
    'inventarioManoObraService.errors.numero_de_parte_duplicado': defineMessage({
        id: 'inventarioManoObraService.errors.numero_de_parte_duplicado',
        defaultMessage: 'Ya existe un ítem de mano de obra con ese número de parte.'
    }),
    'inventarioManoObraService.errors.descripcion_requerida': defineMessage({
        id: 'inventarioManoObraService.errors.descripcion_requerida',
        defaultMessage: 'La descripción es requerida.'
    }),
    'inventarioManoObraService.errors.categoria_requerida': defineMessage({
        id: 'inventarioManoObraService.errors.categoria_requerida',
        defaultMessage: 'La categoría es requerida.'
    }),
    'inventarioManoObraService.errors.subcategoria_requerida': defineMessage({
        id: 'inventarioManoObraService.errors.subcategoria_requerida',
        defaultMessage: 'La subcategoría es requerida.'
    }),
    'inventarioManoObraService.errors.costo_invalido': defineMessage({
        id: 'inventarioManoObraService.errors.costo_invalido',
        defaultMessage: 'El costo debe ser un número mayor o igual a cero.'
    }),
    'inventarioManoObraImport.errors.no_se_recibio_ningun_archivo': defineMessage({
        id: 'inventarioManoObraImport.errors.no_se_recibio_ningun_archivo',
        defaultMessage: 'No se recibió ningún archivo.'
    }),
    'inventarioManoObraImport.errors.error_al_subir_el_archivo': defineMessage({
        id: 'inventarioManoObraImport.errors.error_al_subir_el_archivo',
        defaultMessage: 'Hubo un error al subir el archivo.'
    }),
    'inventarioManoObraImport.errors.error_al_leer_el_excel': defineMessage({
        id: 'inventarioManoObraImport.errors.error_al_leer_el_excel',
        defaultMessage: 'No se pudo leer el Excel. Verifique que sea un archivo .xlsx o .xls válido.'
    }),
    'inventarioManoObraImport.errors.el_excel_no_contiene_filas': defineMessage({
        id: 'inventarioManoObraImport.errors.el_excel_no_contiene_filas',
        defaultMessage: 'El Excel no contiene filas para importar. Los datos deben empezar en la fila 3.'
    }),
    'inventarioManoObraImport.errors.faltan_columnas_obligatorias': defineMessage({
        id: 'inventarioManoObraImport.errors.faltan_columnas_obligatorias',
        defaultMessage: 'Faltan columnas obligatorias en el archivo. Descargue la plantilla y vuelva a intentar.'
    }),
    'inventarioManoObraImport.errors.error_desconocido': defineMessage({
        id: 'inventarioManoObraImport.errors.error_desconocido',
        defaultMessage: 'Ocurrió un error desconocido al importar la fila.'
    }),
    // VEC-3313 / VEC-3314 — Stock por depósito e ingresos del módulo de Inventario v3.0.
    //
    // ⚠️ FALTABAN TODAS. Se agregan al implementar VEC-3316, no porque sean de esta card, sino
    // porque el módulo mostraría mensajes correctos en la pantalla de reservas y la CLAVE CRUDA en
    // la de ingresos: `Utils.js` (getBackendMessage) devuelve `e` tal cual cuando no encuentra el
    // descriptor, así que hoy el Swal del formulario de ingreso dice literalmente
    // "inventarioStockService.errors.cantidad_fuera_de_rango".
    //
    // ⚠️ DOS DE ESTAS CLAVES NO APARECEN COMO LITERAL EN EL BACKEND: `fecha_desde_invalida` y
    // `fecha_hasta_invalida` se arman por concatenación en ItemStockService::fechaFiltro()
    // ('inventarioStockService.errors.' . $claveError). Un grep del prefijo completo no las
    // encuentra — si se agrega otra clave por ese camino, hay que sumarla acá a mano.
    //
    // `costo_fuera_de_rango` NO va en este bloque: la agregó VEC-3781 más arriba en el archivo.
    'inventarioStockService.errors.modulo_no_habilitado': defineMessage({
        id: 'inventarioStockService.errors.modulo_no_habilitado',
        defaultMessage: 'El módulo de Inventario no está habilitado.'
    }),
    'inventarioStockService.errors.usuario_no_resuelto': defineMessage({
        id: 'inventarioStockService.errors.usuario_no_resuelto',
        defaultMessage: 'No se pudo identificar al usuario de la sesión. Vuelva a iniciar sesión e intente nuevamente.'
    }),
    'inventarioStockService.errors.item_inactivo': defineMessage({
        id: 'inventarioStockService.errors.item_inactivo',
        defaultMessage: 'El ítem está dado de baja y no se puede ingresar stock.'
    }),
    'inventarioStockService.errors.cantidad_invalida': defineMessage({
        id: 'inventarioStockService.errors.cantidad_invalida',
        defaultMessage: 'La cantidad debe ser un número entero de unidades de stock.'
    }),
    'inventarioStockService.errors.cantidad_fuera_de_rango': defineMessage({
        id: 'inventarioStockService.errors.cantidad_fuera_de_rango',
        defaultMessage: 'La cantidad debe estar entre 1 y 1000 unidades de stock.'
    }),
    // Se acepta 0 (donación, garantía): lo que se rechaza es un negativo o algo que no es número.
    'inventarioStockService.errors.costo_invalido': defineMessage({
        id: 'inventarioStockService.errors.costo_invalido',
        defaultMessage: 'El costo unitario debe ser un número mayor o igual a cero.'
    }),
    'inventarioStockService.errors.fecha_requerida': defineMessage({
        id: 'inventarioStockService.errors.fecha_requerida',
        defaultMessage: 'La fecha es requerida.'
    }),
    'inventarioStockService.errors.fecha_invalida': defineMessage({
        id: 'inventarioStockService.errors.fecha_invalida',
        defaultMessage: 'La fecha debe tener el formato AAAA-MM-DD.'
    }),
    'inventarioStockService.errors.fecha_desde_invalida': defineMessage({
        id: 'inventarioStockService.errors.fecha_desde_invalida',
        defaultMessage: 'La fecha "desde" debe tener el formato AAAA-MM-DD.'
    }),
    'inventarioStockService.errors.fecha_hasta_invalida': defineMessage({
        id: 'inventarioStockService.errors.fecha_hasta_invalida',
        defaultMessage: 'La fecha "hasta" debe tener el formato AAAA-MM-DD.'
    }),
    // El backend rechaza el rango invertido en vez de darlo vuelta en silencio: siempre es un error
    // de quien consulta, y corregirlo solo esconde el problema.
    'inventarioStockService.errors.rango_de_fechas_invertido': defineMessage({
        id: 'inventarioStockService.errors.rango_de_fechas_invertido',
        defaultMessage: 'La fecha "desde" no puede ser posterior a la fecha "hasta".'
    }),
    'inventarioStockService.errors.ubicacion_destino_requerida': defineMessage({
        id: 'inventarioStockService.errors.ubicacion_destino_requerida',
        defaultMessage: 'Debe indicar el depósito de destino.'
    }),
    'inventarioStockService.errors.ubicacion_incompleta': defineMessage({
        id: 'inventarioStockService.errors.ubicacion_incompleta',
        defaultMessage: 'El depósito indicado está incompleto.'
    }),
    'inventarioStockService.errors.ubicacion_tipo_invalido': defineMessage({
        id: 'inventarioStockService.errors.ubicacion_tipo_invalido',
        defaultMessage: 'El tipo de ubicación indicado no es válido.'
    }),
    // VEC-3316 — Reservas de repuestos asociadas a tickets (módulo de Inventario v3.0).
    //
    // Sin estas claves el usuario ve la clave CRUDA en pantalla: Utils.js:138 devuelve `e` tal cual
    // cuando no encuentra el descriptor. No es un fallback amable, es texto interno filtrado a la UI.
    //
    // Ninguna lleva valores interpolados, y no es una simplificación: el pipeline de errores del
    // backend transporta CLAVES de traducción, no datos. El handler de Public/App.php responde
    // `ApiError(4000, $exception->getDetalle())`, que es un array de strings, y BadRequestException
    // recibe un solo argumento. Por eso "stock insuficiente" no puede decir cuántos hay disponibles.
    'inventarioReservaService.errors.modulo_no_habilitado': defineMessage({
        id: 'inventarioReservaService.errors.modulo_no_habilitado',
        defaultMessage: 'El módulo de Inventario no está habilitado.'
    }),
    'inventarioReservaService.errors.usuario_no_resuelto': defineMessage({
        id: 'inventarioReservaService.errors.usuario_no_resuelto',
        defaultMessage: 'No se pudo identificar al usuario de la sesión. Vuelva a iniciar sesión e intente nuevamente.'
    }),
    // Scenario 02. La clave es propia y no comparte texto con otros errores de stock: VEC-3319 la va
    // a usar para ofrecer generar una Orden de Compra justo en este caso.
    // VEC-3316 — gate de la aprobación: no se aprueba un presupuesto sin stock cubierto.
    'ticketsPresupuestosService.errors.stock_insuficiente_para_aprobar': defineMessage({
        id: 'ticketsPresupuestosService.errors.stock_insuficiente_para_aprobar',
        defaultMessage: 'No se puede aprobar el presupuesto: no hay stock suficiente en el depósito del móvil para todos los repuestos. Conseguí el stock o sacá los repuestos que faltan del presupuesto.'
    }),
    // VEC-3316 — gate de la CREACIÓN: presupuestar reserva, así que no se puede presupuestar lo que
    // no se puede reservar. Clave propia y no la de aprobar: el front la usa para distinguir el
    // caso, y VEC-3317 se va a colgar de ella cuando la solicitud de stock se persista.
    'ticketsPresupuestosService.errors.stock_insuficiente_para_presupuestar': defineMessage({
        id: 'ticketsPresupuestosService.errors.stock_insuficiente_para_presupuestar',
        defaultMessage: 'No se puede guardar el presupuesto: no hay stock suficiente en el depósito del móvil para reservar todos los repuestos. Generá la solicitud de stock o sacá del presupuesto los repuestos que faltan.'
    }),
    // VEC-3316 — tope de ítems por consulta en GET /items/stock-disponible.
    'itemController.errors.demasiados_items': defineMessage({
        id: 'itemController.errors.demasiados_items',
        defaultMessage: 'Se consultó el stock de demasiados ítems a la vez.'
    }),
    'inventarioReservaService.errors.stock_insuficiente': defineMessage({
        id: 'inventarioReservaService.errors.stock_insuficiente',
        defaultMessage: 'No hay stock disponible suficiente en el depósito seleccionado para la cantidad solicitada.'
    }),
    // VEC-3316 pre-commit F2 — la aprobación intentó completar el faltante y no alcanzó: otro
    // ticket se llevó el stock entre el gate y la escritura. Clave propia: no comparte texto con
    // `stock_insuficiente` (Sc. 02, reservada para VEC-3319) ni con
    // `ticketsPresupuestosService.errors.stock_insuficiente_para_aprobar` (el gate previo, de otra
    // clase). Hoy el único call site de producción traga esta excepción y solo la loguea, así que
    // este mensaje no llega a mostrarse en pantalla — se documenta igual para cuando alguien la
    // capture desde otro lado.
    'inventarioReservaService.errors.stock_insuficiente_al_utilizar': defineMessage({
        id: 'inventarioReservaService.errors.stock_insuficiente_al_utilizar',
        defaultMessage: 'No se pudo completar el stock reservado para aprobar este presupuesto: el faltante ya no está disponible en el depósito.'
    }),
    'inventarioReservaService.errors.ticket_no_reservable': defineMessage({
        id: 'inventarioReservaService.errors.ticket_no_reservable',
        defaultMessage: 'No se pueden reservar repuestos en un ticket cerrado o cancelado.'
    }),
    'inventarioReservaService.errors.ticket_sin_presupuesto': defineMessage({
        id: 'inventarioReservaService.errors.ticket_sin_presupuesto',
        defaultMessage: 'El ticket todavía no tiene un presupuesto, así que no se pueden reservar repuestos.'
    }),
    'inventarioReservaService.errors.reserva_no_liberable': defineMessage({
        id: 'inventarioReservaService.errors.reserva_no_liberable',
        defaultMessage: 'La reserva ya no está comprometida, así que no se puede liberar.'
    }),
    'inventarioReservaService.errors.item_inactivo': defineMessage({
        id: 'inventarioReservaService.errors.item_inactivo',
        defaultMessage: 'El ítem está dado de baja y no se puede reservar.'
    }),
    'inventarioReservaService.errors.cantidad_invalida': defineMessage({
        id: 'inventarioReservaService.errors.cantidad_invalida',
        defaultMessage: 'La cantidad debe ser un número entero de unidades de stock.'
    }),
    // El tope se nombra en el texto a propósito: "fuera de rango" sin el rango no le dice al usuario
    // qué corregir. Si el tope cambia, este mensaje es uno de los cuatro lugares a actualizar —
    // ItemStockReservaValidation::TOPE_CANTIDAD_RESERVA es la fuente, y los otros dos son el Service
    // y la doc de OpenAPI.
    'inventarioReservaService.errors.cantidad_fuera_de_rango': defineMessage({
        id: 'inventarioReservaService.errors.cantidad_fuera_de_rango',
        defaultMessage: 'La cantidad debe estar entre 1 y 1000 unidades de stock.'
    }),
    'inventarioReservaService.errors.ubicacion_requerida': defineMessage({
        id: 'inventarioReservaService.errors.ubicacion_requerida',
        defaultMessage: 'Debe indicar el depósito del que se reserva.'
    }),
    'inventarioReservaService.errors.ubicacion_incompleta': defineMessage({
        id: 'inventarioReservaService.errors.ubicacion_incompleta',
        defaultMessage: 'El depósito indicado está incompleto.'
    }),
    'inventarioReservaService.errors.ubicacion_tipo_invalido': defineMessage({
        id: 'inventarioReservaService.errors.ubicacion_tipo_invalido',
        defaultMessage: 'El tipo de ubicación indicado no es válido.'
    }),
    'movilesService.errors.odometro_deja_llantas_en_cero': defineMessage({
        id: 'movilesService.errors.odometro_deja_llantas_en_cero',
        defaultMessage: 'No se puede guardar: las llantas {llantas} quedarían con odómetro negativo.'
    }),
    'movilesService.errors.odometro_supera_tolerancia': defineMessage({
        id: 'movilesService.errors.odometro_supera_tolerancia',
        defaultMessage: 'No se puede guardar: la diferencia de odómetro supera la tolerancia de {tolerancia} km.'
    })
}